'use strict';

(function () {
    'use strict';

    angular.module('braininstituteApp', ['LocalStorageModule', 'tmh.dynamicLocale', 'pascalprecht.translate', 'ngResource', 'ui.router', 'ngCookies', 'ngCacheBuster', 'ngCacheBuster', 'infinite-scroll', 'ngMaterial', 'ngMessages', 'ivh.treeview', 'tcincCommon', 'ngMask', 'spring-data-rest', 'tekstackSecurity', 'angular-cache', 'md.data.table', 'dibari.angular-ellipsis', 'angular-q-extras', 'ngFileUpload', 'ngIdle', 'templates']);
})();
'use strict';

angular.module('braininstituteApp').factory('SiteLocation', function ($resource, $http, EntitiesUtil) {
    var resourceUri = '/api/siteLocations';
    var searchResourceUri = resourceUri + '/search';

    return {
        resource: $resource(resourceUri, {}, { query: { method: 'GET', isArray: false, cache: true } }),
        getAll: function getAll() {
            return EntitiesUtil.data(resourceUri);
        },
        getSiteLocation: getSiteLocation
    };

    // for use in Document page because I don't  want to change the other field in the common form.
    function getSiteLocation(id) {
        return $http.get(resourceUri + '/' + id).then(function (data) {
            return data.data;
        });
    }
});
'use strict';

angular.module('braininstituteApp').factory('SiteLocationSearch', function ($resource) {
    return $resource('/api/siteLocationsSearch/:query');
});
'use strict';

angular.module('braininstituteApp').factory('SampleType', function ($resource, EntitiesUtil) {

    var resourceUri = '/api/sampleTypes';
    var searchResourceUri = resourceUri + '/search';

    return {
        resource: $resource(resourceUri, { 'query': { method: 'GET', isArray: false, cache: true } }),
        topLevel: function topLevel(projection) {
            return EntitiesUtil.processDataPromise($resource(searchResourceUri + '/topLevel', {}, { 'query': { method: 'GET', isArray: false, cache: true } }).query({ projection: projection }).$promise);
        },
        children: function children(url, projection) {
            return EntitiesUtil.data(url, projection, { cache: true });
        }
    };
});
'use strict';

angular.module('braininstituteApp').factory('SampleTypeSearch', function ($resource) {
    return $resource('/api/sampleTypesSearch/:query');
});
'use strict';

angular.module('braininstituteApp').factory('SampleRequest', function ($resource, DateUtils) {
    return $resource('/api/sampleRequests/:id', {}, {
        get: {
            method: 'GET',
            transformResponse: function transformResponse(data) {
                data = angular.fromJson(data);
                return data;
            }
        }
    });
});
'use strict';

angular.module('braininstituteApp').factory('SampleRequestSearch', function ($resource) {
    return {
        forUser: $resource('/api/sampleRequests/search/forUser?projection=requestView'),
        forAdmin: $resource('/api/sampleRequests/search/forAdmin?projection=requestView')
    };
});
'use strict';

angular.module('braininstituteApp').factory('SampleInfo', function ($resource, EntitiesUtil) {
    var resourceUri = '/api/samples';
    var searchResourceUri = resourceUri + '/search';

    return {
        resource: $resource(resourceUri),

        create: function create(data) {
            return EntitiesUtil.create(this.resource, data);
        },

        topByPatientCode: function topByPatientCode(patientCode, projection) {
            return EntitiesUtil.data(searchResourceUri + '/topByPatientCode', projection, { patientCode: patientCode });
        },
        topByPatientCodeAndSiteLocation: function topByPatientCodeAndSiteLocation(patientCode, siteLocation, projection) {
            return EntitiesUtil.data(searchResourceUri + '/topByPatientCodeAndSiteLocation', projection, {
                patientCode: patientCode,
                siteLocation: siteLocation
            });
        }
    };
});
'use strict';

angular.module('braininstituteApp').factory('SampleInfoSearch', function ($resource) {
    return $resource('/api/samplesSearch/:query');
});
'use strict';

angular.module('braininstituteApp').factory('RequestStatus', function ($resource, DateUtils) {

    var resourceUri = '/api/requestStatuses';
    var searchResourceUri = resourceUri + '/search';

    return {
        resource: $resource(resourceUri + "/:id", {}, { 'query': { method: 'GET', isArray: false, cache: true } })
    };
});
'use strict';

angular.module('braininstituteApp').factory('RequestStatusSearch', function ($resource) {
    return $resource('/api/requestStatusesSearch/:query');
});
'use strict';

angular.module('braininstituteApp').factory('RequestHistory', function ($resource, DateUtils) {
    return $resource('/api/requestHistories/:id', {}, {
        'get': {
            method: 'GET',
            transformResponse: function transformResponse(data) {
                data = angular.fromJson(data);
                data.dtAction = DateUtils.convertDateTimeFromServer(data.dtAction);
                return data;
            }
        } });
});
'use strict';

angular.module('braininstituteApp').factory('RequestHistorySearch', function ($resource) {
    return $resource('/api/requestHistoriesSearch/:query');
});
'use strict';

angular.module('braininstituteApp').factory('Patient', function ($resource, EntitiesUtil) {

    var resourceUri = '/api/patients';
    var searchResourceUri = resourceUri + '/search';

    return {
        resource: $resource(resourceUri),

        create: function create(data) {
            return EntitiesUtil.create(this.resource, data);
        },

        byCode: function byCode(code) {
            return EntitiesUtil.data(searchResourceUri + '/byCode', null, { code: code });
        }
    };
});
'use strict';

angular.module('braininstituteApp').factory('PatientSearch', function ($resource) {
    return $resource('/api/patientSearch/:query');
});
'use strict';

angular.module('braininstituteApp').service('NotificationDirectiveSupport', function ($state, Principal, RequestsService, $log, Document, baseUri) {
    var hasBeenInitialized = false;
    var notificationCount;
    var notifications;
    var loadingMore;
    var pageData = {
        number: 0,
        size: 0,
        totalElements: 0,
        totalPages: 0
    };

    return {
        // functions
        init: init,
        previous: previous,
        next: next,
        loadNotifications: loadNotifications,
        clearAllNotifications: clearAllNotifications,
        notificationClick: notificationClick,
        getNotifications: getNotifications,
        getNotificationCount: getNotificationCount,
        // variables
        loadingMore: loadingMore,
        getPageData: getPageData,
        setNotInitialized: setNotInitialized
    };

    function setPageData(data) {
        pageData = data;
    }

    function getPageData() {
        return pageData;
    }

    function clearAllNotifications() {
        RequestsService.clearAll().then(function () {
            notificationCount = 0;
            notifications = [];
            setPageData(pageData = {
                number: 0,
                size: 0,
                totalElements: 0,
                totalPages: 0
            });
        });
    }

    function notificationClick(n) {
        if (n.category == 'Download') {
            if (n.action) {
                Document.download(baseUri + '/api/files/download/' + n.action);
            }
        } else {
            $state.go('requests');
        }

        RequestsService.setRead(n).then(function () {
            _.remove(notifications, function (item) {
                return n.id == item.id;
            });
            notificationCount--;
        });
    }

    /**
     * Load a page of Notifications
     * @param page
     */
    function loadNotifications(page) {
        notifications = [];
        RequestsService.loadNotifications(page).then(function (data) {
            var result = data.data;
            if (result) {
                notifications = result._embeddedItems;
                setPageData(result.page);
                notificationCount = result.page.totalElements;
            }
            loadingMore = false;
        }, function (err) {
            loadingMore = false;
            $log.debug(err);
        });
    }

    function setNotInitialized() {
        hasBeenInitialized = false;
    }

    function init() {
        if (hasBeenInitialized) return;
        notifications = [];
        notificationCount = 0;

        if (Principal.isAuthenticated()) {
            Principal.identity().then(function (account) {
                hasBeenInitialized = true; //we need to change the variable here.
                RequestsService.startWebSockets(account, function (data) {
                    if (!notifications) {
                        notifications = [];
                        notificationCount = 0;
                    }
                    notifications.unshift(data);
                    notificationCount++;
                });
            });

            //Call first time
            loadNotifications(0);
        }
    }

    function previous(evt) {
        loadingMore = true;
        loadNotifications(pageData.number - 1);
    }

    function next() {
        loadingMore = true;
        loadNotifications(pageData.number + 1);
    }

    function getNotifications() {
        return notifications;
    }

    function getNotificationCount() {
        return notificationCount;
    }
});
'use strict';

angular.module('braininstituteApp').factory('Notification', function ($http, EntitiesUtil) {
    var resourceUri = '/api/notificationsSearch';
    var searchResourceUri = resourceUri + '/search';

    return {
        // functions
        forUser: forUser,
        setRead: setRead,
        clearAll: clearAll

        // variables
    };

    function forUser(page) {
        return $http.get(searchResourceUri + '/forUser?sort=dtNotification,desc&size=5&page=' + page);
    }

    function setRead(data) {
        var url;

        if (data._links && data._links.self) {
            url = data._links.self.href;
        } else {
            //websocket data
            url = resourceUri + '/' + data.id;
        }

        return EntitiesUtil.update(url, data);
    }

    function clearAll() {
        return EntitiesUtil.data(searchResourceUri + '/clearAll');
    }
});
'use strict';

angular.module('braininstituteApp').factory('Molecular', function ($resource, EntitiesUtil) {

    var resourceUri = '/api/moleculares';
    var searchResourceUri = resourceUri + '/search';

    return {
        resource: $resource(resourceUri, {}, { 'query': { method: 'GET', isArray: false, cache: true } })
    };
});
'use strict';

angular.module('braininstituteApp').factory('MolecularSearch', function ($resource) {
    return $resource('/api/molecularesSearch/:query');
});
'use strict';

angular.module('braininstituteApp').factory('Location', function ($resource, EntitiesUtil) {

    var resourceUri = '/api/locations';
    var searchResourceUri = resourceUri + '/search';

    return {
        resource: $resource('/api/locations', {}, { 'query': { method: 'GET', isArray: false, cache: true } }),
        topLevel: function topLevel() {
            return EntitiesUtil.processDataPromise($resource(searchResourceUri + '/topLevel', {}, { 'query': { method: 'GET', isArray: false, cache: true } }).query().$promise);
        },
        children: function children(url, projection) {
            return EntitiesUtil.data(url, projection, { cache: true });
        }
    };
});
'use strict';

angular.module('braininstituteApp').factory('LocationSearch', function ($resource) {
    return $resource('/api/locationsSearch/:id');
});
'use strict';

angular.module('braininstituteApp').factory('Document', function ($http, EntitiesUtil, $q) {
    var resourceUri = '/api/files';
    var uploadUri = resourceUri + '/upload';
    var categoriesUri = resourceUri + '/categories';

    return {
        search: search,
        getCategories: getCategories,
        getUploadURL: getUploadURL,
        updateSharedUsers: updateSharedUsers,
        delete: deleter,
        download: download
    };

    /**
     * The search function to be called from controller. This will call two
     * separate server functions based on freetext vs chip search. Temporarily
     * separate for now.
     */
    function search(page, pageSize, sortBy, query) {
        if (query.length === 0) {
            return searchText(page, pageSize, sortBy, null);
        } else if (query.length && query[0].out === 'Search text') {
            // text search
            return searchText(page, pageSize, sortBy, query[0].name);
        } else {
            // fields search
            return searchChips(page, pageSize, sortBy, query);
        }
    }

    function searchText(page, pageSize, sortBy, query) {
        return EntitiesUtil.dataPage(resourceUri, {}, {
            sort: sortBy + ',asc',
            page: page - 1,
            size: pageSize,
            query: query
        });
    }

    function searchChips(page, pageSize, sortBy, filters) {
        var uri = resourceUri + '?size=' + pageSize;
        if (page) {
            uri += '&page=' + (page - 1);
        }
        if (sortBy) {
            //sort by one field support
            uri += '&sort=' + sortBy + ',asc';
        }

        var fields = { fields: JSON.parse(filters) };
        return $http.post(uri, fields);
    }

    function getCategories(all) {
        return EntitiesUtil.data(categoriesUri, {}, { all: all });
    }

    function getUploadURL() {
        return uploadUri;
    }

    function updateSharedUsers(current, users, version, href) {
        var deferred = $q.defer();
        var post = {
            userId: current,
            shareUsers: users
        };
        $http.post(href, post, { headers: { "If-Match": version } }) //set headers to check versioning
        .then(function (response) {
            deferred.resolve(response.data);
        }, function errorCallback(response) {
            EntitiesUtil.processErrorResponse(response);
            deferred.reject(response);
        });

        return deferred.promise;
    }

    function deleter(href, version) {
        var deferred = $q.defer();

        $http.delete(href, { headers: { "If-Match": version } }).then(function (response) {
            deferred.resolve(response.data); //return back update data
        }, function errorCallback(response) {
            EntitiesUtil.processErrorResponse(response);
            deferred.reject(response);
        });

        return deferred.promise;
    }

    function download(href) {
        if (/constructor/i.test(window.HTMLElement)) {
            //Safari hack - safari has limited support for file downloads
            window.location.href = href;
        } else {
            $http.get(href, { responseType: 'arraybuffer' }).then(function (response) {
                var type = response.headers('Content-Type');
                var disposition = response.headers('Content-Disposition');
                var fileName;
                if (disposition) {
                    var match = disposition.match(/.*filename=\"?([^;\"]+)\"?.*/);
                    if (match[1]) fileName = match[1];
                }

                var blob = new Blob([response.data], { type: type });
                saveAs(blob, fileName);
            });
        }
    }
});
'use strict';

angular.module('braininstituteApp').factory('Diagnosis', function ($resource, EntitiesUtil) {

    var resourceUri = '/api/diagnoses';
    var searchResourceUri = resourceUri + '/search';

    return {
        resource: $resource(resourceUri, {}, { 'query': { method: 'GET', isArray: false, cache: true } }),
        topLevel: function topLevel() {
            return EntitiesUtil.processDataPromise($resource(searchResourceUri + '/topLevel', {}, { 'query': { method: 'GET', isArray: false, cache: true } }).query().$promise);
        },
        children: function children(url, projection) {
            return EntitiesUtil.data(url, projection, { cache: true });
        }
    };
});
'use strict';

angular.module('braininstituteApp').factory('DiagnosisSearch', function ($resource) {
    return $resource('/api/diagnosesSearch/:query');
});
'use strict';

angular.module('braininstituteApp').factory('User', function ($resource, $q, $http, EntitiesUtil) {
    var resourceUri = '/api/users';
    var searchResourceUri = resourceUri + '/search';

    return {
        resource: $resource(resourceUri),

        getAllForAdmin: function getAllForAdmin() {
            return EntitiesUtil.data(searchResourceUri + '/allForAdmin');
        },

        getAllForCoordinator: function getAllForCoordinator() {
            return EntitiesUtil.data(searchResourceUri + '/allForCoordinator');
        },

        unlockUser: function unlockUser(email) {
            return EntitiesUtil.update(resourceUri + "/remove_lock", email);
        },

        updatePersonalData: function updatePersonalData(payload, etag) {
            return $http.put(resourceUri + "/personal_data", payload, { headers: { "If-Match": etag } });
        },

        create: function create(data) {
            return EntitiesUtil.create(this.resource, data);
        },

        current: function current() {
            return EntitiesUtil.data(searchResourceUri + '/current', 'authorities');
        },

        getAllForShareSearch: function getAllForShareSearch() {
            return EntitiesUtil.data(searchResourceUri + "/allForShareSearch", "userShareSearch");
        },

        verifyEmailUnique: function verifyEmailUnique(email) {
            var uri = searchResourceUri + '/email?email=' + email;
            return $q(function (resolve, reject) {
                $http.get(uri).then(function (data) {
                    /* If a user with the given email exists and is also
                       activated,  consider that an unavailable address
                       for user edit. In any other case it's available. */
                    if (data && data.data && data.data.activated) reject('email already exists');else resolve('email not used before');
                }).catch(function (err) {
                    resolve('email not used before');
                });
            });
        }
    };

    function myStringEndsWith(subjectString, searchString, position) {
        if (typeof position !== 'number' || !isFinite(position) || Math.floor(position) !== position || position > subjectString.length) {
            position = subjectString.length;
        }
        position -= searchString.length;
        var lastIndex = subjectString.indexOf(searchString, position);
        return lastIndex !== -1 && lastIndex === position;
    }
});
'use strict';

angular.module('braininstituteApp').factory('UserSearch', function ($resource) {
    return $resource('/api/usersSearch/:query', {}, {
        'query': { method: 'GET', isArray: true }
    });
});
/**
 * Created by Daniel Costa <danielcosta123@gmail.com> on 4/22/2016.
 */
'use strict';

angular.module('braininstituteApp').factory('UserAdditional', function ($resource, $q, EntitiesUtil) {
    var resourceUri = '/api/userAdditional';
    var searchResourceUri = resourceUri + '/search';

    return {
        resource: $resource(resourceUri),
        create: function create(data) {
            return EntitiesUtil.create(this.resource, data);
        }
    };
});
'use strict';

/**
 * Created by Daniel Costa <danielcosta123@gmail.com> on 8/5/2015.
 */
angular.module('braininstituteApp').factory('Authority', function ($resource, EntitiesUtil) {

    var resourceUri = '/api/groups';
    var searchResourceUri = resourceUri + '/search';

    return {
        resource: $resource(resourceUri),
        getAll: function getAll() {
            return EntitiesUtil.data(searchResourceUri + '/all');
        }
    };
});
/**
 * Generic Resource Utilities
 */
'use strict';

angular.module('braininstituteApp').factory('EntitiesUtil', function ($http, $q, localStorageService, AlertService, $translate, _, baseUri) {
    function processErrorResponse(response) {
        //Optimistic locking
        if (response.status === 409) {
            AlertService.showAlert($translate.instant('global.messages.error.versioning-title'), $translate.instant('global.messages.error.versioning'));
        }

        //Not acceptable
        if (response.status === 406) {
            AlertService.showAlert($translate.instant('global.messages.error.server-error-title-406'), response.data ? response.data.message : response.message);
        }

        //Forbidden
        if (response.status === 403) {
            AlertService.showAlert($translate.instant('global.messages.error.server-error-title'), response.data ? response.data.message : response.message);
        }

        //Internal server error
        if (response.status === 500) {
            AlertService.showAlert($translate.instant('global.messages.error.server-error-title'), $translate.instant('global.messages.error.server-error'));
        }
    }

    function createOptions(projection, params) {
        var options = {};

        options.params = params || {};

        if (!_.isEmpty(projection)) {
            options.params.projection = projection;
        }

        return options;
    }

    return {
        processErrorResponse: processErrorResponse,

        /**                                               s
         * Retrieve data from given URL and projection.
         * @param url Resource URL
         * @param projection Optional projection for the resource
         * @param params Optional parameters
         * @returns Promise, it will either resolve with data or reject with response object
         */
        data: function data(url, projection, params) {
            return this.processDataPromise($http.get(url, createOptions(projection, params)));
        },

        /**
         * Retrieve page of data
         *
         * @param url resource URL
         * @param projection Optional projection
         * @param params Optional parameters
         * @returns Either error object or response object
         */
        dataPage: function dataPage(url, projection, params) {
            return this.processDataPagePromise($http.get(url, createOptions(projection, params)));
        },

        /**
         * Retrieve resource with optional projection.
         * Pulls the ETag from the header and sets it in local storage.
         *
         * @param url Resource URI
         * @param projection Option projection
         * @returns Promise, resolved with resource data or rejected with response
         */
        get: function get(url, projection) {
            url = this.removeBaseUri(url);
            var deferred = $q.defer();
            console.log(url);
            $http.get(url, createOptions(projection)).then(function (response) {
                localStorageService.set('etag-' + url, response.headers().etag); //Retrieve Etag from header and set it in the local storage
                deferred.resolve(response.data);
            }, function (response) {
                processErrorResponse(response);
                deferred.reject(response);
            });

            return deferred.promise;
        },

        /**
         * Update resource. Adds If-Match header attribute with the value of ETag.
         *
         * @param url Resource URI
         * @param data Update data
         * @param silentMode If set, we won't show any alert here
         * @returns Promise, resolved with resource updated data or rejected with response
         */
        update: function update(url, data, silentMode) {
            url = this.removeBaseUri(url);
            var etagUrl = 'etag-' + url;
            var etag = localStorageService.get(etagUrl); //retrieve the Etag from local storage
            var deferred = $q.defer();

            //If we don't find the etag in local storage, get the version from the object
            if (!etag && angular.isDefined(data.version)) {
                etag = data.version;
            } else if (!etag) {
                etag = "0";
            }

            $http.put(url, data, { headers: { "If-Match": etag } }) //set headers to check versioning
            .then(function (response) {
                //Update the local storage with the new etag
                localStorageService.set(etagUrl, response.headers().etag);
                deferred.resolve(response.data); //return back update data
            }, function errorCallback(response) {
                if (!silentMode) {
                    processErrorResponse(response);
                }
                deferred.reject(response);
            });

            return deferred.promise;
        },

        /**
         * Create resource
         *
         * @param resource NG Resource
         * @param data Resource data
         * @returns Promise, solved with the create resource or rejects with response
         */
        create: function create(resource, data) {
            return this.processDataPromise(resource.create(data).$promise);
        },

        delete: function _delete(url) {
            url = this.removeBaseUri(url);
            var etag = localStorageService.get('etag-' + url); //retrieve the Etag from local storage
            var deferred = $q.defer();

            $http.delete(url, { headers: { "If-Match": etag } }).then(function (response) {
                localStorageService.remove('etag-' + url);
                deferred.resolve(response.data); //return back update data
            }, function errorCallback(response) {
                processErrorResponse(response);
                deferred.reject(response);
            });

            return deferred.promise;
        },

        processDataPromise: function processDataPromise(promise) {
            var deferred = $q.defer();
            promise.then(function (response) {
                var data = response.data ? response.data : response;
                deferred.resolve(_.has(data, '_embeddedItems') ? data._embeddedItems ? data._embeddedItems : {} : data);
            }, function (response) {
                processErrorResponse(response);
                deferred.reject(response);
            });

            return deferred.promise;
        },

        processDataPagePromise: function processDataPagePromise(promise) {
            var deferred = $q.defer();
            promise.then(function (response) {
                var data = response.data ? response.data : response;
                deferred.resolve(data);
            }, function (response) {
                processErrorResponse(response);
                deferred.reject(response);
            });

            return deferred.promise;
        },

        /**
         * Looks for ETags keys in the local storage and removes all of them
         */
        clearETags: function clearETags() {
            angular.forEach(localStorageService.keys(), function (key) {
                if (/^etag-/.test(key)) {
                    localStorageService.remove(key);
                }
            });
        },

        /**
         * Remove base URI for Saving/Retrieving data from local storage
         * We want to use only the relative path
         * @param uri
         */
        removeBaseUri: function removeBaseUri(uri) {
            if (uri) {
                return uri.replace(baseUri, "");
            }
            return "";
        }
    };
});
'use strict';

angular.module('tcincCommon', []);
'use strict';

(function () {
    'use strict';
    /**
     * create directive with injected VERSION constant
     */

    angular.module('tcincCommon').directive('appVersion', ['VERSION', function (VERSION) {
        return function (scope, elm) {
            elm.text(VERSION);
        };
    }]);
})();
'use strict';

/**
 * Created by Daniel Costa <danielcosta123@gmail.com> on 10/9/2015.
 */
(function () {
    'use strict';

    angular.module('braininstituteApp').directive('toLowerCase', function () {
        return {
            require: 'ngModel',
            link: Link
        };
    });

    function Link(scope, element, attrs, modelCtrl) {
        modelCtrl.$parsers.push(function (inputValue) {

            var transformedInput = inputValue.toLowerCase().replace(/ /g, '');

            if (transformedInput != inputValue) {
                modelCtrl.$setViewValue(transformedInput);
                modelCtrl.$render();
            }

            return transformedInput;
        });
    }
})();
'use strict';

//unfinished
(function () {
    'use strict';

    angular.module('braininstituteApp').directive('sameAs', function () {
        return {
            require: 'ngModel',
            link: Link
        };
    });

    function Link(scope, elem, attrs, ngModel) {
        ngModel.$parsers.unshift(validate);

        // Force-trigger the parsing pipeline.
        scope.$watch(attrs.sameAs, function () {
            ngModel.$setViewValue(ngModel.$viewValue);
        });

        function validate(value) {
            var isValid = scope.$eval(attrs.sameAs) == value;

            ngModel.$setValidity('same-as', isValid);

            return isValid ? value : undefined;
        }
    }
})();
'use strict';

//unfinished
//issue 1: one has modelValue, other has viewValue
//issue 2: validators run only when that field's value changes, and not when the other field's value changes although
//that is a part of the answer, and not when the field in question is empty. This will make it unusable.
(function () {
    'use strict';

    angular.module('braininstituteApp').directive('lte', function () {
        return {
            require: 'ngModel',
            link: Link
        };
    });

    function Link(scope, elem, attrs, ngModel) {
        ngModel.$parsers.unshift(validate);

        // Force-trigger the parsing pipeline.
        scope.$watch(attrs.lte, function () {
            ngModel.$setViewValue(ngModel.$viewValue);
        });

        function validate(value) {
            var other = scope.$eval(attrs.lte);

            if (angular.isDate(other)) other = moment(other).format('YYYY-MM');
            var isValid = other >= value || angular.isUndefined(other) || other === null || angular.isUndefined(value) || value === null;
            ngModel.$setValidity('lte', isValid);

            return isValid ? value : undefined;
        }

        //function validate(value) {
        //    var other = scope.$eval(attrs.lte);
        //    var isValid = other >= value || !angular.isDefined(other) || !angular.isDefined(value);
        //
        //    ngModel.$setValidity('lte', isValid);
        //
        //    return isValid ? value : undefined;
        //}
    }
})();
'use strict';

//unfinished
(function () {
    'use strict';

    angular.module('braininstituteApp').directive('gte', function () {
        return {
            require: 'ngModel',
            link: Link
        };
    });

    function Link(scope, elem, attrs, ngModel) {
        ngModel.$parsers.unshift(validate);

        // Force-trigger the parsing pipeline.
        scope.$watch(attrs.gte, function () {
            ngModel.$setViewValue(ngModel.$viewValue);
        });

        function validate(value) {
            var other = scope.$eval(attrs.gte);
            var isValid = other <= value || !angular.isDefined(other) || !angular.isDefined(value);

            ngModel.$setValidity('gte', isValid);

            return isValid ? value : undefined;
        }
    }
})();
'use strict';

/**
 * Selection management logic for treeviews with checkboxes
 *
 * @private
 * @package ivh.treeview
 * @copyright 2014 iVantage Health Analytics, Inc.
 */

angular.module('ivh.treeview').directive('ivhTreeviewMdCheckboxHelper', [function () {
    'use strict';

    return {
        restrict: 'A',
        scope: {
            node: '=ivhTreeviewMdCheckboxHelper'
        },
        require: '^ivhTreeview',
        link: function link(scope, element, attrs, trvw) {
            var node = scope.node,
                opts = trvw.opts(),
                indeterminateAttr = opts.indeterminateAttribute,
                selectedAttr = opts.selectedAttribute;

            // Set initial selected state of this checkbox
            scope.isSelected = node[selectedAttr];

            // Local access to the parent controller
            scope.trvw = trvw;

            // Update the checkbox when the node's selected status changes
            scope.$watch(function () {
                return node[selectedAttr];
            }, function (newVal, oldVal) {
                scope.isSelected = newVal;
            });

            // Update the checkbox when the node's indeterminate status changes
            scope.$watch(function () {
                return node[indeterminateAttr];
            }, function (newVal, oldVal) {
                //element.find('input').prop('indeterminate', newVal);
                // SINAN: I changed from input to md-checkbox, and added attr in addition to prop to match using CSS,
                // as I have to match using CSS because md-checkbox doesn't use the "indeterminate" prop.
                var tmp = element.find('md-checkbox');
                tmp.prop('indeterminate', newVal);
                tmp.attr('indeterminate', newVal);
            });
        },
        //template: [
        //  '<input type="checkbox"',
        //    'ng-model="isSelected"',
        //    'ng-change="trvw.select(node, isSelected)" />'
        //].join('\n')
        // SINAN: I added ng-transclude to catch node label and insert into md-checkbox. The original doesn't need that
        // because in input[checkbox] the label is outside the input element. Also ng-transclude in the paired directive.
        template: ['<md-checkbox', 'ng-model="isSelected"', 'ng-change="trvw.select(node, isSelected)"', 'aria-label={{trvw.label(node)}}', 'class="tcinc-ivh-treeview-md-checkbox">', '<ng-transclude></ng-transclude>', // after BRAIN-128 we aren't using the transclusion.
        '</md-checkbox>'].join('\n'),
        transclude: true
    };
}]);
'use strict';

/**
 * Wrapper for a checkbox directive
 *
 * Basically exists so folks creeting custom node templates don't need to attach
 * their node to this directive explicitly - i.e. keeps consistent interface
 * with the twistie and toggle directives.
 *
 * @package ivh.treeview
 * @copyright 2014 iVantage Health Analytics, Inc.
 */

angular.module('ivh.treeview').directive('ivhTreeviewMdCheckbox', [function () {
    'use strict';

    return {
        restrict: 'AE',
        require: '^ivhTreeviewNode',
        template: '<span ivh-treeview-md-checkbox-helper="node"><ng-transclude></ng-transclude></span>',
        transclude: true
        // SINAN: I added ng-transclude to catch node label and insert into md-checkbox. The original doesn't need that
        // because in input[checkbox] the label is outside the input element. Also ng-transclude in the paired directive.
        // after BRAIN-128 we aren't using the transclusion.
    };
}]);
'use strict';

// version 2015-08-14.1
(function () {
    'use strict';

    angular.module('tcincCommon').directive('topWhiteframeOff', [function () {
        return {
            restrict: 'AE',
            scope: false,
            link: function link(scope, element) {
                var $frame = $('md-whiteframe').eq(0);

                // get existing properties
                var background = $frame.css('background');
                var margin = $frame.css('margin');
                var padding = $frame.css('padding');
                var boxShadow = $frame.css('box-shadow');

                // set properties this way to hide the whiteframe
                $frame.css('background', 'inherit');
                $frame.css('margin', 'inherit');
                $frame.css('padding', 'inherit');
                $frame.css('box-shadow', 'inherit');

                scope.$on('$destroy', function () {
                    // set properties back to normal for other pages
                    $frame.css('background', background);
                    $frame.css('margin', margin);
                    $frame.css('padding', padding);
                    $frame.css('box-shadow', boxShadow);
                });
            }
        };
    }]);
})();
'use strict';

// version 2015-08-31.1
// this is a simpler version that doesn't try to clear the input text or set null value.
(function () {
    'use strict';

    angular.module('tcincCommon').directive('tcincDatepickerSimple', [function () {
        return {
            restrict: 'E',
            scope: {
                ngModel: '=',
                mdPlaceholder: '@'
            },
            link: link,
            template: '<md-datepicker ng-model="ngModel" md-placeholder="{{ mdPlaceholder }}">'
        };
        function link(scope, element, attrs) {
            if (!scope.ngModel) scope.ngModel = new Date(1900, 0, 2);

            var modelName = attrs.ngModel;

            $('tcinc-datepicker[ng-model="' + modelName + '"] .md-datepicker-input').on('change', scope, datepickerInputChangeHandler);
        }

        function datepickerInputChangeHandler(ev) {
            var scope = ev.data;
            if (ev.target.value === '') {
                scope.ngModel = new Date(1900, 0, 2);
            }
        }
    }]);
})();
'use strict';

// version 2015-08-31.1
// I also want to show the input text as empty on initialization, while having a value in the model because that is
// required by the datepicker directive. I was trying some ideas here, commented out.
(function () {
    'use strict';

    angular.module('tcincCommon').directive('tcincDatepicker', [function () {
        return {
            restrict: 'E',
            scope: {
                ngModel: '=',
                mdPlaceholder: '@'
            },
            link: link,
            template: '<md-datepicker ng-model="ngModel" md-placeholder="{{ mdPlaceholder }}">'
        };
        function link(scope, element, attrs) {
            if (!scope.ngModel) {
                scope.ngModel = new Date(1900, 0, 2);
                scope.ngModel.isNull = true;
            }

            var modelName = attrs.ngModel;

            $('tcinc-datepicker[ng-model="' + modelName + '"] .md-datepicker-input').on('change', scope, datepickerInputChangeHandler);

            scope.$watch('ngModel', function (value) {
                scope.isNull = undefined;
            });

            //window.$pick = $('tcinc-datepicker[ng-model="' + modelName + '"] .md-datepicker-input')
            //window.pick = $pick[0]
            //console.log('initial value is: ' + pick.value)
            //pick.value = ''
            //
            //angular.element(document).ready(function () {
            //    console.log('initial value is: ' + pick.value)
            //});
        }

        function datepickerInputChangeHandler(ev) {
            var scope = ev.data;
            if (ev.target.value === '') {
                scope.ngModel.isNull = true;
            }
        }
    }]);
})();
'use strict';

// version 2015-09-29.1
(function () {
    'use strict';

    angular.module('tcincCommon').directive('sidenavWithTreviewCheckboxes', ['$mdSidenav', '$compile', 'ivhTreeviewMgr', function ($mdSidenav, $compile, ivhTreeviewMgr) {
        var unexpandedTpl = '\
<md-sidenav md-component-id="_COMPONENT_ID" md-is-open="isOpen" class="md-sidenav-left md-whiteframe-z2"\
    <md-toolbar class="md-theme-light">\
        <h1 class="md-toolbar-tools">{{ title }}</h1>\
    </md-toolbar>\
    <md-content layout-padding>\
        <form>\
            <tree-view-checkboxes ng-if="ngModel" ng-model="ngModel" collapse-others-on-expand="true"\
            use-twisties="true"></tree-view-checkboxes>\
        </form>\
        <md-button href ng-click="close()" class="md-primary">\
            Done\
        </md-button>\
        <md-button href ng-click="clear()" class="md-secondary">\
            Clear\
        </md-button>\
    </md-content>\
</md-sidenav>\
';
        return {
            restrict: 'E',
            scope: {
                name: '@',
                title: '@',
                closeHandler: '&',
                ngModel: '='
            },
            controller: ['$scope', function ($scope) {}],
            link: link
        };

        function link(scope, element) {
            scope.isOpen = false;

            scope.$watch('isOpen', function (newVal, oldVal) {
                if (scope.closeHandler && oldVal === true && newVal === false) scope.closeHandler();
            });

            scope.close = function () {
                $mdSidenav(scope.name).close();
            };

            scope.clear = function () {
                ivhTreeviewMgr.deselectAll(scope.ngModel);
            };

            element.html(generateTemplate(unexpandedTpl, scope.name));
            $compile(element.contents())(scope);
        }

        function generateTemplate(unexpandedTpl, componentId) {
            return unexpandedTpl.replace('_COMPONENT_ID', componentId);
        }
    }]);
})();
'use strict';

(function () {
    'use strict';

    angular.module('braininstituteApp').directive('sampleTypeSelector', function ($timeout, SampleType) {
        return {
            restrict: 'E',
            templateUrl: 'app/shared/directive/sampleTypeSelector/sampleTypeSelector.html',
            scope: {
                sample: '=',
                topModel: '='
            },
            controller: controller
        };

        function controller($scope, $http) {
            $scope.sampleType = {};

            $scope.hasSampleTypeChildren = false;
            //This variable will control if there's a valid SampleType selected.
            $scope.isSampleTypeSelected = false;
            //This variable will control if the selected SampleType is countable or not
            $scope.isSampleTypeCountable = false;

            SampleType.topLevel('sampleTypeNested').then(function (data) {
                $scope.sampleTypesFirst = data;
            });

            $scope.getChildren = function (url, isLast) {
                SampleType.children(url, 'sampleTypeNested').then(function (data) {
                    $scope.sampleTypesSecond = data;

                    if (isLast) {
                        //second sample type selected
                        $scope.hasSampleTypeChildren = true; //show the second sample type
                        $scope.isSampleTypeSelected = true;
                        $scope.isSampleTypeCountable = $scope.sampleType.second.countable;
                    } else {
                        //frist smaple type selected
                        $scope.hasSampleTypeChildren = data.length > 0; //if no children hide the second select
                        $scope.isSampleTypeSelected = !$scope.hasSampleTypeChildren; //if there are children hide the sample info, show it after second selections

                        if ($scope.isSampleTypeSelected) {
                            $scope.topModel = $scope.sampleType.first;
                            $scope.isSampleTypeCountable = $scope.sampleType.first.countable;
                            if (!$scope.isSampleTypeCountable) {
                                $scope.sample.aliquots = undefined;
                            }
                        }
                    }
                }, function (message) {});
            };

            $scope.onChangeSampleType = function onChangeSampleType(sampleType) {
                if (sampleType.level == 1) {
                    $scope.sampleType.first = sampleType; //enforcing, there was a delay bug
                    $scope.getChildren(sampleType._links.children.href, false);
                    $scope.sampleType.second = null;
                } else if (sampleType.level == 2) {
                    $scope.sampleType.second = sampleType; //enforcing, there was a delay bug
                    $scope.isSampleTypeSelected = true;
                    $scope.isSampleTypeCountable = sampleType.countable;
                    $scope.topModel = sampleType;
                }
            };

            //Wait for the sample data loaded in the page controller
            $scope.$watch('sample.sampleType', function (newData) {
                if (newData && newData._links) {
                    newData._links.self.href = newData._links.self.href.replace('{?projection}', ''); //adjust the id

                    if (newData.level === 1) {
                        $scope.sampleType.first = newData;

                        $scope.getChildren(newData._links.children.href, false);
                    } else {
                        // level === 2
                        $scope.sampleType.first = newData.parent;
                        $scope.sampleType.second = newData;

                        $scope.getChildren(newData.parent._links.children.href, true);
                        newData.parent._links.self.href = newData.parent._links.self.href.replace('{?projection}', ''); //adjust the id
                    }

                    $scope.topModel = newData;
                } else {
                    $scope.topModel = null;
                    $scope.sampleType = {};
                    $scope.hasSampleTypeChildren = false;
                    $scope.isSampleTypeSelected = false;
                    $scope.isSampleTypeCountable = false;
                }
            });
        }
    });
})();
'use strict';

(function () {
    'use strict';

    angular.module('tcincCommon').directive('rangeValidator', function () {
        // Below is only for Brain demo on 24 March. After that we should update to lodash 4 and remove this.
        _.isInteger = _.isInteger || function (value) {
            return typeof value === 'number' && isFinite(value) && Math.floor(value) === value;
        };

        return {
            restrict: 'A',
            link: Link,
            controller: Controller
        };

        function Link(scope, element, attrs, controller) {
            scope.rangeType = attrs.rangeValidator;
        }

        function Models() {
            this.from = this.to = null;
        }

        function Controller($scope) {
            var models = new Models();
            this.setParentModels = setParentModels;
            this.setValidities = setValidities;

            function setParentModels(modelType, ngModel) {
                models[modelType] = ngModel;
            }

            /**
             *
             */
            function setValidities(modelType) {
                var from = parseValue(models.from.$viewValue);
                var to = parseValue(models.to.$viewValue);

                if (validateSingleValue(from) && validateSingleValue(to) && from > to) {
                    models.from.$setValidity('range', false);
                    models.to.$setValidity('range', false);
                } else {
                    models.from.$setValidity('range', true);
                    models.to.$setValidity('range', true);
                }
            }

            /**
             * Needed because the result of parsing can't be used directly in setValidities's if,
             * e.g. a max=0 would look like max is empty so the range would be incorrectly flagged as valid.
             * Not intended as angular form validation for single fields.
             */
            function validateSingleValue(value) {
                if ($scope.rangeType === 'integer') return _.isInteger(value);
                if ($scope.rangeType === 'number') return _.isNumber(value);
                if ($scope.rangeType === 'year-month') return (/((([1][9][0-9][0-9])|([2][0-9][0-9][0-9])))([-])((0[123456789]|10|11|12))/.test(value)
                );
            }

            function parseValue(value) {
                if ($scope.rangeType === 'integer') return parseInt(value, 10);
                if ($scope.rangeType === 'number') return _.toNumber(value);
                if ($scope.rangeType === 'year-month') return value;
            }

            //function compareValue(from, to) {
            //}
        }
    }).directive('rangeValidatorChild', function () {
        return {
            restrict: 'A',
            link: Link,
            controller: Controller,
            require: ['^rangeValidator', '^ngModel']
        };

        function Link(scope, element, attrs, controller) {
            var rangeValidatorCtrl = controller[0];
            var ngModelCtrl = controller[1];
            rangeValidatorCtrl.setParentModels(attrs.rangeValidatorChild, ngModelCtrl);
            // $validators cannot be used because it needs to return true/false whereas we need to set validity
            // for the two models.
            ngModelCtrl.$parsers.unshift(function (viewValue) {
                rangeValidatorCtrl.setValidities(attrs.rangeValidatorChild);
                return viewValue;
            });
        }

        function Controller($scope) {}
    });
})();
'use strict';

(function () {
    'use strict';

    angular.module('braininstituteApp').directive('notificationMenu', function () {
        return {
            restrict: 'E',
            templateUrl: 'app/shared/directive/notificationMenu/notificationMenu.html',
            scope: {},
            controller: controller
        };

        function controller($scope, NotificationDirectiveSupport, Notification, Principal) {
            var vm = this;

            // variables
            $scope.getPageData = NotificationDirectiveSupport.getPageData;
            $scope.loadingMore = NotificationDirectiveSupport.loadingMore;

            // functions
            $scope.getNotificationCount = NotificationDirectiveSupport.getNotificationCount;
            $scope.getNotifications = NotificationDirectiveSupport.getNotifications;

            $scope.isAuthenticated = Principal.isAuthenticated;
            $scope.clearAllNotifications = NotificationDirectiveSupport.clearAllNotifications;
            $scope.notificationClick = NotificationDirectiveSupport.notificationClick;
            $scope.loadNotifications = NotificationDirectiveSupport.loadNotifications;
            $scope.previous = NotificationDirectiveSupport.previous;
            $scope.next = NotificationDirectiveSupport.next;

            NotificationDirectiveSupport.init();

            $scope.openMenu = function ($mdOpenMenu, ev) {
                $mdOpenMenu(ev);
                $scope.loadNotifications(0);
            };

            //Declare a function to handle when stomp is down
            $scope.$on('stompDown', function () {
                $scope.stompDown = true;
                NotificationDirectiveSupport.setNotInitialized();
            });

            $scope.$on('loggedIn', function () {
                NotificationDirectiveSupport.init();
            });

            $scope.parseTitle = function (category) {
                if (category === 'UserRequests') {
                    return 'New Request';
                } else if (category === 'MyRequests') {
                    return 'My Request';
                } else {
                    return 'Notification';
                }
            };

            $scope.parseDate = function (date) {
                return moment(date).format('MM/DD h:mm a');
            };
        }
    });
})();
'use strict';

/**
 * Created by Daniel Costa <danielcosta123@gmail.com> on 10/22/2015.
 */
(function () {
    'use strict';

    angular.module('tcincCommon').directive('monthInput', ['$compile', function ($compile) {
        return {
            priority: 1000,
            terminal: true,
            restrict: 'A',
            compile: function compile(element, attr) {
                element.removeAttr('month-input');
                element.attr('ng-pattern', '/((([1][9][0-9][0-9])|([2][0-9][0-9][0-9])))([-])((0[123456789]|10|11|12))/');
                element.attr('mask', '9999-19');
                element.attr('placeholder', 'YYYY-MM');
                element.attr('type', 'text');

                return {
                    pre: function preLink(scope, iElement, iAttrs, controller) {},
                    post: function postLink(scope, iElement, iAttrs, controller) {
                        $compile(iElement)(scope);
                    }
                };
            }
        };
    }]);
})();
'use strict';

// version 2015-10-14.1
(function () {
    'use strict';

    angular.module('tcincCommon').directive('manyTabs', function () {
        return {
            restrict: 'E',
            transclude: true,
            scope: {},
            link: ManyTabsLink,
            controller: ManyTabsController,
            template: '<div ng-transclude></div>'
        };

        function ManyTabsLink(scope) {
            //scope.selectedPane = null;
            //scope.expandedMode = false;
        }

        function ManyTabsController($scope) {
            $scope.panes = [];

            this.oneExpanded = function (selectedPane) {
                //$scope.expandedMode = true;
                $scope.panes.forEach(function (pane) {
                    // collapse and hide others
                    if (selectedPane != pane) {
                        pane.expanded = false;
                        pane.visible = false;
                    }
                });
            };

            this.goBack = function () {
                $scope.panes.forEach(function (pane) {
                    pane.expanded = false;
                    pane.visible = true;
                });
            };

            //this.isExpandedMode = function () {
            //    return $scope.expandedMode;
            //};

            this.addPane = function (pane) {
                $scope.panes.push(pane);
            };
        }
    }).directive('manyTabsPane', function () {
        return {
            require: '^manyTabs',
            restrict: 'E',
            transclude: true,
            scope: {
                title: '@theTitle',
                clear: '&',
                changeFilterVisibilityCallback: '&',
                changedCount: '='
            },
            link: ManyTabsPaneLink,
            controller: ManyTabsPaneController,
            templateUrl: 'app/shared/directive/manyTabs/manyTabsPane.html'
        };

        function ManyTabsPaneLink(scope, element, attrs, tabsCtrl) {
            scope.visible = true;
            scope.expanded = false;

            tabsCtrl.addPane(scope);

            scope.expand = function () {
                //scope.visible = true;
                scope.expanded = true;
                tabsCtrl.oneExpanded(scope);
                //element.prependTo(element.parents('many-tabs'));
            };

            scope.goBack = tabsCtrl.goBack;
        }

        function ManyTabsPaneController() {}
    });
})();
'use strict';

// version 2016-05-23.1
(function () {
    'use strict';

    angular.module('tcincCommon').directive('labelRequired', function ($timeout) {
        return {
            restrict: 'A',
            link: link
            // priority: 1
        };

        function link(scope, element, attrs) {
            /* Directive priority setting of this one and adding a config
             * block in app.js like:
             * .config(function($translateProvider) {
             *     $translateProvider.directivePriority(2);
             *  });
             * didn't work for me and reversing the priorities so I wrap
             * it in $timeout for now. 
             */
            $timeout(function () {
                element.html(element.html() + ' <span class="label-required-directive-class">*</span>');
            }, 0);
        }
    });
})();
'use strict';

(function () {
    'use strict';

    angular.module('braininstituteApp').directive('inputSpaceRemover', function () {
        return {
            require: 'ngModel',
            link: function link(scope, element, attrs, modelCtrl) {
                modelCtrl.$parsers.push(function (inputValue) {
                    var transformedInput = inputValue.replace(/\s/g, '');

                    if (transformedInput !== inputValue) {
                        modelCtrl.$setViewValue(transformedInput);
                        modelCtrl.$render();
                    }

                    return transformedInput;
                });
            }
        };
    });
})();
'use strict';

// version 2015-08-14.1
(function () {
    'use strict';

    angular.module('tcincCommon').directive('inputRange', ['$compile', function ($compile) {
        var tpl = '<div layout>' + '    <md-input-container flex>' + '        <label>From</label>' + '        <input type="{{ inputType }}" ng-model="ngModel.from">' + '    </md-input-container>' + '    <md-input-container flex>' + '        <label>To</label>' + '        <input type="{{ inputType }}" ng-model="ngModel.to">' + '    </md-input-container>' + '</div>';
        return {
            restrict: 'E',
            template: tpl,
            scope: {
                ngModel: '=',
                inputType: '@'
            }
        };
    }]);
})();
'use strict';

(function () {
    'use strict';

    angular.module('tcincCommon').directive('dependentDropdown', function ($compile, EntitiesUtil) {
        return {
            restrict: 'E',
            scope: {
                topModel: '=',
                initialData: '=',
                numberOfLevels: '=',
                title: '@',
                titlesArray: '=',
                querier: '&',
                showSelectsAsNeeded: '@'
            },
            controller: controller,
            link: link
        };

        function controller($scope, $http) {
            //Load initial data
            $scope.querier({
                callback: function callback(data) {
                    $scope.choices[0] = data;
                    $scope.showns[0] = true;
                }
            });

            $scope.optionClicked = function (choice) {
                $scope.topModel = choice;
                $scope.model[choice.level - 1] = choice;

                if (choice.level === $scope.numberOfLevels) // don't go past the end
                    return;

                // Update next level choices
                EntitiesUtil.data(choice._links.children.href, 'nested').then(function (data) {
                    if (data && data[0]) {
                        $scope.choices[data[0].level - 1] = data;
                        if ($scope.showSelectsAsNeeded) $scope.showns[data[0].level - 1] = true;
                    } else {
                        // no next level came, so hide
                        if ($scope.showSelectsAsNeeded) $scope.showns[choice.level] = false;
                    }
                });

                // Clear higher levels
                for (var i = choice.level; i < $scope.numberOfLevels; i++) {
                    $scope.choices[i] = null;
                    $scope.model[i] = null;
                    // hide higher than next
                    if ($scope.showSelectsAsNeeded && i > choice.level + 1) $scope.showns[i] = false;
                }
            };

            $scope.clear = function () {
                for (var i = 0; i < $scope.numberOfLevels; i++) {
                    $scope.model[i] = null;
                    $scope.showns[i] = null;
                }
            };
        }

        function link(scope, element, attrs) {
            // array that stores the current level n choices at choices[n], and is updated by onChange
            scope.choices = [];
            scope.model = [];
            // array that stores whether each dropdown is shown or not. used when showSelectsAsNeeded is true.
            scope.showSelectsAsNeeded = scope.showSelectsAsNeeded === 'true';
            scope.showns = _.fill(new Array(scope.numberOfLevels), !scope.showSelectsAsNeeded);

            scope.$watch('initialData', function updatedModel(newData, oldData) {
                if (newData) {
                    // go through the received data and make it in proper array order instead of data.parent.parent...,
                    // for next step because I want to go from index 1 up and use the existing optionClicked function.
                    var modelTemp = [];
                    var nrLevels = newData.level;
                    for (var level = nrLevels; level > 0; --level) {
                        newData._links.self.href = newData._links.self.href.replace('{?projection}', ''); //adjust the id
                        modelTemp[level] = newData;
                        newData = newData.parent;
                    }

                    angular.forEach(modelTemp, function (item, index) {
                        if (item) {
                            if (index - 1 == 0) {
                                //show the first one
                                scope.showns[0] = true;
                            }
                            scope.model[index - 1] = item;
                            scope.optionClicked(item);
                        }
                    });
                }
            }, true);

            scope.showns[0] = true;
            element.html(generateTemplate(scope.numberOfLevels, scope.titlesArray || scope.title));
            $compile(element.contents())(scope);
        }

        function generateTemplate(numberOfLevels, titles) {
            // titles can be string or array
            var singleTpl = '\
<md-input-container ng-show="showns[_level_]">\
    <label>_label_</label>\
    <md-select ng-model="model[_level_]" ng-model-options="{trackBy: \'$value._links.self.href\'}">\
        <md-option ng-value="choice" ng-click="optionClicked(choice)" ng-repeat="choice in choices[_level_]">{{ choice.name }}</md-option>\
    </md-select>\
</md-input-container><br/>\
';
            var nr = parseInt(numberOfLevels, 10);
            var tpl = '';
            var tplPart;
            for (var i = 0; i < nr; i++) {
                tplPart = singleTpl.replace(/_level_/g, i);
                if (angular.isString(titles)) tplPart = tplPart.replace('_label_', titles + ' Level ' + (i + 1));else // array
                    tplPart = tplPart.replace('_label_', titles[i]);
                tpl += tplPart;
            }
            tpl = '<div layout="column">' + tpl + '</div>';
            return tpl;
        }
    });
})();
'use strict';

angular.module('braininstituteApp').factory('Menu', function ($rootScope, $q, $translate, Principal, NewRecordService, NewPatientService, $mdDialog, $timeout, $mdSidenav, $mdMedia, responsiveDesignService, $mdComponentRegistry, tekstackSecurityService, MenuSecurityService, _) {
    var menuId = 'navbar';
    var _pages = [];

    function getPageName(key) {
        /* For BRAIN-454 (async issue), I'm changing to returning key
         * instead of name here, and moving the translation action to
         * menulink.html (view layer) so async will be dealt with auto.
         */
        // return $translate.instant(key);
        return key;
    }

    //Close menu listener
    $rootScope.$on('closeMenu', function () {
        closeMainNav();
    });

    function closeMainNav() {
        $mdComponentRegistry.when(menuId).then(function (leftSidenav) {
            leftSidenav.close();
        });
    }

    function toggleSideNav() {
        $mdComponentRegistry.when(menuId).then(function (leftSidenav) {
            leftSidenav.toggle();
        });
    }

    function isMobile() {
        return $mdMedia('xs') || $mdMedia('sm') ? true : false;
    }

    //Open populated edit user form
    function currentUser() {
        Principal.identity().then(function (account) {
            if (isMobile()) {
                closeMainNav();
            }
            $mdDialog.show({
                controller: 'UserPersonalController',
                templateUrl: 'app/components/user-management/user-personal-info-form.html',
                fullscreen: responsiveDesignService.mdDialogFullScreen(),
                locals: {
                    userUrl: account._links.self.href
                },
                parent: angular.element(document.body),
                clickOutsideToClose: true,
                resolve: {
                    translatePartialLoader: function translatePartialLoader($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('users');
                        $translate.refresh();
                    }
                }
            }).then(function (result) {
                if (!isMobile() && result && result == 'success') {
                    closeMainNav();
                }
            }, function () {
                // closeMainNav();
            });
        });
    }

    return {
        createPages: function createPages() {

            _pages = [];

            //add security pages
            _pages = _.concat(_pages, MenuSecurityService.pages());

            if (!Principal.isAuthenticated()) {
                _pages.push({
                    order: 1,
                    name: getPageName('global.menu.landing'),
                    click: function click() {
                        window.location.href = '/';
                    },
                    icon: 'action:ic_home_24px'
                });
            } else {
                var isCoordinator = Principal.isInRole('OP_COORDINATOR');

                var isInvestigator = Principal.isInRole('OP_INVESTIGATOR');

                _pages.push({
                    order: 1,
                    name: getPageName('global.menu.adminTools.search'),
                    url: 'search',
                    icon: 'action:ic_search_24px'
                });

                if (isInvestigator) {
                    _pages.push({
                        order: 2,
                        name: getPageName('global.menu.adminTools.requests'),
                        url: 'requests',
                        icon: 'content:ic_mail_24px'
                    });
                }

                if (isCoordinator) {
                    _pages.push({
                        order: 3,
                        name: 'Add Sample',
                        click: function click() {
                            var callback = closeMainNav;
                            if (isMobile()) {
                                closeMainNav();
                                callback = null;
                            }
                            NewRecordService.showNewRecordDialog(null, callback);
                        },
                        icon: 'content:ic_add_24px'
                    }, {
                        order: 4,
                        name: 'Add Patient',
                        click: function click() {
                            var callback = closeMainNav;
                            if (isMobile()) {
                                closeMainNav();
                                callback = null;
                            }
                            NewPatientService.showNewPatientDialog(null);
                        },
                        icon: 'content:ic_add_24px'
                    }, {
                        order: 5,
                        name: getPageName('global.menu.adminTools.userManagement'),
                        url: 'users',
                        icon: 'social:ic_person_24px'
                    });
                }

                _pages.push({
                    order: 6,
                    name: getPageName('global.menu.adminTools.documents'),
                    url: 'documents',
                    icon: 'file:ic_folder_24px'
                }, {
                    order: 7,
                    name: getPageName('global.menu.account.myProfile'),
                    click: currentUser,
                    icon: 'action:ic_settings_24px'
                });
            }

            _pages = _.orderBy(_pages, ['order'], ['asc']);
        },
        addPages: function addPages(newPages) {
            if (Array.isArray(newPages)) {
                Array.prototype.push.apply(_pages, newPages);
            }
        },
        pages: function pages() {
            return _pages;
        },
        close: closeMainNav,
        toggleSideNav: toggleSideNav
    };
});
'use strict';

angular.module('braininstituteApp').directive('userInfo', function () {
    return {
        scope: {
            user: '='
        },
        templateUrl: 'app/components/navbar/template/userinfo.html'
    };
});
/**
 * Created by User on 6/10/2016.
 */
'use strict';

angular.module('tcincCommon').controller('ToastCtrl', function (locals) {
    var vm = this;

    vm.message = locals.message;
});
'use strict';

/**
 * Created by Daniel Costa <danielcosta123@gmail.com> on 8/17/2015.
 */
(function () {
    'use strict';

    angular.module('braininstituteApp').factory('WebService', ['$resource', 'DateUtils', function ($resource, DateUtils) {
        return {
            RequestOpenByUserAndSampleId: $resource('/api/requestOpenByUserAndSampleId/:sampleId', { sampleId: '@sampleId' }, {
                'get': {
                    method: 'GET',
                    isArray: false,
                    transformResponse: function transformResponse(data) {
                        return { value: data };
                    }
                }
            }),
            HistoriesByRequest: $resource('/api/requestHistories/search/requestHistories?projection=logs', {}, {}),
            RequestsActiveForSampleInfo: $resource('/api/requestsFindActiveForSampleInfo')
        };
    }]);
})();
'use strict';

angular.module('braininstituteApp').filter('characters', function () {
    return function (input, chars, breakOnWord) {
        if (isNaN(chars)) {
            return input;
        }
        if (chars <= 0) {
            return '';
        }
        if (input && input.length > chars) {
            input = input.substring(0, chars);

            if (!breakOnWord) {
                var lastspace = input.lastIndexOf(' ');
                // Get last space
                if (lastspace !== -1) {
                    input = input.substr(0, lastspace);
                }
            } else {
                while (input.charAt(input.length - 1) === ' ') {
                    input = input.substr(0, input.length - 1);
                }
            }
            return input + '...';
        }
        return input;
    };
}).filter('words', function () {
    return function (input, words) {
        if (isNaN(words)) {
            return input;
        }
        if (words <= 0) {
            return '';
        }
        if (input) {
            var inputWords = input.split(/\s+/);
            if (inputWords.length > words) {
                input = inputWords.slice(0, words).join(' ') + '...';
            }
        }
        return input;
    };
});
'use strict';

(function () {
    'use strict';

    angular.module('tcincCommon').factory('treeviewService', function (ivhTreeviewMgr, ivhTreeviewBfs) {
        var nodeTpl = ['  <div title="{{trvw.label(node)}}">', '    <span ivh-treeview-toggle>', '      <span ivh-treeview-twistie></span>', '    </span>', '    <span ng-if="trvw.useCheckboxes()" ivh-treeview-md-checkbox></span>', '    <span class="ivh-treeview-node-label" ivh-treeview-toggle>', '      {{trvw.label(node)}}', '    </span>', '  <div ivh-treeview-children ng-if="trvw.isExpanded(node)"></div>', '  </div>'].join('\n');

        var treeviewOpts = {
            nodeTpl: nodeTpl,
            onToggle: toggleHandler,
            labelAttribute: 'name',
            defaultSelectedState: false,
            twistieCollapsedTpl: '<md-icon md-svg-icon="navigation:ic_chevron_right_24px"></md-icon>',
            twistieExpandedTpl: '<md-icon md-svg-icon="navigation:ic_expand_more_24px"></md-icon>',
            twistieLeafTpl: '<md-icon></md-icon>'
        };

        return {
            treeviewOpts: treeviewOpts,
            createTreeFromServerArray: createTreeFromServerArray,
            getMinFlat: getMinFlat,
            getMaxTree: getMaxTree,
            getSelectionSummaryText: getSelectionSummaryText
        };

        function treeify(list, idAttr, parentAttr, childrenAttr) {
            if (!idAttr) idAttr = 'id';
            if (!parentAttr) parentAttr = 'parent';
            if (!childrenAttr) childrenAttr = 'children';

            var treeList = [];
            var lookup = {};
            list.forEach(function (obj) {
                lookup[obj[idAttr]] = obj;
                obj[childrenAttr] = [];
            });
            list.forEach(function (obj) {
                if (obj[parentAttr] != null) {
                    lookup[obj[parentAttr]][childrenAttr].push(obj);
                } else {
                    treeList.push(obj);
                }
            });
            return treeList;
        }

        function createTreeFromServerArray(serverArray) {
            return treeify(serverArray, 'id', 'parentId');
        }

        function getMinFlat(tree) {
            var result = [];
            ivhTreeviewBfs(tree, null, function (node, parents) {
                if (node && node.selected) {
                    // going breadth-first top-down, stop going deeper when you see a selected node because it
                    // means any children, if they exist, will also be selected but not wanted to be sent to server.
                    result.push(node);
                    return false;
                }
            });
            return result;
        }

        /**
         * ...
         * @param tree
         * @param settings: in the result we include indeterminate selections too. If settings has the key
         *  includeSpecialDataForSearchJson as true, this will add an extra key about whether that node was such.
         *  This was added so that search service can decide whether to add itself as its own child for JSON
         *  depending on whether all its children are selected.
         * @returns Array
         */
        function getMaxTree(tree, settings) {
            var myTree = { isRootNode: true, children: tree };

            var result = t.filter(myTree, function (node, par) {
                if (!(node.isRootNode || node.selected || node.__ivhTreeviewIndeterminate)) return false;else {
                    if (settings.includeSpecialDataForSearchJson) return {
                        id: node.id,
                        name: node.name,
                        indeterminate: node.__ivhTreeviewIndeterminate
                    };else return {
                        id: node.id,
                        name: node.name
                    };
                }
            });

            return result.children;
        }

        function getSelectionSummaryText(tree) {
            var minFlat = this.getMinFlat(tree);
            var namesArray = minFlat.map(function (node) {
                return node.name;
            });
            if (namesArray.length > 0) return namesArray.join(', ');
            return '';
        }

        function collapseChildren(tree, node) {
            ivhTreeviewMgr.collapseRecursive(tree, node);
        }

        function toggleHandler(arg) {
            if (arg.ivhIsExpanded === false) {
                collapseChildren(arg.ivhTree, arg.ivhNode);
            }
        }
    });
})();
'use strict';

(function () {
    'use strict';

    angular.module('braininstituteApp').factory('StompService', function ($rootScope, localStorageService, $q, ENV, stompUri) {
        var stompClient = null;
        var subscriber = [];
        var listener = [];
        var connected = $q.defer();

        return {
            connect: function connect() {
                connected = $q.defer();
                var ws_token = localStorageService.get("token").ws_token;

                //add WS token
                var connectionUri = angular.copy(stompUri);
                connectionUri += '?ws_token=' + ws_token;

                var socket = new SockJS(connectionUri, null, { transports: ['websocket'] });
                stompClient = Stomp.over(socket);

                if (ENV == "prod") {
                    stompClient.debug = null;
                }
                stompClient.connect({}, function () {
                    connected.resolve("success");
                }, function (err) {
                    $rootScope.$broadcast("stompDown");
                });
            },
            disconnect: function disconnect() {
                if (stompClient != null) {
                    stompClient.disconnect();
                    stompClient = null;
                }
            },
            subscribe: function subscribe(name) {
                listener[name] = $q.defer();
                connected.promise.then(function () {
                    subscriber[name] = stompClient.subscribe(name, function (data) {
                        listener[name].notify(JSON.parse(data.body));
                    });
                }, null, null);
            },

            unsubscribe: function unsubscribe(name) {
                if (subscriber[name] != null) {
                    subscriber[name].unsubscribe();
                }
            },
            receive: function receive(name) {
                return listener[name].promise;
            }
        };
    });
})();
'use strict';

angular.module('braininstituteApp').factory('StateSetup', function ($rootScope, $window, $state, $translate, Language, Auth, Principal, ENV, VERSION, Menu) {
    return {
        setup: function setup() {
            $rootScope.ENV = ENV;
            $rootScope.VERSION = VERSION;
            $rootScope.$on('$stateChangeStart', function (event, toState, toStateParams) {
                $rootScope.toState = toState;
                $rootScope.toStateParams = toStateParams;

                if (Principal.isIdentityResolved()) {
                    Auth.authorize();
                }

                // Update the language
                Language.getCurrent().then(function (language) {
                    $translate.use(language);
                });
            });

            $rootScope.$on('$stateChangeSuccess', function (event, toState, toParams, fromState, fromParams) {
                var titleKey = 'global.title';

                // Remember previous state unless we've been redirected to login or we've just
                // reset the state memory after logout. If we're redirected to login, our
                // previousState is already set in the authExpiredInterceptor. If we're going
                // to login directly, we don't want to be sent to some previous state anyway
                if (toState.name != 'login' && $rootScope.previousStateName) {
                    $rootScope.previousStateName = fromState.name;
                    $rootScope.previousStateParams = fromParams;
                }

                // Set the page title key to the one configured in state or use default one
                if (toState.data.pageTitle) {
                    titleKey = toState.data.pageTitle;
                }

                $translate(titleKey).then(function (title) {
                    // Change window title with translated one
                    $window.document.title = title;
                });

                Menu.close();
            });

            $rootScope.back = function () {
                // If previous state is 'activate' or do not exist go to 'home'
                if ($rootScope.previousStateName === 'activate' || $state.get($rootScope.previousStateName) === null) {
                    $state.go('search');
                } else {
                    $state.go($rootScope.previousStateName, $rootScope.previousStateParams);
                }
            };
        }
    };
});
'use strict';

/**
 * Created by Eduardo Aleixo <eduardo@translucentcomputing.com> on 07/11/2016.
 */
(function () {
    'use strict';

    angular.module('tcincCommon').factory('responsiveDesignService', function ($mdMedia) {
        var exports = {};

        exports.mdDialogFullScreen = function () {
            return $mdMedia('xs') || $mdMedia('sm') ? true : false;
        };

        return exports;
    });
})();
'use strict';

angular.module('braininstituteApp').factory('Language', function ($q, $http, $translate, LANGUAGES) {
    return {
        getCurrent: function getCurrent() {
            var deferred = $q.defer();
            var language = $translate.storage().get('NG_TRANSLATE_LANG_KEY');

            if (angular.isUndefined(language)) {
                language = 'en';
            }

            deferred.resolve(language);
            return deferred.promise;
        },
        getAll: function getAll() {
            var deferred = $q.defer();
            deferred.resolve(LANGUAGES);
            return deferred.promise;
        }
    };
})

/*
 Languages codes are ISO_639-1 codes, see http://en.wikipedia.org/wiki/List_of_ISO_639-1_codes
 They are written in English to avoid character encoding issues (not a perfect solution)
 */
.constant('LANGUAGES', ['en', 'fr'
//JHipster will add new languages here
]);
'use strict';

angular.module('braininstituteApp').controller('LanguageController', function ($scope, $translate, Language, tmhDynamicLocale) {
    $scope.changeLanguage = function (languageKey) {
        $translate.use(languageKey);
        tmhDynamicLocale.set(languageKey);
    };

    Language.getAll().then(function (languages) {
        $scope.languages = languages;
    });
}).filter('findLanguageFromKey', function () {
    return function (lang) {
        return {
            "en": "English",
            "fr": "Français"
        }[lang];
    };
});
'use strict';

(function () {
    'use strict';

    angular.module('braininstituteApp').factory('formsService', function () {
        var exports = {};

        exports.genders = [{ id: 'M', name: 'Male' }, { id: 'F', name: 'Female' }];

        exports.yesNo = [{ id: true, name: 'Yes' }, { id: false, name: 'No' }];

        exports.getGender = function (genderCode) {
            if (genderCode === 'M') return 'Male';else if (genderCode === 'F') return 'Female';
        };

        return exports;
    });
})();
'use strict';

angular.module('braininstituteApp').service('DateUtils', function () {
    this.convertLocaleDateToServer = function (date) {
        if (date) {
            var utcDate = new Date();
            utcDate.setUTCDate(date.getDate());
            utcDate.setUTCMonth(date.getMonth());
            utcDate.setUTCFullYear(date.getFullYear());
            return utcDate;
        } else {
            return null;
        }
    };

    /**
     *
     * @param year: int
     * @returns {*}
     */
    this.convertLocaleYearToServer = function (year) {
        if (year) {
            var utcDate = new Date();
            utcDate.setUTCDate(1);
            utcDate.setUTCMonth(0);
            utcDate.setUTCFullYear(year);
            return utcDate;
        } else {
            return null;
        }
    };

    this.convertLocaleDateFromServer = function (dateString) {
        if (dateString) {
            var dateParts = dateString.split('-');
            return new Date(dateParts[0], dateParts[1] - 1, dateParts[2]);
        }
        return null;
    };

    this.convertLocaleYearFromServer = function (dateString) {
        if (dateString) {
            var dateParts = dateString.split('-');
            return parseInt(dateParts[0], 10);
        }
        return null;
    };

    this.convertDateTimeFromServer = function (date) {
        if (date) {
            return new Date(date);
        } else {
            return null;
        }
    };
});
'use strict';

/**
 * Created by Daniel Costa <danielcosta123@gmail.com> on 10/22/2015.
 */
(function () {
    'use strict';

    angular.module('tcincCommon').factory('dateService', function () {
        var exports = {};

        //Converts the text on the month-input to a date string
        /**
         * We used to be sending a date object with time zone here, but as the server
         * is truncating that information and saving incorrect dates on occasions with
         * more eastern time zones, now I'm updating here to send a string instead, so
         * it will be assumed by the server to be in its local time zone. This way at least
         * both sides have the same assumption.
         */
        exports.monthInputToDate = function (text) {
            return moment(text + '-01').toDate();
            // return text + '-01';
        };

        exports.dateToMonthInput = function (date) {
            if (date) return moment(date).format('YYYY-MM');
        };

        return exports;
    });
})();
'use strict';

angular.module('braininstituteApp').factory('CacheSetup', function ($http, CacheFactory) {
    return {
        setup: function setup() {
            //Set up cache factory - default cache setup
            if (!CacheFactory.get('defaultCache')) $http.defaults.cache = CacheFactory('defaultCache', {
                maxAge: 15 * 60 * 1000, // Items added to this cache expire after 15 minutes
                cacheFlushInterval: 60 * 60 * 1000, // This cache will clear itself every hour
                deleteOnExpire: 'aggressive' // Items will be deleted from this cache when they expire
            });

            //Setup for long lived cache
            if (!CacheFactory.get('longLivedCache')) CacheFactory('longLivedCache', {
                maxAge: 7 * 24 * 60 * 60 * 1000, // Items added to this cache expire after 5 days
                cacheFlushInterval: 5 * 24 * 60 * 60 * 1000, // This cache will clear itself every 5 days
                deleteOnExpire: 'aggressive' // Items will be deleted from this cache when they expire
            });
        }
    };
});
/*jshint bitwise: false*/
'use strict';

angular.module('braininstituteApp').service('Base64', function () {
    var keyStr = 'ABCDEFGHIJKLMNOP' + 'QRSTUVWXYZabcdef' + 'ghijklmnopqrstuv' + 'wxyz0123456789+/' + '=';
    this.encode = function (input) {
        var output = '',
            chr1,
            chr2,
            chr3 = '',
            enc1,
            enc2,
            enc3,
            enc4 = '',
            i = 0;

        while (i < input.length) {
            chr1 = input.charCodeAt(i++);
            chr2 = input.charCodeAt(i++);
            chr3 = input.charCodeAt(i++);

            enc1 = chr1 >> 2;
            enc2 = (chr1 & 3) << 4 | chr2 >> 4;
            enc3 = (chr2 & 15) << 2 | chr3 >> 6;
            enc4 = chr3 & 63;

            if (isNaN(chr2)) {
                enc3 = enc4 = 64;
            } else if (isNaN(chr3)) {
                enc4 = 64;
            }

            output = output + keyStr.charAt(enc1) + keyStr.charAt(enc2) + keyStr.charAt(enc3) + keyStr.charAt(enc4);
            chr1 = chr2 = chr3 = '';
            enc1 = enc2 = enc3 = enc4 = '';
        }

        return output;
    };

    this.decode = function (input) {
        var output = '',
            chr1,
            chr2,
            chr3 = '',
            enc1,
            enc2,
            enc3,
            enc4 = '',
            i = 0;

        // remove all characters that are not A-Z, a-z, 0-9, +, /, or =
        input = input.replace(/[^A-Za-z0-9\+\/\=]/g, '');

        while (i < input.length) {
            enc1 = keyStr.indexOf(input.charAt(i++));
            enc2 = keyStr.indexOf(input.charAt(i++));
            enc3 = keyStr.indexOf(input.charAt(i++));
            enc4 = keyStr.indexOf(input.charAt(i++));

            chr1 = enc1 << 2 | enc2 >> 4;
            chr2 = (enc2 & 15) << 4 | enc3 >> 2;
            chr3 = (enc3 & 3) << 6 | enc4;

            output = output + String.fromCharCode(chr1);

            if (enc3 !== 64) {
                output = output + String.fromCharCode(chr2);
            }
            if (enc4 !== 64) {
                output = output + String.fromCharCode(chr3);
            }

            chr1 = chr2 = chr3 = '';
            enc1 = enc2 = enc3 = enc4 = '';
        }

        return output;
    };
});
'use strict';

/**
 * Created by Daniel on 4/13/2015.
 */
(function () {
    'use strict';

    angular.module('braininstituteApp').factory('AlertService', function ($mdToast, $mdDialog, $q) {

        function _showConfirm(title, message) {
            var confirm = $mdDialog.confirm().title(title).textContent(message).ariaLabel(title).ok('Yes').cancel('No');
            var q = $q.defer();
            $mdDialog.show(confirm).then(function () {
                q.resolve();
            }, function () {
                q.reject();
            });
            return q.promise;
        }

        function _showAction(title, message, actionText) {
            var alert = $mdDialog.alert().clickOutsideToClose(false).title(title).ariaLabel(title).textContent(message).ok(actionText);
            var q = $q.defer();
            $mdDialog.show(alert).then(function () {
                q.resolve();
            }, function () {
                q.reject();
            });
            return q.promise;
        }

        return {
            showInputMessageDialog: function showInputMessageDialog(title, label) {
                var deferred = $q.defer();
                $mdDialog.show({
                    controller: 'inputDialogController',
                    template: '<md-dialog style="padding: 30px"> <form name="messageForm" ng-submit="messageForm.$valid && done()" novalidate> ' + '<md-dialog-content> <h1 class="md-title">' + title + '</h1> ' + '<md-input-container> <label>' + label + '</label> ' + '<input type="text" ng-model="message" required/> ' + '</md-input-container> </md-dialog-content> ' + '<div class="md-actions"> <md-button type="submit" class="md-primary">Done </md-button> ' + '</div> </form> </md-dialog>',
                    clickOutsideToClose: true
                }).then(function (message) {
                    deferred.resolve(message);
                });
                return deferred.promise;
            },
            showAlert: function showAlert(title, message) {
                $mdDialog.show($mdDialog.alert().clickOutsideToClose(true).title(title).textContent(message).ariaLabel(message).ok('Close'));
            },
            showError: function showError(error) {
                var alert = $mdDialog.alert().title(error.statusText).textContent(error.data.message).ok('Close');
                $mdDialog.show(alert).finally(function () {
                    alert = undefined;
                });
            },
            toastSuccess: function toastSuccess(message) {
                return $mdToast.show({
                    hideDelay: 3000,
                    position: 'top right',
                    controller: 'ToastCtrl as ctrl',
                    templateUrl: 'app/shared/toasts/toast-success.html',
                    parent: angular.element(document.querySelector('#content')),
                    locals: { message: message }
                });
            },
            toastWarning: function toastWarning(message) {
                return $mdToast.show({
                    hideDelay: 3000,
                    position: 'top right',
                    controller: 'ToastCtrl as ctrl',
                    templateUrl: 'app/shared/toasts/toast-warning.html',
                    parent: angular.element(document.querySelector('#content')),
                    locals: { message: message }
                });
            },
            toastInfo: function toastInfo(message) {
                return $mdToast.show({
                    hideDelay: 3000,
                    position: 'top right',
                    controller: 'ToastCtrl as ctrl',
                    templateUrl: 'app/shared/toasts/toast-info.html',
                    parent: angular.element(document.querySelector('#content')),
                    locals: { message: message }
                });
            },
            toastError: function toastError(message) {
                return $mdToast.show({
                    hideDelay: 3000,
                    position: 'top right',
                    controller: 'ToastCtrl as ctrl',
                    templateUrl: 'app/shared/toasts/toast-error.html',
                    parent: angular.element(document.querySelector('#content')),
                    locals: { message: message }
                });
            },
            toast: function toast(message) {
                return $mdToast.show($mdToast.simple().content(message).parent(angular.element(document.querySelector('#content'))).position('top right').hideDelay(3000));
            },
            showAction: function showAction(title, message, actionText) {
                return _showAction(title, message, actionText);
            },
            showDeleteConfirm: function showDeleteConfirm(entity, name) {
                return _showConfirm('Delete ' + entity, 'Are you sure you want to delete ' + angular.lowercase(entity) + ": " + name + "?");
            },
            showConfirm: function showConfirm(title, message) {
                return _showConfirm(title, message);
            }

        };
    });
})();
'use strict';

/**
 * Created by Daniel Costa <danielcosta123@gmail.com> on 9/21/2015.
 */
(function () {
    'use strict';

    angular.module('tcincCommon').controller('inputDialogController', inputDialogController);

    function inputDialogController($scope, $mdDialog, $log) {
        $scope.done = function () {
            $log.debug($scope.message);
            $mdDialog.hide($scope.message);
        };
    }
})();
/**
 * Created by Daniel on 4/6/2015.
 */
'use strict';

(function () {
    'use strict';

    angular.module('braininstituteApp').filter('userRole', function () {
        return function (users, authorities) {
            if (!users || users.length == 0) return [];

            //users = All the users
            //authorities = the authorities of the selected tab
            var result = [];

            _.forEach(users, function (user) {
                if (authorities.length == 1 && authorities[0] == 'ROLE_USER') {
                    //Collect users that have only USER role
                    if (user.groups.length == 1 && user.groups[0].name == 'ROLE_USER') {
                        result.push(user);
                    }
                } else {
                    for (var x = 0; x < user.groups.length; x++) {
                        if (_.contains(authorities, user.groups[x].name)) {
                            result.push(user);
                            break;
                        }
                    }
                }
            });

            return result;
        };
    }).filter('parent', function () {
        return function (data, parent) {
            var result = [];
            _.forEach(data, function (item) {
                if (item.parent.id == parent.id) {
                    result.push(item);
                }
            });
            return result;
        };
    }).filter('arrayToList', function () {
        return function (arr) {
            return arr.join(',');
        };
    }).filter('bytes', function () {
        return function (bytes, precision) {
            if (isNaN(parseFloat(bytes)) || !isFinite(bytes)) return '-';
            if (typeof precision === 'undefined') precision = 1;
            var units = ['bytes', 'kB', 'MB', 'GB', 'TB', 'PB'],
                number = Math.floor(Math.log(bytes) / Math.log(1024));
            return (bytes / Math.pow(1024, Math.floor(number))).toFixed(precision) + ' ' + units[number];
        };
    });
})();
'use strict';

angular.module('braininstituteApp').factory('ErrorInterceptor', function ($rootScope, $q) {
    var errorInterceptor = {};

    errorInterceptor.responseError = function (response) {
        if (!(response.status == 401 && response.data.path && response.data.path.indexOf("/api/account") > -1)) {
            $rootScope.$emit('braininstituteApp.httpError', response);
        }
        return $q.reject(response);
    };

    return errorInterceptor;
});
'use strict';

angular.module('braininstituteApp').config(function ($stateProvider) {
    $stateProvider.state('error', {
        parent: 'site',
        url: '/error',
        data: {
            authorities: [],
            pageTitle: 'error.title'
        },
        views: {
            'content@': {
                templateUrl: 'app/error/error.html'
            }
        },
        resolve: {
            mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                $translatePartialLoader.addPart('error');
                return $translate.refresh();
            }]
        }
    }).state('accessdenied', {
        parent: 'site',
        url: '/accessdenied',
        data: {
            authorities: []
        },
        views: {
            'content@': {
                templateUrl: 'app/error/accessdenied.html'
            }
        },
        resolve: {
            mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                $translatePartialLoader.addPart('error');
                return $translate.refresh();
            }]
        }
    });
});
'use strict';

/*
 * Users Controller
 */
(function () {
    'use strict';

    angular.module('braininstituteApp').config(function ($stateProvider) {
        $stateProvider.state('users', {
            parent: 'site',
            url: '/users',
            data: {
                authorities: ['OP_COORDINATOR'],
                pageTitle: 'braininstituteApp.user.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/components/user-management/users.html',
                    controller: 'UsersController as usersCtrl'
                }
            },
            resolve: {
                translatePartialLoader: function translatePartialLoader($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('users');
                    $translatePartialLoader.addPart('document');
                    return $translate.refresh();
                }
            }
        });
    });
})();
'use strict';

/*
 * Users Controller
 */
(function () {
    'use strict';

    angular.module('braininstituteApp').controller('UsersController', function (User, $mdDialog, $scope, $state, $log, AlertService, EntitiesUtil, Principal, responsiveDesignService) {
        var vm = this;

        vm.showDisabledUsers = false; // by default the switch is turned off

        this.loadAll = function () {
            //Get all users
            if (Principal.isAdmin()) {
                User.getAllForAdmin().then(function (data) {
                    $scope.users = data;
                });
            } else {
                User.getAllForCoordinator().then(function (data) {
                    $scope.users = data;
                });
            }
        };

        this.unlockUser = function (email) {
            User.unlockUser(email).then(function () {
                vm.loadAll();
            }, function (err) {
                AlertService.showError(err);
            });
        };

        this.setupTabs = function () {
            $scope.tabs = [{ label: 'Users' }];
            $scope.selectedIndex = 0;
            $scope.switchTab = function (index) {
                $scope.selectedIndex = index;
            };
        };

        this.uploadProtocol = function (user) {
            $mdDialog.show({
                controller: "DocumentUploadController",
                templateUrl: 'app/document/file-form.html',
                fullscreen: responsiveDesignService.mdDialogFullScreen(),
                locals: {
                    category: 'User Protocol',
                    forUser: parseInt(user._links.self.href.substring(user._links.self.href.lastIndexOf('/') + 1)),
                    share: false
                },
                parent: angular.element(document.body),
                clickOutsideToClose: true
            });
        };

        this.init = function () {
            this.loadAll();
            this.setupTabs();
        };

        this.init();

        //Open empty edit user form
        this.goCreateUser = function () {
            showUserDialog(false, null);
        };

        //Open populated edit user form
        this.goEditUser = function (user) {
            var url = user._links.self.href;
            if (url) {
                showUserDialog(url);
            } else {
                AlertService.showAlert('User Error', 'User not found.');
            }
        };

        function showUserDialog(url) {
            $mdDialog.show({
                controller: 'UserEditController',
                templateUrl: 'app/components/user-management/user-form.html',
                locals: {
                    userUrl: url
                },
                parent: angular.element(document.body),
                fullscreen: responsiveDesignService.mdDialogFullScreen(),
                clickOutsideToClose: true
            }).then(function (result) {
                if (result && result == 'success') {
                    vm.loadAll();
                }
            }, function () {
                //cancelled
            });
        }

        //Delete user
        this.deleteUser = function (user) {
            AlertService.showConfirm("Delete", "Are you sure you want to remove this user from active users? The user will not have access to the application anymore. " + user.email).then(function () {
                EntitiesUtil.get(user._links.self.href).then(function (data) {
                    EntitiesUtil.delete(data._links.self.href).then(function () {
                        vm.loadAll();
                        AlertService.toastSuccess("Deleted with success!");
                    }, function (error) {
                        if (error.status == 409) {
                            AlertService.showAlert('This user has records in the system and can not be deleted. Instead, you can disable this user.');
                        } else {
                            AlertService.showAlert('Error Deleting User', error.message ? error.message : error);
                        }
                        $log.debug(error);
                    });
                });
            });
        };

        //Reset Password
        this.resetPass = function () {
            AlertService.showConfirm("Password Reset", "Do you want to reset user password?").then(function () {
                UserService.resetPass($scope.user.id, $scope.user.email).then(function (data) {}, function (error) {
                    AlertService.showAlert('User Error', 'Error resetting user password.');
                });
            });
        };
    });
})();
'use strict';

(function () {
    'use strict';

    angular.module('braininstituteApp').factory('UserService', function (User, Authority) {

        /*
         Convert the dot in email for safe url
         */
        function encodeEmail(email) {
            return encodeURIComponent(email.replace(/\./g, '&#46;'));
        }

        return {
            getAll: function getAll() {
                return User.query({}).$promise;
            },
            getUser: function getUser(id) {
                return User.get({ "id": id }).$promise;
            },
            saveUpdateUser: function saveUpdateUser(user) {
                return User.update(user).$promise;
            },
            deleteUser: function deleteUser(userId) {
                return User.delete({ id: userId }).$promise;
            },
            resetPass: function resetPass(id, email) {
                return User.resetPass({ id: id, email: email, resetPass: true }).$promise;
            },
            userSearch: function userSearch(query) {
                return User.search({ query: query }).$promise;
            },
            getAuthorities: function getAuthorities() {
                return Authority.query().$promise;
            }
        };
    });
})();
'use strict';

(function () {
    'use strict';

    angular.module('braininstituteApp').controller('UserPersonalController', function ($http, $scope, $rootScope, $translate, $mdDialog, $log, EntitiesUtil, Authority, AlertService, userUrl, User, localStorageService) {
        $scope.user = {};

        $scope.init = function () {
            EntitiesUtil.get(userUrl, 'customUserEdit').then(function (data) {
                data.groups = null;
                $scope.user = data;
            }, function () {
                $scope.cancel();
            });
        };

        $scope.init();

        $scope.addUser = function () {
            if (!$scope.userForm.$valid) return;
            $scope.user.langKey = $translate.use();
            $scope.isSubmitting = true;

            var user = angular.copy($scope.user);
            delete user._resources;
            delete user._links;
            delete user.role;

            var etag = localStorageService.get('etag-' + EntitiesUtil.removeBaseUri(userUrl));

            User.updatePersonalData(user, etag).then(function (response) {
                $mdDialog.hide('success');
                AlertService.toastSuccess($translate.instant('braininstituteApp.user.messages.success'));
            }, function (response) {
                $scope.isSubmitting = false;
                AlertService.toastError($translate.instant('braininstituteApp.user.messages.error.fail'));
            });
        };

        $scope.cancel = function () {
            $mdDialog.cancel();
        };
    });
})();
'use strict';

(function () {
    'use strict';

    angular.module('braininstituteApp').controller('UserEditController', function ($http, $scope, $timeout, $rootScope, $translate, $q, $mdDialog, $log, SiteLocation, EntitiesUtil, Authority, AlertService, userUrl, Principal, User, Upload, UserAdditional) {
        $scope.isEditing = !!userUrl;

        $scope.user = {};

        $scope.init = function () {
            $scope.isAdmin = Principal.isAdmin();

            //If the user is not admin, he can only create users for his own location, so the location is fixed
            if (!$scope.isAdmin) {
                Principal.identity().then(function (user) {
                    user.siteLocation._links.self.href = user.siteLocation._links.self.href.replace("{?projection}", "");
                    $scope.user.siteLocation = user.siteLocation;
                });
            } else {
                //if the user is admin we should load all Locations
                SiteLocation.resource.query(function (data) {
                    $scope.locations = data._embeddedItems;
                });
            }

            Authority.getAll().then(function (data) {
                $scope.authorities = data;
                //remove admin role if user is not admin
                if (!Principal.isInRole('OP_ADMIN')) {
                    _.remove($scope.authorities, function (item) {
                        return item.name == "ADMIN";
                    });
                }
            });

            if ($scope.isEditing) {
                EntitiesUtil.get(userUrl, 'customUserEdit').then(function (data) {

                    data.siteLocation._links.self.href = data.siteLocation._links.self.href.replace('{?projection}', ''); //adjust the id
                    $scope.user = data;

                    data.groups[0]._links.self.href = data.groups[0]._links.self.href.replace('{?projection}', ''); //adjust the id
                    $scope.user.role = data.groups[0]; //only one group
                    $scope.disableEdit = !$scope.isAdmin && Principal.isAdmin($scope.user.role.name);
                }, function () {
                    $scope.cancel();
                });
            } else {
                $scope.user.activated = false;
            }
        };

        $scope.init();

        $scope.addUser = function () {
            if (!$scope.userForm.$valid) return;
            $scope.user.langKey = $translate.use();
            $scope.isSubmitting = true;

            var user = angular.copy($scope.user);
            delete user._resources;
            delete user._links;

            user.groups = [user.role._links.self.href];
            delete user.role;

            user.additional = {
                siteLocation: user.siteLocation._links.self.href,
                dtype: "additional",
                '@class': "com.translucentcomputing.braininstitute.domain.security.UserAdditional"
            };

            if (userUrl) {
                EntitiesUtil.update(userUrl, user).then(function (response) {
                    //After the user was updated, Update the User additional
                    $mdDialog.hide('success');
                    AlertService.toastSuccess($translate.instant('braininstituteApp.user.messages.success'));
                }, function (response) {
                    $scope.isSubmitting = false;
                    if (response.status === 400 && response.headers('Failure') === 'e-mail already in use') {
                        AlertService.toastError($translate.instant('braininstituteApp.user.messages.error.emailexists'));
                    } else {
                        AlertService.toastError($translate.instant('braininstituteApp.user.messages.error.fail'));
                    }
                });
            } else {
                user.enabled = true;
                User.create(user).then(function (response) {
                    $mdDialog.hide('success');
                    AlertService.toastSuccess($translate.instant('braininstituteApp.user.messages.success'));
                }, function (error) {
                    $scope.isSubmitting = false;
                    if (error.status === 422) {
                        AlertService.toastError($translate.instant('braininstituteApp.user.messages.error.emailexists'));
                    } else {
                        AlertService.toastError($translate.instant('braininstituteApp.user.messages.error.fail'));
                    }
                });
            }
        };

        $scope.cancel = function () {
            $mdDialog.cancel();
        };
    });
})();
'use strict';

(function () {
    'use strict';

    angular.module('braininstituteApp').directive('emailUniqueValidator', function ($q, User) {
        return {
            require: 'ngModel',
            scope: {
                euvDisableValidation: '='
            },
            link: function link(scope, element, attrs, ngModel) {
                scope.$watch('euvDisableValidation', function (newValue, oldValue) {
                    /* We need to disable this validator when this disable argument
                       evaluates to true.
                       When
                       case 1: a new user is being added, or
                       case 2: a non-validated user is being edited,
                       we need to validate. newValue in watch will be false.
                       When
                       case 3: a validated user is being edited, email field is read-only,
                       and it will always seem to be invalid if checked with server
                       (because of the existing same user record), so we disable it.
                       
                       It has to be a watch because user record loading is async in the page.
                        The argument is required and must be bound to a true or false value,
                       because in any case watch starts with undefined value, which we skip.
                     */
                    if (newValue === true) ngModel.$asyncValidators.emailUnique = noop;else if (newValue === false) ngModel.$asyncValidators.emailUnique = User.verifyEmailUnique;
                });
            }
        };

        function noop() {
            return $q(function (resolve) {
                resolve();
            });
        }
    });
})();
'use strict';

angular.module('braininstituteApp').controller('NavbarController', function ($scope, Menu, $mdDialog, Auth, Principal, StompService, Idle, $state, $log, AlertService, NotificationDirectiveSupport) {
    var vm = this;

    //menu
    $scope.menu = Menu;
    $scope.isAuthenticated = Principal.isAuthenticated;

    //If a page refresh happens with the user logged in, we restart the idle
    if (Principal.isAuthenticated()) {
        Idle.watch();
    }

    $scope.$on('IdleStart', function () {
        $log.debug('start');
        // the user appears to have gone idle
    });

    $scope.$on('IdleWarn', function (e, countdown) {
        $log.debug('warn');
        //This will be called every second in the warn period, so let's not show every second.
        if (countdown % 2 == 0) //let's show every 2 seconds
            AlertService.toastWarning("You have been idle from the app for so long. You will be logged out in " + countdown + " seconds.");
        // follows after the IdleStart event, but includes a countdown until the user is considered timed out
        // the countdown arg is the number of seconds remaining until then.
        // you can change the title or display a warning dialog from here.
        // you can let them resume their session by calling Idle.watch()
    });

    $scope.$on('IdleTimeout', function () {
        $log.debug('timeout');
        // the user has timed out (meaning idleDuration + timeout has passed without any activity)
        // this is where you'd log them
        NotificationDirectiveSupport.setNotInitialized(); //resets the var that control if the stomp was initialized, so that on next login, it restarts
        StompService.disconnect();
        Auth.logout(); //log out of the app
        $state.go("login", { code: 1 }); //goes to login page showing message
    });

    $scope.$on('IdleEnd', function () {
        $log.debug('end');
        // the user has come back from AFK and is doing stuff. if you are warning them, you can use this to hide the dialog
    });
});
'use strict';

(function () {
    'use strict';

    angular.module('braininstituteApp').factory('SearchService', function ($q, treeviewService, $http, $rootScope, DateUtils, dateService, localStorageService) {
        var sharedMessage = {
            field: '',
            value: ''
        };

        var inputTypeEnum = {
            HierarchicalMultiple: 1,
            String: 2,
            RangeMonth: 3,
            SelectMultiple: 4,
            RangeNumber: 5,
            SelectSingle: 6
        };

        var inputs;

        return {
            resetFormBroadcast: broadcastForm,
            resetSearchBroadcast: broadcastSearch,
            getSharedMessage: getSharedMessage,
            createSearchJson: createSearchJson,
            prepareInput: prepareInput,
            prepareSelectSingle: prepareSelectSingle,
            prepareSelectMultiple: prepareSelectMultiple,
            prepareDate: prepareDate,
            prepareNumberRange: prepareNumberRange,
            prepareDateRange: prepareDateRange,
            prepareDependentDropdown: prepareDependentDropdown,
            prepareHierarchicalMultiple: prepareHierarchicalMultiple,
            search: search,
            getSearchAllDTO: getSearchAllDTO,
            getItemsPerPage: getItemsPerPage,
            initInputs: initInputs,
            loadInputConfig: loadInputConfig,
            clearInputGroup: clearInputGroup,
            clearAllInputs: clearAllInputs,
            isInputEmpty: isInputEmpty,
            countNonEmptyInputsInGroup: countNonEmptyInputsInGroup
        };

        function broadcastForm(field, value) {
            sharedMessage.field = field;
            sharedMessage.value = value;
            $rootScope.$broadcast('resetSearchForm');
        }

        /**
         *
         * @param goToSearch go to state
         */
        function broadcastSearch(goToSearch) {
            $rootScope.$broadcast('resetSearch', { goToSearch: goToSearch });
        }

        function getSharedMessage() {
            return sharedMessage;
        }

        function hasWhiteSpace(s) {
            return (/\s/g.test(s)
            );
        }

        function prepareInput(name, value, type) {
            var nodeType = 'INPUT';

            if (type === 'INPUT_CONTAINING' && hasWhiteSpace(value)) {
                throw 'Please remove the empty space between the words.';
            }

            if (type) nodeType = type;
            if (!_.isEmpty(value)) return {
                name: name,
                type: nodeType,
                values: [{ value: value }]
            };
        }

        /**
         * This takes an object value with field "id" (was taking a number until now)
         */
        function prepareSelectSingle(name, value) {
            if (!(value && value.id)) // don't use _.isEmpty
                return;
            return {
                name: name,
                type: 'SELECT',
                values: [{ value: value.id.toString() }]
            };
        }

        function prepareSelectMultiple(name, value) {
            if (_.isEmpty(value)) return;
            var values = [];
            value.forEach(function (elem) {
                values.push({ value: elem.id });
            });
            return {
                name: name,
                type: 'SELECT_MULTIPLE',
                values: values
            };
        }

        function prepareDate(name, value) {
            if (_.isDate(value)) return {
                name: name,
                type: 'DATE',
                values: [{ value: moment(value).format('YYYY-MM-DD') }]
            };
            if (value && !_.isDate(value)) throw 'non-date input';
        }

        function prepareNumberRange(name, value) {
            if (!value) return;
            var from = value.from;
            var to = value.to;
            if (from && !_.isNumber(from) || to && !_.isNumber(to)) throw 'non-numeric input';
            var haveFrom = _.isNumber(from);
            var haveTo = _.isNumber(to);
            if (!haveFrom && !haveTo) return;
            var resultElemFrom = haveFrom ? { value: from.toString() } : null;
            var result = {
                name: name,
                type: 'NUMBER_RANGE',
                values: [resultElemFrom]
            };
            if (haveTo) result.values.push({ value: to.toString() });
            return result;
        }

        function prepareDateRange(name, value, type) {
            if (!value) return;
            var from = value.from;
            var to = value.to;

            // if month string was given, convert to date here
            if (type === 'month') {
                if (from) from = dateService.monthInputToDate(from);
                if (to) to = dateService.monthInputToDate(to);
            }

            if (from && !_.isDate(from) || to && !_.isDate(to)) throw 'non-date input';
            var haveFrom = _.isDate(from);
            var haveTo = _.isDate(to);
            if (!haveFrom && !haveTo) return;
            var resultElemFrom = haveFrom ? { value: moment(from).format('YYYY-MM-DD') } : null;
            var result = {
                name: name,
                type: 'DATE_RANGE',
                values: [resultElemFrom]
            };
            if (haveTo) result.values.push({ value: moment(to).format('YYYY-MM-DD') });
            return result;
        }

        function prepareDependentDropdown(names, values) {
            if (_.isEmpty(values)) return;
            var input = angular.copy(values);
            var fields = [];
            for (var currLevel; input; input = input.parent) {
                currLevel = input.level;
                fields.push({
                    name: names[currLevel - 1],
                    type: 'SELECT',
                    values: [{ value: input.id.toString() }]
                });
            }
            return fields.reverse();
        }

        //TODO: replace the for loop with recursive call for the childValues
        function prepareHierarchicalSelect(name, values) {
            var field = {};
            if (values) {
                field.name = name;
                field.type = 'SELECT_HIERARCHICAL';
                field.values = [];
                var fieldValue = {};
                var childCount = values.length - 1;
                for (var i = 0, len = values.length; i < len; i++, childCount--) {
                    if (i == 0) {
                        fieldValue.value = values[i];
                    } else {
                        //TODO:this section should be replaced with recursive funciton
                        if (_.has(fieldValue.childValues)) {
                            if (_.has(fieldValue.childValues[0].childValues)) {
                                fieldValue.childValues[0].childValues[0].childValues = [];
                                fieldValue.childValues[0].childValues[0].childValues.push({ value: values[i] });
                            } else {
                                fieldValue.childValues[0].childValues = [];
                                fieldValue.childValues[0].childValues.push({ value: values[i] });
                            }
                        } else {
                            fieldValue.childValues = [];
                            fieldValue.childValues.push({ value: values[i] });
                        }
                    }
                }

                field.values.push(fieldValue);
            }

            return field;
        }

        function prepareHierarchicalMultiple(name, value) {
            var tree = { childValues: treeviewService.getMaxTree(value, { includeSpecialDataForSearchJson: true }) };

            visitDfs(tree, nodeVisitor);

            // This call is explained below before function visitDfs2.
            _.each(tree.childValues, function (child) {
                visitDfs2(child, function nodeVisitor2(node) {
                    if (node.childValues && !node.indeterminate) node.childValues.push({ value: node.value });
                    delete node.indeterminate;
                });
            });

            if (tree.childValues) return {
                name: name,
                type: 'SELECT_MULTIPLE_HIERARCHICAL',
                values: tree.childValues
            };

            function visitDfs(node, func) {
                func(node);

                _.each(node.childValues, function (child) {
                    visitDfs(child, func);
                });
            }

            function nodeVisitor(node) {
                if (node.id) {
                    node.value = node.id.toString();
                    delete node.id;
                }
                if (node.name) delete node.name;
                if (node.children) {
                    node.childValues = node.children;
                    delete node.children;
                }
            }

            /**
             * This was added in addition to / after visitDfs, does an additional depth-first visit to all nodes
             * except top level. The purpose is to add the node's own value as a child value to itself because the
             * server was missing non-leaf results.
             */
            function visitDfs2(node, func) {
                func(node);

                _.each(node.childValues, function (child) {
                    visitDfs2(child, func);
                });
            }
        }

        function createSearchJson(inputs, defaultSortProperty, defaultSortDirection) {
            var fields = [];

            // Sample Information tab
            fields.push(prepareHierarchicalMultiple('diagnosis.id', inputs.sample.diagnosis.value));
            fields.push(prepareHierarchicalMultiple('location.id', inputs.sample.location.value));
            fields.push(prepareInput('code', inputs.sample.code.value, 'INPUT_CONTAINING')); // called "Site Sample ID"
            fields.push(prepareSelectMultiple('moleculars.id', inputs.sample.molecular.value));
            fields.push(prepareHierarchicalMultiple('sampleType.id', inputs.sample.sampleType.value));
            fields.push(prepareDateRange('dtDiagnosis', inputs.sample.dtDiagnosis.value, 'month'));

            // Patient Information tab
            if (!inputs.patient.patientCode.useRaw) {
                fields.push(prepareInput('patient.code', inputs.patient.patientCode.value, 'INPUT_CONTAINING')); // called "Patient ID"
            } else {
                fields.push(prepareInput('patient.codeRaw', inputs.patient.patientCode.value)); // called "Patient ID"
                inputs.patient.patientCode.useRaw = false;
            }
            fields.push(prepareNumberRange('ageAtDiagnosisYear', inputs.patient.ageAtDiagnosisYear.value));
            fields.push(prepareNumberRange('ageAtDiagnosisMonth', inputs.patient.ageAtDiagnosisMonth.value));
            fields.push(prepareNumberRange('patient.lengthOfSurvivalYear', inputs.patient.lengthOfSurvivalYear.value));
            fields.push(prepareNumberRange('patient.lengthOfSurvivalMonth', inputs.patient.lengthOfSurvivalMonth.value));
            fields.push(prepareSelectSingle('patient.fgGender', inputs.patient.gender.value));
            var dtSurgeryForServer = inputs.patient.dtSurgery ? {
                from: DateUtils.convertLocaleYearToServer(inputs.patient.dtSurgery.value.from),
                to: DateUtils.convertLocaleYearToServer(inputs.patient.dtSurgery.value.to)
            } : null;
            fields.push(prepareDateRange('dtSurgery', dtSurgeryForServer));

            // Availability Information tab
            fields.push(prepareSelectMultiple('patient.siteLocation.id', inputs.avail.siteLocation.value));

            if (inputs.avail.siteAvailability.value && inputs.avail.siteAvailability.value.id == true) {
                // use service function
                fields.push(prepareNumberRange('aliquots', inputs.avail.siteAvailability.aliquots));
                //Will get all Y or > 0
                fields.push(prepareInput('containAliquots', 'true'));
            } else if (inputs.avail.siteAvailability.value && inputs.avail.siteAvailability.value.id == false) {
                //Will get all N or 0
                fields.push(prepareInput('containAliquots', 'false'));
            }

            var definedFields = [];
            fields.forEach(function (field) {
                if (field) definedFields.push(field);
            });

            return {
                defaultSortProperty: defaultSortProperty.charAt(0) == '-' ? defaultSortProperty.substr(1) : defaultSortProperty,
                defaultSortDirection: defaultSortProperty.charAt(0) == '-' ? 'desc' : 'asc',
                fields: definedFields
            };
        }

        /*
         * Build the search api URI and post the search object.
         * The success callback is called with data.
         */
        function search(entity, pageNumber, size, sort, searchJSON, sucess, error) {
            var uri = '/api/search/' + entity + "?size=" + size;

            if (pageNumber && pageNumber > 0) {
                //server starts paging from 0
                pageNumber--;
                uri += '&page=' + pageNumber;
            }

            if (sort) {
                //sort by one field support //TODO update this to array to support multiple sort properties
                uri += '&sort=' + (sort.charAt(0) == '-' ? sort.substr(1) : sort) + ',' + (sort.charAt(0) == '-' ? 'desc' : 'asc');
            }

            searchJSON.projection = "sampleLight";

            return $http.post(uri, searchJSON).success(sucess).error(error);
        }

        /**
         * If nor fields are provided the query will return all the records.
         *
         * @param defaultSortProperty  Required default sort, fallback
         * @returns {{defaultSortProperty: *, defaultSortDirection: *, fields: Array}}
         */
        function getSearchAllDTO(defaultSortProperty) {
            if (_.isUndefined(defaultSortProperty) || defaultSortProperty === null) throw new Error("Default sort is required");

            return {
                defaultSortProperty: defaultSortProperty.charAt(0) == '-' ? defaultSortProperty.substr(1) : defaultSortProperty,
                defaultSortDirection: defaultSortProperty.charAt(0) == '-' ? 'desc' : 'asc',
                fields: []
            };
        }

        function getItemsPerPage(window) {
            var navbar = 64;
            var tableHeader = 56;
            var paginationFooter = 56;

            var height = window.innerHeight - (navbar + tableHeader + paginationFooter);

            var itemsPerPage = Math.floor(height / 48);
            if (itemsPerPage < 1) return 1;
            return itemsPerPage;
        }

        //function Input() {
        //    this.displayName = 'Diagnosis'; // used only in ChangeInputVisibilityDialog for now (not in search filters area)
        //    this.i18n = 'braininstituteApp.diagnosis.diagnosis'; // same as above
        //    this.type = inputTypeEnum.HierarchicalMultiple;
        //    this.value = {}; // This will be stored by the app here for every input
        //    this.emptyValue = {}; // This is for hierarchicalMultiple only, may be later removed, used for fast clearing
        //    this.viewValue = ''; // This is for hierarchicalMultiple only, may be later removed, used to avoid processing to get the text
        //    this.configKey = 'diagnosis'; // show/hide configuration key
        //}

        function initInputs() {
            inputs = {
                sample: {
                    diagnosis: {
                        displayName: 'Diagnosis',
                        i18n: 'braininstituteApp.diagnosis.diagnosis', // TODO: all strings
                        type: inputTypeEnum.HierarchicalMultiple,
                        configKey: 'diagnosis'
                    },
                    location: {
                        displayName: 'Location',
                        type: inputTypeEnum.HierarchicalMultiple,
                        configKey: 'location'
                    },
                    code: {
                        displayName: 'Sample ID',
                        type: inputTypeEnum.String,
                        configKey: 'code'
                    },
                    molecular: {
                        displayName: 'Molecular',
                        type: inputTypeEnum.SelectMultiple,
                        configKey: 'molecular'
                    },
                    sampleType: {
                        displayName: 'Sample type',
                        type: inputTypeEnum.HierarchicalMultiple,
                        configKey: 'sampleType'
                    },
                    dtDiagnosis: {
                        displayName: 'Date of diagnosis',
                        type: inputTypeEnum.RangeMonth,
                        configKey: 'dtDiagnosis'
                    }
                },
                patient: {
                    patientCode: {
                        displayName: 'Patient ID',
                        type: inputTypeEnum.String,
                        configKey: 'patient'
                    },
                    ageAtDiagnosisYear: {
                        displayName: 'Age at diagnosis (Year)',
                        type: inputTypeEnum.RangeNumber,
                        configKey: 'ageAtDiagnosisYear'
                    },
                    ageAtDiagnosisMonth: {
                        displayName: 'Age at diagnosis (Month)',
                        type: inputTypeEnum.RangeNumber,
                        configKey: 'ageAtDiagnosisMonth'
                    },
                    lengthOfSurvivalYear: {
                        displayName: 'Length of survival (Year)',
                        type: inputTypeEnum.RangeNumber,
                        configKey: 'lengthOfSurvivalYear'
                    },
                    lengthOfSurvivalMonth: {
                        displayName: 'Length of survival (Month)',
                        type: inputTypeEnum.RangeNumber,
                        configKey: 'lengthOfSurvivalMonth'
                    },
                    gender: {
                        displayName: 'Gender',
                        type: inputTypeEnum.SelectSingle,
                        configKey: 'gender'
                    },
                    dtSurgery: {
                        displayName: 'Date of treatment (Surgical)',
                        type: inputTypeEnum.RangeNumber,
                        configKey: 'dtSurgery'
                    }
                },
                avail: {
                    siteLocation: {
                        displayName: 'Sample site location',
                        type: inputTypeEnum.SelectMultiple,
                        configKey: 'siteLocation'
                    },
                    siteAvailability: {
                        displayName: 'Site availability',
                        type: inputTypeEnum.SelectSingle, // FIXME: The current behaviour isn't fully captured. consider making special boolean selector, but I don't prefer that.
                        configKey: 'siteAvailability'
                        // Aliquots won't be here
                    } }
            };

            /* We give all their respective empty value based on type to save troubles of checking it in lots of
             * places later (undefined, null etc). */
            clearAllInputs();

            return inputs;
        }

        function clearInput(inputName) {
            var input = _.get(inputs, inputName);
            if (input.type === inputTypeEnum.HierarchicalMultiple) {
                input.value = angular.copy(input.emptyValue);
                input.viewValue = '';
            } else if (input.type === inputTypeEnum.String) input.value = '';else if (input.type === inputTypeEnum.SelectMultiple) input.value = [];else if (input.type === inputTypeEnum.RangeMonth) input.value = { from: '', to: '' };else if (input.type === inputTypeEnum.RangeNumber) input.value = { from: null, to: null };else if (input.type === inputTypeEnum.SelectSingle) // FIXME: the empty value breaks this. angular gives empty object.
                input.value = {};
        }

        function clearInputGroup(inputGroupName) {
            var inputGroup = inputs[inputGroupName];
            for (var input in inputGroup) {
                if (inputGroup.hasOwnProperty(input)) {
                    clearInput(inputGroupName + '.' + input);
                }
            }
        }

        function clearAllInputs() {
            for (var inputGroup in inputs) {
                if (inputs.hasOwnProperty(inputGroup)) {
                    clearInputGroup(inputGroup);
                }
            }
        }

        function isInputEmpty(inputName) {
            var input = _.get(inputs, inputName);

            // if the input doesn't exist, it's technically empty
            // if(!input) return true;

            if (input.type === inputTypeEnum.HierarchicalMultiple) return input.viewValue === '';else if (input.type === inputTypeEnum.String) return input.value === '';else if (input.type === inputTypeEnum.SelectMultiple) return input.value.length === 0;else if (input.type === inputTypeEnum.RangeMonth) return !(input.value.from || input.value.to);else if (input.type === inputTypeEnum.RangeNumber) return !(_.isNumber(input.value.from) || _.isNumber(input.value.to));else if (input.type === inputTypeEnum.SelectSingle)
                // return !input.value.id; // not ok because of ng-md: return _.isEmpty(input.value);
                return !(input.value && input.value.id);
            // FIXME: (above) the empty value breaks this. angular gives empty object.
        }

        function countNonEmptyInputsInGroup(inputGroupName) {
            var count = 0;

            var inputGroup = inputs[inputGroupName];
            for (var input in inputGroup) {
                if (inputGroup.hasOwnProperty(input)) {
                    if (!isInputEmpty(inputGroupName + '.' + input)) count++;
                }
            }

            return count;
        }

        function loadInputConfig(inputs) {
            for (var inputGroupName in inputs) {
                if (inputs.hasOwnProperty(inputGroupName)) {
                    var configPrefix = 'config.search.filterVisibility.' + inputGroupName + '.';
                    for (var inputName in inputs[inputGroupName]) {
                        if (inputs[inputGroupName].hasOwnProperty(inputName)) {
                            var input = inputs[inputGroupName][inputName];
                            var cfg = localStorageService.get(configPrefix + inputName);
                            if (cfg === null) input.visible = true;else input.visible = cfg;
                        }
                    }
                }
            }
        }
    });
})();
'use strict';

(function () {
    'use strict';

    angular.module('braininstituteApp').config(function ($stateProvider) {
        $stateProvider.state('search', {
            parent: 'site',
            url: '/search',
            data: {
                authorities: ['OP_AUTHENTICATED'],
                pageTitle: 'search.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/search/search.html',
                    controller: 'searchController as search'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('commonFormMsg');
                    $translatePartialLoader.addPart('search');
                    $translatePartialLoader.addPart('diagnosis');
                    $translatePartialLoader.addPart('location');
                    $translatePartialLoader.addPart('sampleInfo');
                    $translatePartialLoader.addPart('molecular');
                    $translatePartialLoader.addPart('sampleType');
                    $translatePartialLoader.addPart('patient');
                    return $translate.refresh();
                }]
            }
        });
    });
})();
'use strict';

(function () {
    'use strict';

    angular.module('braininstituteApp').controller('searchController', searchController);

    function searchController($scope, $rootScope, $state, $element, $mdDialog, $mdToast, $mdSidenav, $q, $timeout, $window, $mdMedia, $log, ivhTreeviewMgr, Diagnosis, Location, SiteLocation, Molecular, SampleType, treeviewService, formsService, SearchService, dslService, Principal, localStorageService, dateService, NewRecordService, NewPatientService, AlertService, StompService, ExportService, _, responsiveDesignService) {
        var vm = this;
        vm.showNewRecordDialog = NewRecordService.showNewRecordDialog;
        vm.showNewPatientDialog = NewPatientService.showNewPatientDialog;
        vm.searchbarToggle = searchbarToggle;
        vm.getSearchbarLockedOpen = getSearchbarLockedOpen;
        vm.rowClick = rowClick;
        vm.resetSearch = resetSearch;
        vm.doToggleSearchToolbarTitle = doToggleSearchToolbarTitle;
        vm.toggleSearchToolbarTitle = false;

        vm.isInputEmpty = SearchService.isInputEmpty;
        vm.isViewShown = isViewShown;
        vm.$mdMedia = $mdMedia;
        vm.$mdSidenav = $mdSidenav;
        vm.hasInvestigator = false;

        vm.dsl = null;
        vm.filters = null;

        setSearchToolbarTitle();
        var firstLoad;
        var searchbarLockedOpenIfWide = true;
        var mediaQueries = {
            searchSidenavLocked: '(min-width: 1440px)',
            sampleViewSideBySide: '(min-width: 839px)',
            responsiveMode: '(max-width: 1279px)'
        };

        vm.mediaQueries = mediaQueries;
        vm.selected = []; //selected rows

        var defaultSort = 'patient.code';
        var window = angular.element($window);

        vm.isFabOpen = true; //set the fab dial to open to start

        // On opening, add a delayed property which shows tooltips after the speed dial has opened
        // so that they have the proper position; if closing, immediately hide the tooltips
        $scope.$watch('search.isFabOpen', function (isOpen) {
            if (isOpen) {
                $timeout(function () {
                    vm.tooltipVisible = vm.isFabOpen;
                }, 600);
            } else {
                vm.tooltipVisible = vm.isFabOpen;
            }
        });

        $timeout(function () {
            vm.isFabOpen = false; //close the fab dial after dealy
        }, 250);

        vm.requestMultiple = function (selected) {
            if (selected.length == 1) {
                $mdDialog.show({
                    templateUrl: 'app/sample/request-sample-dialog.html',
                    controller: 'RequestSampleDialogController',
                    clickOutsideToClose: true,
                    fullscreen: responsiveDesignService.mdDialogFullScreen(),
                    locals: {
                        sampleUrl: selected[0]._links.self.href
                    }
                }).then(function (success) {
                    vm.selected = [];
                });
            } else {
                $mdDialog.show({
                    templateUrl: 'app/search/request-multiple-sample-dialog.html',
                    controller: 'RequestMultipleSampleDialogController',
                    clickOutsideToClose: true,
                    fullscreen: responsiveDesignService.mdDialogFullScreen(),
                    locals: {
                        samples: selected
                    }
                }).then(function (success) {
                    vm.selected = [];
                });
            }
        };

        window.bind('resize', function () {
            $scope.$apply();

            vm.cardModeOn = $mdMedia(vm.mediaQueries.responsiveMode);
        });

        $scope.$on('resetSearch', function (evt, params) {
            resetSearch(params);
        });

        init();

        function init() {
            vm.hasInvestigator = Principal.isInRole("OP_INVESTIGATOR");
            //Variable to not trigger the $watches in the first load of the page
            firstLoad = true;

            Principal.identity().then(function (user) {
                vm.currentUser = user;
                vm.isAdmin = Principal.isInRole('OP_ADMIN');
                vm.isCoordinator = Principal.isInRole('OP_COORDINATOR');
            });

            vm.isLoadingData = true;
            prepareTable();

            initSearchTabs();

            var searchDTO = localStorageService.get('searchQueryDTO');

            if (false && searchDTO) {
                // temporarily disabling this per BRAIN-314
                var orderBy = localStorageService.get('searchOrderBy');
                var pageNumber = localStorageService.get('searchPageNumber');

                vm.pageNumber = pageNumber ? pageNumber : 1;
                vm.perPage = SearchService.getItemsPerPage($window);
                vm.sort = orderBy ? orderBy : defaultSort;

                loadData(searchDTO, pageNumber, vm.sort, vm.perPage, function () {
                    // init search tabs after initial data was loaded
                    vm.loadData();
                    SearchService.loadInputConfig(vm.inputs);
                });
            } else {
                vm.pageNumber = 1;
                vm.perPage = SearchService.getItemsPerPage($window);
                vm.sort = defaultSort;

                loadData(null, 1, vm.sort, vm.perPage, function () {
                    // init search tabs after initial data was loaded
                    vm.loadData();
                    SearchService.loadInputConfig(vm.inputs);
                });
            }
        }

        $scope.$watch(function () {
            return $window.innerHeight;
        }, function () {
            if (!firstLoad) {
                vm.perPage = SearchService.getItemsPerPage($window);
                vm.isLoadingData = true;
                vm.pageNumber = 1;
                loadData(vm.searchJSON, 1, vm.sort, vm.perPage);
            }
        });

        $scope.$watch('search.searchJSON', function () {
            if (!firstLoad) {
                vm.isLoadingData = true;
                vm.pageNumber = 1;
                loadData(vm.searchJSON, 1, vm.sort, vm.perPage);
            }
        });

        vm.formatSampleAliquots = function (sample) {
            if (sample.sampleType.countable) {
                return sample.aliquots;
            }
            return sample.containAliquots ? "Y" : "N";
        };

        function prepareTable() {
            vm.headers = [{ name: 'Patient ID', orderBy: 'patient.code' }, { name: 'Age year', orderBy: 'ageAtDiagnosisYear', numeric: true }, { name: 'Age month', orderBy: 'ageAtDiagnosisMonth', numeric: true }, { name: 'Sample type', orderBy: 'sampleType.name' }, { name: 'Aliquots', orderBy: 'aliquots', numeric: true }];
        }

        vm.exportData = function () {
            //create empty search dto if we don't have one
            var searchDTO = vm.searchJSON;
            if (!searchDTO) {
                searchDTO = SearchService.getSearchAllDTO(defaultSort);
            }

            //set our search index/entity and projection
            var entity = 'sample';
            searchDTO.projection = "sampleLight";

            var columns = [{ property: 'patient.code', name: 'Patient', checked: true }, { property: 'sampleType.tier1', name: 'Sample Type Tier 1', checked: true }, { property: 'sampleType.tier2', name: 'Sample Type Tier 2', checked: true }, { property: 'aliquots', name: 'Aliquots', checked: true }, //Special case - this column will handle either aliquots or contain aliquots
            { property: 'dtSurgery', name: 'Surgery', checked: true }, { property: 'ageAtDiagnosisYear', name: 'Age At Diagnosis (Year)' }, { property: 'ageAtDiagnosisMonth', name: 'Age At Diagnosis (Month)' }, { property: 'dtDiagnosis', name: 'Date of Diagnosis' }, { property: 'diagnosis.tier1', name: 'Diagnosis Tier 1' }, { property: 'diagnosis.tier2', name: 'Diagnosis Tier 2' }, { property: 'diagnosis.tier3', name: 'Diagnosis Tier 3' }, { property: 'diagnosisNotes', name: 'Diagnosis Notes' }, { property: 'location.tier1', name: 'Location Tier 1' }, { property: 'location.tier2', name: 'Location Tier 2' }, { property: 'location.tier3', name: 'Location Tier 3' }, { property: 'location.tier4', name: 'Location Tier 4' }, { property: 'locationNotes', name: 'Location Notes' }, { property: 'moleculars.name', fieldType: 'commaList', name: 'Moleculars' }];

            $mdDialog.show({
                controller: 'ExportColumnsDialogController',
                templateUrl: 'app/search/export-columns-dialog.html',
                fullscreen: responsiveDesignService.mdDialogFullScreen(),
                locals: {
                    items: columns
                },
                parent: angular.element(document.body),
                clickOutsideToClose: true
            }).then(function (result) {
                if (result && result.length > 0) {
                    //run export service
                    var params = {
                        searchDTO: searchDTO,
                        columns: result
                    };
                    ExportService.exportData(entity, params).then(function (data) {
                        AlertService.showAlert("Preparing your file.", "Your export is being prepared, once it is complete you will receive a notification to download your file.");
                    }, function () {});
                }
            }, function () {
                //cancelled
            });
        };

        function getSearchbarLockedOpen() {
            return $mdMedia(mediaQueries.searchSidenavLocked) && searchbarLockedOpenIfWide;
        }

        function searchbarToggle() {
            if ($mdMedia(mediaQueries.searchSidenavLocked)) searchbarLockedOpenIfWide = !searchbarLockedOpenIfWide;else $mdSidenav('sidenavSearchFilters', true).toggle();
        }

        function rowClick(row) {
            // if the user clicked on the sample which is already opened
            if ($state.current.name === "sampleView" && $state.get('sampleView').data.url == row._links.self.href) {
                return;
            }

            $state.go('sampleView', { id: row._links.self.href });
        }

        /**
        * Creates the Toast with info about the filters
        */
        function makeQueryStringToast() {
            var filtersContent = ['Search', (vm.totalElements || 0) + ' results', "Filters: " + (vm.dsl ? vm.dsl : "None")].join(' | ');
            return $mdToast.show({
                controller: function controller($scope, $mdToast) {
                    $scope.hide = function () {
                        $mdToast.hide();
                    };
                },
                template: ['<md-toast style="max-width: 100%;">', '   <div class="md-toast-content" style="height: 800px">', '       <span flex>' + filtersContent + '</span>', '<md-button type="button" class="md-icon-button" ng-click="hide()" style="position: absolute; top: 0; right: 0;">', '<md-icon md-svg-icon="content:ic_clear_24px" aria-label="Close dialog" style="color: #fff;"></md-icon>', '</md-button>', '   </div>', '</md-toast>'].join('\n'),
                hideDelay: 7000,
                position: 'bottom left'
            });
        }

        function doToggleSearchToolbarTitle() {
            $mdSidenav('rightInfo', true).toggle();
        }

        vm.onpagechange = function (page, limit) {
            var deferred = $q.defer();

            // this reflects md-progress="search.promise"
            vm.promise = deferred.promise;

            loadData(vm.searchJSON, page, vm.sort, limit, function () {
                deferred.resolve();
            });

            return deferred.promise;
        };

        vm.onorderchange = function (order) {
            var deferred = $q.defer();

            // this reflects md-progress="search.promise"
            vm.promise = deferred.promise;

            loadData(vm.searchJSON, vm.pageNumber, order, vm.perPage, function () {
                deferred.resolve();
            });

            return deferred.promise;
        };

        vm.cardModeOn = $mdMedia(vm.mediaQueries.responsiveMode);

        /**
        * When we change between modes, we have to reload data
        */
        $scope.$watch(vm.cardModeOn, function (newValue) {
            if (newValue == false) {
                vm.isLoadingData = true;
                loadData(vm.searchJSON, vm.pageNumber, vm.sort, vm.perPage);
            }
        });

        /**
        * This function is called everytime the user scrolls next to
        * end of the page.
        */
        vm.nextPageInfiniteScroll = function () {
            if (vm.isLoadingData || // if we are still loading data
            !vm.data || // we don't have any data
            vm.data.length < vm.perPage && vm.searchJSON || // if we are have less items than the page size, which means we don't have more items
            vm.content && vm.content.length >= vm.totalElements) // or we have reached the last page
                return;

            vm.isLoadingData = true;

            loadData(vm.searchJSON, vm.pageNumber++, vm.sort, vm.perPage, null, true);
        };

        function loadData(searchDTO, pageNumber, orderBy, size, onSuccess, concat) {
            if (!searchDTO) {
                searchDTO = SearchService.getSearchAllDTO(defaultSort);
            }

            vm.selected = []; //reset selected

            SearchService.search('sample', pageNumber, size, orderBy, searchDTO, function (data) {
                vm.isLoadingData = false;
                vm.limit = data.page.size;
                vm.totalElements = data.page.totalElements;
                setSearchToolbarTitle();
                // vm.pageNumber = data.page.number + 1;
                vm.searchDTO = searchDTO;
                if (concat) {
                    // we only want unique values
                    var uniques = _.uniqBy(_.concat(vm.data, _.remove(data._embeddedItems, undefined)), function (sample) {
                        //TODO
                        //not the best way to verify that two samples are the same, maybe we should have an id?
                        return JSON.stringify(sample);
                    });

                    vm.data = uniques;
                } else {
                    vm.data = data != null ? data._embeddedItems : null;
                }

                if (orderBy) {
                    localStorageService.set('searchOrderBy', orderBy);
                } else {
                    localStorageService.remove('searchOrderBy');
                }
                localStorageService.set('searchQueryDTO', searchDTO);
                localStorageService.set('searchPageNumber', vm.pageNumber);

                if (onSuccess) onSuccess();

                if (firstLoad) {
                    firstLoad = false;
                }
            }, function () {
                //TODO:show error
            });
        }

        function resetSearch(params) {
            vm.isLoadingData = true;
            vm.pageNumber = 0;
            vm.sort = defaultSort;
            loadData(vm.searchJSON, 1, vm.sort, vm.perPage);
            //if this param is set, go back to search state (ex: when deleting a sample/patient)
            if (params && params.goToSearch) {
                $state.go('search');
            }
        }

        function setSearchToolbarTitle() {
            vm.searchToolbarTitle = ['Search', (vm.totalElements || 0) + ' results'].join(' | ');
        }

        function initSearchTabs() {
            vm.inputs = 0;
            vm.changedCounts = {
                sample: 0, patient: 0, avail: 0
            };

            vm.treeviewOpts = treeviewService.treeviewOpts;
            vm.resetForm = resetForm;
            vm.resetFilters = resetFilters;
            vm.clearInputGroup = clearInputGroup;
            vm.showChangeInputVisibilityDialog = showChangeInputVisibilityDialog;

            $scope.$on('resetSearchForm', function () {
                resetForm();

                var message = SearchService.getSharedMessage();
                if (message.field === 'patientCode') {
                    vm.inputs.patient.patientCode.value = message.value;
                } else if (message.field == 'patientCodeRaw') {
                    vm.inputs.patient.patientCode.value = message.value;
                    vm.inputs.patient.patientCode.useRaw = true;
                }

                vm.blurOrChangeEvents();
            });

            vm.genders = formsService.genders;
            dslService.registerTable('gender', vm.genders);
            vm.yesNo = formsService.yesNo;
            dslService.registerTable('yesNo', vm.yesNo);

            vm.loadData = function () {
                vm.getDiagnoses();
                vm.getSiteLocations();
                vm.getSampleTypes();
                vm.getLocations();
                vm.getMoleculars();
            };

            vm.getSiteLocations = function () {
                SiteLocation.resource.query({ projection: "searchValueName" }, function (data) {
                    vm.siteLocations = data._embeddedItems;
                    dslService.registerTable('siteLocation', data._embeddedItems);
                });
            };

            vm.getMoleculars = function () {
                Molecular.resource.query({ projection: "searchValueName" }, function (data) {
                    vm.moleculars = data._embeddedItems;
                    dslService.registerTable('molecular', data._embeddedItems);
                });
            };

            vm.getDiagnoses = function () {
                Diagnosis.resource.query({ projection: "searchNestedNoParent" }, function (data) {
                    vm.inputs.sample.diagnosis.emptyValue = treeviewService.createTreeFromServerArray(data._embeddedItems);
                    vm.inputs.sample.diagnosis.value = angular.copy(vm.inputs.sample.diagnosis.emptyValue);
                });
            };

            vm.getLocations = function () {
                Location.resource.query({ projection: "searchNestedNoParent" }, function (data) {
                    vm.inputs.sample.location.emptyValue = treeviewService.createTreeFromServerArray(data._embeddedItems);
                    vm.inputs.sample.location.value = angular.copy(vm.inputs.sample.location.emptyValue);
                });
            };

            vm.getSampleTypes = function () {
                SampleType.resource.query({ projection: "searchNestedNoParent" }, function (data) {
                    vm.inputs.sample.sampleType.emptyValue = treeviewService.createTreeFromServerArray(data._embeddedItems);
                    vm.inputs.sample.sampleType.value = angular.copy(vm.inputs.sample.sampleType.emptyValue);
                });
            };

            vm.blurOrChangeEvents = function () {
                vm.submit();
                updateChangedInputCounts();
            };

            /*
             * The watcher of searchJSON is in the parent controller is submits the search JSON
             */
            vm.submit = function () {
                try {
                    vm.filters = dslService.getFilters(vm.inputs);

                    vm.perPage = SearchService.getItemsPerPage($window);
                    vm.searchJSON = SearchService.createSearchJson(vm.inputs, vm.sort ? vm.sort : defaultSort);
                    $rootScope.$broadcast('searchJSON', vm.searchJSON); // FIXME: delete
                } catch (error) {
                    $log.debug(error);
                    AlertService.showAlert('Search Error', error.message);
                }
            };

            vm.clearTreeviewModel = clearTreeviewModel;
            vm.sidenavOpen = sidenavOpen;

            $scope.$watch('search.sidenavDiagnosisIsOpen', function (newVal, oldVal) {
                if (oldVal === true && newVal === false) sidenavDiagnosisCloseHandler();
            });
            $scope.$watch('search.sidenavLocationsIsOpen', function (newVal, oldVal) {
                if (oldVal === true && newVal === false) sidenavLocationsCloseHandler();
            });
            $scope.$watch('search.sidenavSampleTypesIsOpen', function (newVal, oldVal) {
                if (oldVal === true && newVal === false) sidenavSampleTypesCloseHandler();
            });

            vm.inputs = SearchService.initInputs();
            // vm.loadData();
            // SearchService.loadInputConfig(vm.inputs);

            function clearTreeviewModel(treeviewModel) {
                // faster but used only to clear an existing tree, not full form reset (that is done by resetXXX()
                ivhTreeviewMgr.deselectAll(treeviewModel.value);
            }

            function sidenavOpen(id) {
                $mdSidenav(id).open();
            }

            function sidenavDiagnosisCloseHandler() {
                vm.inputs.sample.diagnosis.viewValue = treeviewService.getSelectionSummaryText(vm.inputs.sample.diagnosis.value);
                vm.blurOrChangeEvents();
            }

            function sidenavLocationsCloseHandler() {
                vm.inputs.sample.location.viewValue = treeviewService.getSelectionSummaryText(vm.inputs.sample.location.value);
                vm.blurOrChangeEvents();
            }

            function sidenavSampleTypesCloseHandler() {
                vm.inputs.sample.sampleType.viewValue = treeviewService.getSelectionSummaryText(vm.inputs.sample.sampleType.value);
                vm.blurOrChangeEvents();
            }

            /**
             * This is changing, temporarily halfway
             */
            function clearInputGroup(inputGroupName) {
                SearchService.clearInputGroup(inputGroupName);
                vm.changedCounts[inputGroupName] = 0;
            }

            function updateChangedInputCounts() {
                vm.changedCounts.sample = SearchService.countNonEmptyInputsInGroup('sample');
                vm.changedCounts.patient = SearchService.countNonEmptyInputsInGroup('patient');
                vm.changedCounts.avail = SearchService.countNonEmptyInputsInGroup('avail');
            }

            function clearAllInputs() {
                SearchService.clearAllInputs();

                vm.changedCounts['sample'] = 0;
                vm.changedCounts['patient'] = 0;
                vm.changedCounts['avail'] = 0;
            }

            function resetFilters() {
                clearAllInputs();
                vm.submit();

                resetSearch();
                vm.filters = null;
                setSearchToolbarTitle();
            }

            function resetForm() {
                clearInputGroup('sample');
                clearInputGroup('patient');
                clearInputGroup('avail');
            }

            function showChangeInputVisibilityDialog(inputGroupName) {
                $mdDialog.show({
                    controller: 'ChangeInputVisibilityDialogController',
                    templateUrl: 'app/search/change-input-visibility-dialog.html',
                    fullscreen: responsiveDesignService.mdDialogFullScreen(),
                    locals: {
                        inputGroupName: inputGroupName,
                        inputs: vm.inputs[inputGroupName]
                    },
                    parent: angular.element(document.body),
                    clickOutsideToClose: true
                }).then(function (result) {
                    if (result && result == 'success') {
                        //ctrl.loadAll();
                    }
                }, function () {
                    //cancelled
                });
            }
        } // end of function initSearchTabs()


        /**
         * Return whether search results and/or sample view should be visible, depending on state and viewport.
         */
        function isViewShown(viewName) {
            // don't show sampleView and search side by side, as we won't have enough space
            if ($mdMedia(mediaQueries.sampleViewSideBySide)) return true;else if ($state.is('search') && viewName === 'search') return true;else if ($state.is('sampleView') && viewName === 'sampleView') return true;
        }
    }
})();
'use strict';

(function () {
    'use strict';

    angular.module('braininstituteApp').controller('RequestMultipleSampleDialogController', RequestSampleDialogController);
    function RequestSampleDialogController($scope, $mdDialog, $log, $http, $q, locals, SampleRequest, AlertService) {
        var vm = this;
        var samples = locals.samples;

        $scope.loadingAll = false;
        $scope.requestingSamples = [];
        //If any of the multiple samples is available it will be true
        $scope.anyAvailable = false;
        $scope.submitted = false;

        vm.init = function () {
            $scope.loadingAll = true;
            var promises = [];

            _.forEach(samples, function (item) {
                promises.push($http.get(item._links['self'].href + "?projection=sampleView"));
            });

            $q.all(promises).then(function (values) {
                _.forEach(values, function (data) {
                    var sampleData = data.data;

                    //Add the request data inside the sample data object
                    sampleData.request = {
                        sampleInfo: sampleData._links.self.href
                    };

                    //For the form
                    sampleData.aliquotsAvailable = sampleData.aliquots;
                    sampleData.isCountable = sampleData.sampleType.countable;

                    if (sampleData.isCountable) {
                        sampleData.request.aliquotsRequested = 1;
                    }

                    if (sampleData.requested) {
                        sampleData.requestable = false;
                        sampleData.error = 'You have an open request for this sample.';
                    } else if (sampleData.haveRequestsOpen) {
                        sampleData.requestable = false;
                        sampleData.error = 'There are open requests for this sample.';
                    } else if (sampleData.aliquotsAvailable == 0 || !sampleData.containAliquots && !sampleData.isCountable) {
                        sampleData.requestable = false;
                        sampleData.error = 'There are no aliquots available for this sample.';
                    } else {
                        $scope.anyAvailable = true; // if any of the samples are available
                        sampleData.requestable = true;
                    }

                    //Description
                    sampleData.description = "Patient: " + sampleData.patient.code + " Sample : " + sampleData.sampleTypes + " ";
                    $scope.requestingSamples.push(sampleData);

                    //When the last item was loaded the spinner will hide
                    if ($scope.requestingSamples.length == samples.length) {
                        $scope.loadingAll = false;
                    }
                });
            }).catch(function (err) {
                AlertService.toastError("Could not load Sample data");
                $log.debug(err);
            });
        };

        vm.init();

        $scope.sendRequest = function () {
            if (!$scope.requestForm.$valid) return;
            $scope.submitted = true;
            _.forEach($scope.requestingSamples, function (item) {
                //Will only send the requestable ones
                if (item.requestable) {
                    item.request.submitting = true;
                    SampleRequest.create(item.request, function (response) {
                        item.request.submitting = false;
                        item.request.success = true;
                    }, function (err) {
                        $log.debug(err);
                        item.request.success = false;
                        item.request.error = err;
                        item.request.submitting = false;
                    });
                }
            });
        };

        $scope.hide = $mdDialog.hide;
        $scope.cancel = $mdDialog.cancel;
    }
})();
'use strict';

angular.module('braininstituteApp').factory('ExportService', function ($http) {
    return {
        exportData: function exportData(entity, params) {
            var uri = '/api/excelExport/prepareFile/' + entity;
            return $http.post(uri, params);
        }
    };
});
'use strict';

(function () {
    'use strict';

    angular.module('braininstituteApp').controller('ExportColumnsDialogController', ExportColumnsDialogController);

    function ExportColumnsDialogController($scope, $mdDialog, items) {
        init();

        function init() {
            $scope.items = items;

            $scope.selectAll = selectAll;
            $scope.selectNone = selectNone;
            $scope.isAllSelected = isAllSelected;
            $scope.hide = $mdDialog.hide;
        }

        $scope.done = function () {
            //Gets all checked items
            var selected = _.filter($scope.items, function (item) {
                return item.checked;
            });

            $mdDialog.hide(selected);
        };

        function selectAll() {
            items.forEach(function (item) {
                item.checked = true;
            });
        }

        function selectNone() {
            items.forEach(function (item) {
                item.checked = false;
            });
        }

        function isAllSelected() {
            return _.every(items, 'checked');
        }
    }
})();
'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

(function () {
    'use strict';

    angular.module('tcincCommon').factory('dslService', function (treeviewService) {
        var dataTables = {};

        return {
            registerTable: registerTable,
            getFilters: getFilters
        };

        function getFilters(inputs) {
            var dslArray = [];

            /**
            * Returns a copy of an array with the filter added if not empty
            */
            function pushFilter(array, title, data) {
                var ar = _.clone(array);

                // add to array if it's not empty
                if (typeof data == 'number' || typeof data == 'string' && data.length > 0 || (typeof data === 'undefined' ? 'undefined' : _typeof(data)) == 'object' && !_.isEmpty(data)) {
                    ar.push({ title: title, data: data });
                }

                // return a copy of the array (immutability)
                return ar;
            }

            // Sample Information tab
            dslArray = pushFilter(dslArray, 'Diagnosis', treeviewService.getSelectionSummaryText(inputs.sample.diagnosis.value));
            dslArray = pushFilter(dslArray, 'Location', treeviewService.getSelectionSummaryText(inputs.sample.location.value));
            dslArray = pushFilter(dslArray, 'Sample id', inputs.sample.code.value);
            dslArray = pushFilter(dslArray, 'Molecular', selectMultiple(inputs.sample.molecular.value));
            dslArray = pushFilter(dslArray, 'Sample type', treeviewService.getSelectionSummaryText(inputs.sample.sampleType.value));
            dslArray = pushFilter(dslArray, 'Date of diagnosis', dateRange(inputs.sample.dtDiagnosis.value, 'monthText').join(" "));

            // Patient Information tab
            dslArray = pushFilter(dslArray, 'Patient id', inputs.patient.patientCode.value); // called "Patient ID"
            dslArray = pushFilter(dslArray, 'Age at diagnosis (year)', numberRange(inputs.patient.ageAtDiagnosisYear.value).join(" "));
            dslArray = pushFilter(dslArray, 'Age at diagnosis (month)', numberRange(inputs.patient.ageAtDiagnosisMonth.value).join(" "));
            dslArray = pushFilter(dslArray, 'Length of survival (year)', numberRange(inputs.patient.lengthOfSurvivalYear.value).join(" "));
            dslArray = pushFilter(dslArray, 'Length of survival (month)', numberRange(inputs.patient.lengthOfSurvivalMonth.value).join(" "));
            dslArray = pushFilter(dslArray, 'Gender', inputs.patient.gender.value && inputs.patient.gender.value.id, 'gender');
            dslArray = pushFilter(dslArray, 'Date of treatment', numberRange(inputs.patient.dtSurgery.value).join(" "));

            // Availability Information tab
            dslArray = pushFilter(dslArray, 'Site location', selectMultiple(inputs.avail.siteLocation.value));
            dslArray = pushFilter(dslArray, 'Site availability', selectSingle(inputs.avail.siteAvailability.value && inputs.avail.siteAvailability.value.id, 'yesNo'));

            if (inputs.avail.siteAvailability.value && inputs.avail.siteAvailability.value.id === true) dslArray = pushFilter(dslArray, '#aliquots', numberRange(inputs.avail.siteAvailability.aliquots).join(" "));

            return dslArray;
        }

        function selectSingle(value, table) {
            if (_.isNumber(value) || _.isString(value) && !_.isEmpty(value) || _.isBoolean(value)) {
                var textValue = _.find(dataTables[table], ['id', value]).name;
                return textValue;
            }
        }

        function selectMultiple(value, table) {
            if (_.isEmpty(value) || !_.isArray(value)) return [];
            var textValue = value.map(function (el) {
                ;
                return el.name;
            }).join(', ');

            return textValue;
        }

        /* dateType: 'date', 'month' */
        function dateRange(value, dateType) {
            if (!value) return [];
            var resultArray = [];
            if (dateType === 'date') {
                var from = value.from;
                var to = value.to;
                var haveFrom = _.isDate(from);
                var haveTo = _.isDate(to);
            } else if (dateType === 'monthText') {
                var from = value.from;
                var to = value.to;
                var haveFrom = _.isString(from) && from.length > 0;
                var haveTo = _.isString(to) && to.length > 0;
            }
            if (!haveFrom && !haveTo) return [];
            if (haveFrom) resultArray.push('from ' + moment(from).format('YYYY-MM-DD'));
            if (haveTo) resultArray.push('to ' + moment(to).format('YYYY-MM-DD'));

            return resultArray;
        }

        function numberRange(value) {
            if (!value) return [];
            var resultArray = [];
            var from = value.from;
            var to = value.to;
            var haveFrom = _.isNumber(from);
            var haveTo = _.isNumber(to);
            if (!haveFrom && !haveTo) return [];
            if (haveFrom) resultArray.push('from ' + from);
            if (haveTo) resultArray.push('to ' + to);

            return resultArray;
        }

        function format(name, value) {
            return '[' + name + ': ' + value + ']';
        }

        function registerTable(name, table) {
            dataTables[name] = table;
        }
    });
})();
'use strict';

(function () {
    'use strict';

    angular.module('braininstituteApp').controller('ChangeInputVisibilityDialogController', ChangeInputVisibilityDialogController);

    function ChangeInputVisibilityDialogController($scope, $mdDialog, localStorageService, inputGroupName, inputs) {
        var configPrefix = 'config.search.filterVisibility.' + inputGroupName + '.';
        init();

        function init() {
            $scope.inputs = inputs;

            $scope.saveOne = saveOne;
            $scope.selectAll = selectAll;
            $scope.selectNone = selectNone;
            $scope.isAllSelected = isAllSelected;
            $scope.hide = $mdDialog.hide;
        }

        function saveOne(input) {
            if (input.visible === false) localStorageService.set(configPrefix + input.configKey, false);else localStorageService.remove(configPrefix + input.configKey);
        }

        function selectAll() {
            for (var input in inputs) {
                if (inputs.hasOwnProperty(input)) {
                    if (inputs[input].visible === false) {
                        inputs[input].visible = true;
                        saveOne(inputs[input]);
                    }
                }
            }
        }

        function selectNone() {
            for (var input in inputs) {
                if (inputs.hasOwnProperty(input)) {
                    if (inputs[input].visible === true) {
                        inputs[input].visible = false;
                        saveOne(inputs[input]);
                    }
                }
            }
        }

        function isAllSelected() {
            return _.every(inputs, 'visible');
        }
    }
})();
'use strict';

(function () {
    'use strict';

    angular.module('braininstituteApp').factory('RequestsService', function (StompService, Notification, Principal, AlertService) {
        var WS_MY_REQUESTS = "/user/queue/userRequests";

        return {
            startWebSockets: function startWebSockets(user, callback) {
                StompService.connect();
                StompService.subscribe(WS_MY_REQUESTS);
                StompService.receive(WS_MY_REQUESTS).then(null, null, function (data) {
                    callback(data);
                    AlertService.toastInfo(data.message);
                });
            },
            loadNotifications: function loadNotifications(page) {
                return Notification.forUser(page);
            },
            setRead: function setRead(data) {
                return Notification.setRead(data);
            },
            clearAll: function clearAll() {
                return Notification.clearAll();
            }
        };
    });
})();
'use strict';

(function () {
    'use strict';

    angular.module('braininstituteApp').config(function ($stateProvider) {

        $stateProvider.state('requests', {
            parent: 'site',
            url: '/requests',
            data: {
                authorities: ['OP_AUTHENTICATED'],
                pageTitle: 'requests.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/requests/requests.html',
                    controller: 'requestsController as requests'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('requests');
                    return $translate.refresh();
                }]
            }
        });
    });
})();
'use strict';

(function () {
    'use strict';

    angular.module('braininstituteApp').controller('requestsController', function ($scope, AlertService, Principal, $mdDialog, SampleRequestSearch, $q, RequestHistory, RequestStatus, $mdMedia, $state, $window, SearchService) {
        var vm = this;
        vm.selected = [];
        var STATUSES = {
            CANCELLED: 1,
            REQUESTED: 2,
            APPROVED: 3,
            DECLINED: 4,
            SENT: 5
        };
        vm.$mdMedia = $mdMedia;
        vm.page = 0;
        vm.perPage = 10;
        vm.requestStatuses = [];
        vm.RequestQuery = {};
        vm.firstLoad = true;
        vm.mediaQueries = {
            searchSidenavLocked: '(min-width: 1440px)',
            logViewSideBySide: '(min-width: 839px)',
            responsiveMode: '(max-width: 1279px)'
        };

        vm.init = function () {
            prepareYearsDropdown();
            RequestStatus.resource.query({}, function (data) {
                vm.requestStatuses = data._embeddedItems;
            });

            //Get the logged in user first
            Principal.identity().then(function (user) {
                vm.currentUser = user;
                vm.isCoordinator = Principal.isInAnyRole(["OP_COORDINATOR"]);
                vm.perPage = SearchService.getItemsPerPage($window);

                if (vm.isCoordinator) {
                    vm.RequestQuery = SampleRequestSearch.forAdmin;
                } else {
                    vm.RequestQuery = SampleRequestSearch.forUser;
                }
                prepareTable();
                vm.loadRequests(function () {
                    vm.firstLoad = false;
                });
            });
        };

        $scope.$watch(function () {
            return $window.innerHeight;
        }, function () {
            if (!vm.firstLoad) {
                vm.perPage = SearchService.getItemsPerPage($window);
                $scope.isLoadingRequests = true;
                vm.pageNumber = 1;
                vm.loadRequests();
            }
        });

        vm.cardModeOn = function () {
            return $mdMedia(vm.mediaQueries.responsiveMode);
        };

        /**
         * This function is called everytime the user scrolls next to
         * end of the page.
         */
        vm.nextPageInfiniteScroll = function () {
            if ($scope.isLoadingRequests || // if we are still loading data
            vm.firstLoad || // if it's the first load (as init() will handle data loading)
            vm.content && vm.content.length >= vm.totalElements) {
                // or we have reached the last page
                return; // do nothing
            }

            vm.page++;
            vm.loadRequests();
        };

        /**
         * Checks if any action button is applicable to this item
         * @param item (a row, or a card)
         * @returns Boolean
         */
        vm.needActionButtons = function (item) {
            var need = false;
            _.each(vm.tableButtons, function (btn) {
                // btn.show takes an array as argument
                if (btn.show([item])) {
                    need = true;
                }
            });

            return need;
        };

        vm.onpagechange = function (page, limit) {
            var deferred = $q.defer();
            vm.promise = deferred.promise;

            vm.page = page - 1;
            vm.loadRequests(function () {
                deferred.resolve();
            });
            return deferred.promise;
        };

        vm.loadRequests = function (onSuccess) {
            $scope.isLoadingRequests = true;
            vm.selected = [];

            if (vm.cardModeOn()) {
                vm.promise = null;

                vm.RequestQuery.query({
                    year: vm.year,
                    page: vm.page,
                    size: vm.perPage
                }, function (data) {
                    $scope.pageData = data.page;
                    vm.totalElements = data.page.totalElements;
                    vm.limit = data.page.size;
                    vm.pageNumber = data.page.number;
                    vm.content = data._embeddedItems ? vm.content.concat(data._embeddedItems) : vm.content;
                    $scope.isLoadingRequests = false;
                    if (onSuccess) onSuccess();
                }, function (err) {
                    //TODO:show error
                    $scope.isLoadingRequests = false;
                });
            } else {

                vm.RequestQuery.query({
                    year: vm.year,
                    page: vm.page,
                    size: vm.perPage
                }, function (data) {
                    $scope.pageData = data.page;
                    vm.totalElements = data.page.totalElements;
                    vm.limit = data.page.size;
                    vm.pageNumber = data.page.number + 1;
                    vm.content = data._embeddedItems;
                    $scope.isLoadingRequests = false;
                    if (onSuccess) onSuccess();
                }, function (err) {
                    //TODO:show error
                    $scope.isLoadingRequests = false;
                });
            }
        };

        /**
         * If a action happens (such as Cancelling a request)
         * We need to reload the requests
         */
        vm.reloadRequests = function () {
            if (vm.cardModeOn()) {
                // If we are in card mode
                vm.page = 0; // Let's start loading from the beginning
                vm.content = [];
            }

            vm.loadRequests();
        };

        var prepareTable = function prepareTable() {
            vm.headers = [{ name: 'Requester User', orderBy: 'userName' }, { name: 'Requester Institution', orderBy: 'requesterInstitution.name' }, { name: 'Aliquots req', orderBy: 'aliquotsRequested', numeric: true }, { name: 'Aliquots available', orderBy: 'sampleInfo.aliquots', numeric: true }, { name: 'Patient ID', orderBy: 'patient.code' }, { name: 'Sample ID', orderBy: 'sampleInfo.code' }, { name: 'Sample type', orderBy: 'sampleName' }, { name: 'Status', orderBy: 'sampleInfo.currentStatus.description' }];
            vm.content = [];
        };

        /**
         * Prepare the request payload
         * @param item
         * @param newStatus
         * @param message
         * @returns {{}}
         */
        function prepareRequest(item, newStatus, message) {
            var requestHistory = {};

            if (message) {
                requestHistory.message = message;
            }
            requestHistory.requestStatus = vm.requestStatuses[newStatus - 1]._links.self.href;
            requestHistory.sampleRequest = item._links.self.href;

            return requestHistory;
        }

        //Helpers for table
        /**
         * To show the cancel button all of the selected items must pass the validation test
         * @param selectedItems
         * @returns {boolean}
         */
        var showCancel = function showCancel(selectedItems) {
            if (!selectedItems || selectedItems.length == 0) return false;

            var show = true;
            _.forEach(selectedItems, function (item) {
                if (!validForCancel(item)) {
                    show = false;
                }
            });
            return show;
        };

        /**
         * Cancel button is displayed to the user that made the request AND if the current status is REQUESTED
         * @param item
         * @returns {*|boolean}
         */
        function validForCancel(item) {
            return item.ownRequest && item.statusId == STATUSES.REQUESTED;
        }

        /**
         * To show the accept/decline buttons all of the selected items must pass the validation test
         * @param selectedItems
         * @returns {boolean}
         */
        var showAcceptDecline = function showAcceptDecline(selectedItems) {
            if (!selectedItems || selectedItems.length == 0) return false;

            var show = true;
            _.forEach(selectedItems, function (item) {
                if (!validForAcceptDecline(item)) {
                    show = false;
                }
            });
            return show;
        };

        /**
         * Approve and decline buttons are only displayed WHEN
         * The logged in user is not the one who requested (!item.ownRequest)
         * The Sample is from the logged in User location (item.sameLocation)
         * The user is at least coordinator
         * And the current status is requested
         * @param item
         */
        function validForAcceptDecline(item) {
            return !item.ownRequest && item.sameLocation && vm.isCoordinator && item.statusId == STATUSES.REQUESTED;
        }

        /**
         * To show the send now button all of the selected items must pass the validation test
         * @param selectedItems
         * @returns {boolean}
         */
        var showSendNow = function showSendNow(selectedItems) {
            if (!selectedItems || selectedItems.length == 0) return false;

            var show = true;
            _.forEach(selectedItems, function (item) {
                if (!validForSendNow(item)) {
                    show = false;
                }
            });
            return show;
        };

        /**
         * Send now button is displayed when
         * The logged in user is not the requester (!item.ownRequest)
         * The User is at least coordinator and the sample is from his location (item.sameLocation && vm.isCoordinator)
         * The current status of the Order is APPROVED
         * @param item
         * @returns {boolean|*}
         */
        function validForSendNow(item) {
            return !item.ownRequest && item.sameLocation && vm.isCoordinator && item.statusId == STATUSES.APPROVED;
        }

        /**
         * Process the rows selected
         * @param rows
         * @param btn the btn object will contain the actionStatus and the successMessage
         */
        var btnClicked = function btnClicked(rows, btn) {
            var promises = [];

            //If it is a decline we have to prompt an input to the user to write the message
            if (btn.actionStatus == STATUSES.DECLINED) {
                AlertService.showInputMessageDialog('Decline Message', 'Please specify a reason').then(function (message) {
                    _.forEach(rows, function (row) {
                        promises.push(RequestHistory.save(prepareRequest(row, btn.actionStatus, message)).$promise);
                    });
                    updateRequests(promises, btn.successMessage);
                });
            } else {
                _.forEach(rows, function (row) {
                    promises.push(RequestHistory.save(prepareRequest(row, btn.actionStatus)).$promise);
                });
                updateRequests(promises, btn.successMessage);
            }
        };

        /**
         * Process the promises
         * @param promises array of promises to be resolved
         * @param successMessage the success message to be displayed
         */
        function updateRequests(promises, successMessage) {
            $scope.isLoadingRequests = true;

            $q.allSettled(promises).then(function (result) {
                var success = [];
                var errors = [];
                _.forEach(result, function (item) {
                    if ($q.isFulfilledState(item)) {
                        success.push(item);
                    } else {
                        errors.push(item);
                    }
                });

                //No error happened
                if (errors.length == 0) {
                    AlertService.toastSuccess(successMessage);
                } else {
                    var payload = {
                        success: success,
                        errors: errors
                    };
                    $mdDialog.show({
                        templateUrl: 'app/requests/requestErrorDialog.html',
                        controller: 'requestErrorDialogController',
                        clickOutsideToClose: true,
                        locals: {
                            data: payload
                        }
                    });
                }
            }).catch(function (err) {
                AlertService.showError(err);
            }).finally(function () {
                //after it's done, reload the table and hide the spinner
                $scope.isLoadingRequests = true;
                vm.reloadRequests();
                // $scope.isLoadingRequests = false;
            });
        }

        vm.tableButtons = [{
            title: 'Approve',
            style: "md-primary",
            callback: btnClicked,
            show: showAcceptDecline,
            actionStatus: STATUSES.APPROVED,
            successMessage: "Request(s) Approved"
        }, {
            title: 'Decline',
            style: "md-warn",
            callback: btnClicked,
            show: showAcceptDecline,
            actionStatus: STATUSES.DECLINED,
            successMessage: "Request(s) Declined"
        }, {
            title: 'Send now',
            style: "md-primary",
            callback: btnClicked,
            show: showSendNow,
            actionStatus: STATUSES.SENT,
            successMessage: "Request(s) Sent"
        }, {
            title: 'Cancel request',
            style: "md-warn",
            callback: btnClicked,
            show: showCancel,
            actionStatus: STATUSES.CANCELLED,
            successMessage: "Request(s) Cancelled"
        }];

        vm.onRowClick = function (row) {
            $state.go('logRequestView', { id: row.id });

            //if we already have a sample detail opened
            //don't do transition for the old one
            var sampleViews = angular.element(document.querySelectorAll('[ui-view="logRequestView"]:not(:empty)'));
            angular.forEach(sampleViews, function (el) {
                angular.element(el).addClass('old-sampleview');
            });
        };

        vm.yearChanged = function () {
            vm.reloadRequests();
        };

        /**
         * Return whether search results and/or sample view should be visible, depending on state and viewport.
         */
        vm.isViewShown = function (viewName) {
            // don't show sampleView and search side by side, as we won't have enough space
            if ($mdMedia(vm.mediaQueries.logViewSideBySide)) return true;else if ($state.is('requests') && viewName === 'requests') return true;else if ($state.is('logRequestView') && viewName === 'logRequestView') return true;

            return false;
        };

        function prepareYearsDropdown() {
            $scope.years = [];

            var startYear = 2015;
            var currentYear = new Date().getFullYear();

            while (startYear <= currentYear) {
                $scope.years.unshift(startYear);
                startYear++;
            }
        }

        vm.init();
    });
})();
'use strict';

(function () {
    'use strict';

    angular.module('braininstituteApp').config(function ($stateProvider) {
        $stateProvider.state('logRequestView', {
            parent: 'requests',
            url: '/log/:id',
            data: {
                authorities: ['OP_AUTHENTICATED'],
                pageTitle: 'global.menu.adminTools.request'
            },
            views: {
                'logRequestView': {
                    templateUrl: 'app/requests/requests-log.html',
                    controller: 'RequestsLogController as ctrl'
                }
            },
            resolve: {
                translatePartialLoader: function translatePartialLoader($translate, $translatePartialLoader) {
                    return $translate.refresh();
                }
            }
        });
    });
})();
'use strict';

(function () {
    'use strict';

    angular.module('braininstituteApp').controller('RequestsLogController', RequestsLogController);

    function RequestsLogController($scope, $log, WebService, $stateParams, $state) {
        var vm = this;
        var requestId = $stateParams.id;

        vm.init = function () {
            $scope.loading = true;
            WebService.HistoriesByRequest.query({ requestId: requestId }, function (data) {
                $scope.logs = data._embeddedItems;
                $log.debug($scope.logs);
                process();

                onFinishedLoadingData();
            });
        };

        function onFinishedLoadingData() {
            vm.isLoadingData = false;

            // var sampleViews = angular.element(document.querySelectorAll('[ui-view="logRequestView"].old-sampleview'));
            // angular.forEach(sampleViews, function (el){
            //     angular.element(el).removeClass('old-sampleview');
            // });
        }

        vm.init();

        vm.formatText = function (log) {
            var text = log.actionUserFullName + " from " + log.requesterLocation + " " + log.status;
            var message;
            switch (log.statusId) {
                case 1:
                    //cancel
                    text += " his request for Sample " + (log.sampleCode || log.sampleId) + " from " + log.sampleLocation;
                    break;
                case 2:
                    //requested
                    text += " " + (log.aliquotsRequested || "") + " aliquots of Sample " + (log.sampleCode || log.sampleId) + " (" + log.sampleName + ")" + " from the patient " + log.patientCode + " from " + log.sampleLocation;
                    break;
                case 3:
                    //approved
                    text += " the request of " + log.requesterFullName + " from " + log.requesterLocation + " for the Sample " + (log.sampleCode || log.sampleId) + " from " + log.sampleLocation;
                    break;
                case 4:
                    //declined
                    text += " the request of " + log.requesterFullName + " from " + log.requesterLocation + " for the Sample " + (log.sampleCode || log.sampleId) + " from " + log.sampleLocation;
                    message = "Reason: " + log.message;
                    break;
                case 5:
                    //sent
                    text += " " + (log.aliquotsRequested || "") + " aliquots of Sample " + (log.sampleCode || log.sampleId) + " to " + log.requesterFullName + " from " + log.requesterLocation;
                    break;
            }

            return { text: text, message: message };
        };

        vm.formatDate = function (date) {
            return moment(date).format("MMMM Do YYYY, h:mm a");
        };

        function process() {
            $scope.formattedLogs = [];
            $scope.logs.forEach(function (log) {
                var result = vm.formatText(log);
                $scope.formattedLogs.push({
                    text: result.text,
                    message: result.message,
                    date: vm.formatDate(log.dtAction)
                });
            });

            //Finished loading
            $scope.loading = false;
        }

        $scope.cancel = function () {
            $state.go('requests');
        };
    }
})();
'use strict';

/**
 * Created by Daniel Costa <danielcosta123@gmail.com> on 10/14/2015.
 */
(function () {
    'use strict';

    angular.module('braininstituteApp').controller('requestErrorDialogController', requestErrorDialogController);

    function requestErrorDialogController($scope, $mdDialog, locals) {
        var vm = this;
        $scope.success = locals.data.success;
        $scope.errors = locals.data.errors;

        $scope.cancel = $mdDialog.hide;
    }
})();
'use strict';

/**
 * Created by Daniel Costa <danielcosta123@gmail.com> on 10/14/2015.
 */
(function () {
    'use strict';

    angular.module('braininstituteApp').controller('logDialogController', logDialogController);

    function logDialogController($scope, $mdDialog, $log, locals, WebService) {
        var vm = this;
        var requestId = locals.requestId;

        vm.init = function () {
            $scope.loading = true;
            WebService.HistoriesByRequest.query({ requestId: requestId }, function (data) {
                $scope.logs = data._embeddedItems;
                $log.debug($scope.logs);
                process();
            });
        };

        vm.init();

        vm.formatText = function (log) {
            var text = log.actionUserFullName + " from " + log.requesterLocation + " " + log.status;
            var message;
            switch (log.statusId) {
                case 1:
                    //cancel
                    text += " his request for Sample " + (log.sampleCode || log.sampleId) + " from " + log.sampleLocation;
                    break;
                case 2:
                    //requested
                    text += " " + (log.aliquotsRequested || "") + " aliquots of Sample " + (log.sampleCode || log.sampleId) + " (" + log.sampleName + ")" + " from the patient " + log.patientCode + " from " + log.sampleLocation;
                    break;
                case 3:
                    //approved
                    text += " the request of " + log.requesterFullName + " from " + log.requesterLocation + " for the Sample " + (log.sampleCode || log.sampleId) + " from " + log.sampleLocation;
                    break;
                case 4:
                    //declined
                    text += " the request of " + log.requesterFullName + " from " + log.requesterLocation + " for the Sample " + (log.sampleCode || log.sampleId) + " from " + log.sampleLocation;
                    message = "Reason: " + log.message;
                    break;
                case 5:
                    //sent
                    text += " " + (log.aliquotsRequested || "") + " aliquots of Sample " + (log.sampleCode || log.sampleId) + " to " + log.requesterFullName + " from " + log.requesterLocation;
                    break;
            }

            return { text: text, message: message };
        };

        vm.formatDate = function (date) {
            return moment(date).format("MMMM Do YYYY, h:mm a");
        };

        function process() {
            $scope.formattedLogs = [];
            $scope.logs.forEach(function (log) {
                var result = vm.formatText(log);
                $scope.formattedLogs.push({
                    text: result.text,
                    message: result.message,
                    date: vm.formatDate(log.dtAction)
                });
            });

            //Finished loading
            $scope.loading = false;
        }

        $scope.cancel = function () {
            $mdDialog.hide();
        };
    }
})();
'use strict';

(function () {
    'use strict';

    angular.module('braininstituteApp').config(function ($stateProvider) {
        $stateProvider.state('sampleView', {
            parent: 'search',
            url: '/sample/{id:URL}',
            data: {
                authorities: ['OP_AUTHENTICATED'],
                pageTitle: 'global.menu.adminTools.sample'
            },
            views: {
                'sampleInSearchView': {
                    templateUrl: 'app/sample/sample-view.html',
                    controller: 'SampleViewController as sampleView'
                }
            },
            resolve: {
                translatePartialLoader: function translatePartialLoader($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('sample');
                    $translatePartialLoader.addPart('patient');
                    return $translate.refresh();
                }
            }
        });
    });
})();
'use strict';

(function () {
    'use strict';

    angular.module('braininstituteApp').controller('SampleViewController', SampleViewController);

    function SampleViewController($state, $element, $timeout, $stateParams, $mdDialog, $scope, $log, $translate, AlertService, Principal, SampleService, formsService, DateUtils, dateService, EntitiesUtil, SearchService, responsiveDesignService, $mdMedia) {
        var vm = this;
        vm.preparePatientData = preparePatientData;
        vm.prepareSampleData = prepareSampleData;
        vm.requestSampleClicked = requestSampleClicked;
        vm.editSampleClicked = editSampleClicked;
        vm.editPatientClicked = editPatientClicked;
        vm.deleteSampleClicked = deleteSampleClicked;
        vm.deletePatientClicked = deletePatientClicked;
        vm.resetFormWithPatient = resetFormWithPatient;
        vm.goBackToSearchClicked = goBackToSearchClicked;
        vm.isLoadingData = true;

        init();

        function init() {
            vm.hasInvestigator = Principal.isInRole("OP_INVESTIGATOR");
            vm.url = $stateParams.id;
            $state.get('sampleView').data.url = vm.url;

            vm.isAdmin = Principal.isInRole('OP_ADMIN');
            vm.isCoordinator = Principal.isInRole('OP_COORDINATOR');

            EntitiesUtil.clearETags();

            EntitiesUtil.get(vm.url, 'sampleView').then(function (data) {
                vm.isOwnLocation = data.currentLocation;

                prepareButtons(data);
                prepareSampleData(data);
                preparePatientData(data);

                vm.isLoadingData = false;
            }, null);
        }

        function preparePatientData(sample) {
            var patient = sample.patient;
            vm.patient = {};
            vm.patient._links = sample.patient._links;
            vm.patient.siteLocation = sample.siteLocation.name;
            vm.patient.code = patient.code;
            vm.patient.gender = formsService.getGender(patient.fgGender);
            vm.patient.lengthOfSurvival = SampleService.formatLengthOfSurvival(patient.lengthOfSurvivalYear, patient.lengthOfSurvivalMonth);
        }

        function prepareSampleData(sampleInfo) {
            vm.sample = sampleInfo;

            vm.sample.dtSurgery = DateUtils.convertLocaleYearFromServer(sampleInfo.dtSurgery);
            vm.sample.dtDiagnosis = dateService.dateToMonthInput(sampleInfo.dtDiagnosis);
            vm.sample.molecular = sampleInfo.moleculars ? sampleInfo.moleculars : '';
            vm.sample.availability = SampleService.parseAvailability(sampleInfo) === true ? 'Available' : 'Not available';
            vm.sample.aliquots = SampleService.parseAliquots(sampleInfo);
            vm.sample.diagnoses = SampleService.parseDiagnosis(sampleInfo.diagnoses);
            vm.sample.locations = SampleService.format(sampleInfo.locations);
            vm.sample.sampleTypes = SampleService.format(sampleInfo.sampleTypes);
        }

        function prepareButtons(sample) {
            vm.buttons = {};

            vm.buttons.requestBtn = {};

            vm.buttons.requestBtn.enabled = !SampleService.isSampleUnavailable(sample) && !sample.requested;
            if (sample.requested) vm.buttons.requestBtn.tooltip = 'You have an open request for this sample';else if (SampleService.isSampleUnavailable(sample)) vm.buttons.requestBtn.tooltip = 'Sample unavailable';else vm.buttons.requestBtn.tooltip = 'Request';

            vm.buttons.editBtn = {};
            vm.buttons.editBtn.enabled = !sample.requested && !sample.haveRequestsOpen && (vm.isAdmin || vm.isCoordinator && vm.isOwnLocation);

            vm.buttons.deleteMenuBtn = {
                visible: vm.isAdmin || vm.isCoordinator && vm.isOwnLocation
            };
        }

        function requestSampleClicked() {
            $mdDialog.show({
                templateUrl: 'app/sample/request-sample-dialog.html',
                controller: 'RequestSampleDialogController',
                clickOutsideToClose: true,
                fullscreen: responsiveDesignService.mdDialogFullScreen(),
                locals: {
                    sampleUrl: vm.url
                }
            }).then(function (success) {
                if (success) vm.buttons.requestBtn.enabled = false;
            });
        }

        function editPatientClicked() {
            $mdDialog.show({
                controller: 'NewPatientDialogController',
                templateUrl: 'app/patient/new-patient-dialog.html',
                fullscreen: responsiveDesignService.mdDialogFullScreen(),
                locals: {
                    patientURL: vm.patient._links.self.href.replace('{?projection}', '') //adjust the id
                },
                parent: angular.element(document.body),
                clickOutsideToClose: true
            }).then(function (result) {
                if (result && result.action && result.action === 'reload') {
                    init();
                }
            }, function () {
                //cancelled
            });
        }

        function editSampleClicked() {
            $mdDialog.show({
                controller: 'SampleEditFormController',
                templateUrl: 'app/sample/sample-edit-form.html',
                fullscreen: responsiveDesignService.mdDialogFullScreen(),
                locals: {
                    sampleURL: vm.url
                },
                parent: angular.element(document.body),
                clickOutsideToClose: true
            }).then(function (result) {
                if (result && result.action && result.action === 'reload') {
                    SearchService.resetSearchBroadcast();
                    init();
                }
            }, function () {
                //cancelled
            });
        }

        function deleteSampleClicked() {
            if (!vm.isAdmin && vm.isCoordinator && !vm.isOwnLocation) {
                AlertService.showAlert('Unauthorized', 'You cannot delete this sample because it belongs to a different site.');
                return;
            }

            if (vm.sample.haveRequestsOpen) {
                AlertService.showAlert('Unauthorized', 'You cannot delete this sample as there is an active request for it. Please cancel any requests for this sample and try again.');
                return;
            }

            var codeOrId;
            if (vm.sample.code) codeOrId = 'code ' + vm.sample.code;else codeOrId = 'ID ' + vm.sample.id;

            AlertService.showDeleteConfirm('sample', codeOrId).then(function () {
                EntitiesUtil.delete(vm.url).then(function () {
                    AlertService.toastSuccess('Sample ' + codeOrId + ' has been deleted.');
                    SearchService.resetSearchBroadcast(true);
                }, function (err) {});
            }, function () {});
        }

        function deletePatientClicked() {
            if (!vm.isAdmin && vm.isCoordinator && !vm.isOwnLocation) {
                AlertService.showAlert('Unauthorized', 'You cannot delete this patient because they belong to a different site.');
                return;
            }

            if (vm.sample.haveRequestsOpen) {
                AlertService.showAlert('Unauthorized', 'You cannot delete this Patient as there is an active request for this Sample. Please cancel any requests for this sample and try again.');
                return;
            }

            var patientUri = vm.sample.patient._links.self.href.replace('{?projection}', '');
            EntitiesUtil.get(patientUri). //get the new patient record with ETag
            then(function (data) {
                AlertService.showConfirm('Delete patient record', 'If you continue, you will delete all the samples ' + 'associated with the patient ' + vm.patient.code + '  as well as the Patient data itself. ' + 'Are you sure?').then(function () {
                    EntitiesUtil.delete(patientUri).then(function () {
                        AlertService.toastSuccess('Patient ' + vm.sample.patient.code + ' and their associated samples have been ' + 'deleted.');
                        SearchService.resetSearchBroadcast(true);
                    }, function (err) {});
                }, function () {});
            });
        }

        function resetFormWithPatient(patientCode) {
            SearchService.resetFormBroadcast('patientCodeRaw', patientCode);

            if ($mdMedia('(max-width: 839px)')) {
                goBackToSearchClicked();
            }
        }

        function goBackToSearchClicked() {
            $state.go('search');
        }
    }
})();
'use strict';

(function () {
    'use strict';

    angular.module('braininstituteApp').service('SampleService', sampleService);

    function sampleService($mdDialog, WebService, responsiveDesignService) {
        this.isSampleUnavailable = function (sampleInfo) {
            if (sampleInfo.blocked) {
                return true;
            }
            if (sampleInfo.sampleType.countable) return sampleInfo.aliquots === 0;else return !sampleInfo.containAliquots;
        };

        this.isSampleRequested = function (sampleId) {
            //If there's a request opened for this sample by the logged in User will return > 0
            //Else will return 0
            return WebService.RequestOpenByUserAndSampleId.get({ sampleId: sampleId }).$promise;
        };

        this.shouldHideRequestButton = function (row) {
            return row.disableRequest || row.requested;
        };

        this.shouldHideNotAvailableButton = function (row) {
            return !(row.disableRequest && !row.requested);
        };

        this.shouldHideSampleRequestedButton = function (row) {
            return !row.requested;
        };

        this.diagnosisSteps = ['WHO Tumor Classification', 'Histological Subtype Tier 1', 'Histological Subtype Tier 2'];

        this.parseDiagnosis = function (diagnoses) {
            var updated = [];
            var self = this;
            angular.forEach(diagnoses.split('||'), function (item, index) {
                updated.push({
                    name: item,
                    title: self.diagnosisSteps[index]
                });
            });

            return updated;
        };

        this.format = function (string) {
            return string.replace(/\|\|/g, ', ');
        };

        this.parseAliquots = function (sampleInfo) {
            if (sampleInfo.sampleType.countable) return sampleInfo.aliquots;else return sampleInfo.containAliquots ? "Yes" : "No";
        };

        this.parseAvailability = function (sampleInfo) {
            return !sampleInfo.blocked;
        };

        this.formatLengthOfSurvival = function (year, month) {
            var arr = [];
            if (year) arr.push(year + ' years');
            if (month) arr.push(month + ' months');
            if (!year && !month) arr.push('-');
            return arr.join(', ');
        };
    }
})();
'use strict';

//this file is temporarily not being used (dialog is shown without its own state)
(function () {
    'use strict';

    angular.module('braininstituteApp').config(function ($stateProvider) {
        $stateProvider.state('sampleEdit', {
            parent: 'search',
            url: '/sample/{sampleId}/edit',
            data: {
                authorities: ['OP_AUTHENTICATED'],
                pageTitle: 'global.menu.adminTools.sample'
            },
            views: {
                'content@': {
                    //templateUrl: 'app/sampleEdit/sampleEdit.html',
                    //controller: 'sampleEditController as sampleEdit'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('sample');
                    return $translate.refresh();
                }]
            }
        });
    });
})();
'use strict';

(function () {
    'use strict';

    angular.module('braininstituteApp').controller('SampleEditFormController', SampleEditFormController);

    function SampleEditFormController($scope, $mdDialog, AlertService, $translate, SampleService, formsService, Molecular, dateService, DateUtils, locals, Diagnosis, Location, EntitiesUtil) {
        $scope.sampleURL = locals.sampleURL;

        var init = function init() {
            $scope.diagnosisDropdownTitles = ['WHO Tumor Classification', 'Histological Subtype Tier 1', 'Histological Subtype Tier 2'];
            $scope.loadingData = true;
            $scope.savingSample = false;

            $scope.topDiagnosis = {};
            $scope.topLocation = {};
            $scope.topSampleType = {};
            $scope.selectedMoleculars = [];

            $scope.genders = formsService.genders;

            Molecular.resource.query(function (data) {
                $scope.moleculars = data._embeddedItems;
            });

            $scope.DiagnosisQuery = function (callback) {
                Diagnosis.topLevel().then(callback);
            };

            $scope.LocationQuery = function (callback) {
                Location.topLevel().then(callback);
            };

            EntitiesUtil.get($scope.sampleURL, 'sampleEdit').then(function (data) {
                //Load moleculars
                EntitiesUtil.get(data._links.moleculars.href, '').then(function (moleculars) {
                    $scope.selectedMoleculars = moleculars._embeddedItems;
                    loadSampleData(data);
                    $scope.loadingData = false;
                });
            }, function () {
                $mdDialog.cancel();
            });
        };

        function loadSampleData(sample) {
            $scope.sampleInfo = sample;
            formatData(sample);
            $scope.isSampleUnavailable = SampleService.isSampleUnavailable(sample);
        }

        function formatData(sampleInfo) {
            if (sampleInfo) {
                if (sampleInfo.dtDiagnosis) $scope.dtDiagnosisText = dateService.dateToMonthInput(sampleInfo.dtDiagnosis);
                if (sampleInfo.dtSurgery) $scope.dtSurgeryClientModel = DateUtils.convertLocaleYearFromServer(sampleInfo.dtSurgery);
            }
        }

        $scope.sampleFormSubmit = function () {
            if (!$scope.sampleForm.$valid || $scope.savingSample) return;

            $scope.savingSample = true;

            var sampleInfo = angular.copy($scope.sampleInfo);

            sampleInfo.patient = sampleInfo.patient._links.self.href.replace('{?projection}', '');

            if ($scope.selectedMoleculars) {
                sampleInfo.moleculars = [];
                _.forEach($scope.selectedMoleculars, function (molecular) {
                    sampleInfo.moleculars.push(molecular._links.self.href);
                });
            } else {
                sampleInfo.moleculars = null;
            }

            //Get the last level of selected diagnosis
            if ($scope.topDiagnosis && $scope.topDiagnosis._links) {
                sampleInfo.diagnosis = $scope.topDiagnosis._links.self.href;
            } else {
                sampleInfo.diagnosis = null;
            }

            //Get the last level of selected Locations
            if ($scope.topLocation && $scope.topLocation._links) {
                sampleInfo.location = $scope.topLocation._links.self.href;
            } else {
                sampleInfo.location = null;
            }

            //Get the last level of selected sample type
            if ($scope.topSampleType && $scope.topSampleType._links) {
                sampleInfo.sampleType = $scope.topSampleType._links.self.href;
            } else {
                sampleInfo.sampleType = null;
            }

            if ($scope.sampleInfo.molecular && $scope.sampleInfo.molecular._links) {
                sampleInfo.molecular = $scope.sampleInfo.molecular._links.self.href;
            } else {
                sampleInfo.molecular = null;
            }

            if ($scope.dtSurgeryClientModel) {
                sampleInfo.dtSurgery = DateUtils.convertLocaleYearToServer($scope.dtSurgeryClientModel);
            } else {
                sampleInfo.dtSurgery = null;
            }

            if ($scope.dtDiagnosisText) {
                sampleInfo.dtDiagnosis = dateService.monthInputToDate($scope.dtDiagnosisText);
            } else {
                $scope.dtDiagnosisText = null;
            }

            if ($scope.sampleURL) {
                EntitiesUtil.update($scope.sampleURL, sampleInfo).then(function () {
                    $scope.savingSample = false;
                    AlertService.toastSuccess("Sample data saved.");
                    $mdDialog.hide({ action: 'reload' });
                }, function () {
                    $scope.savingSample = false;
                    AlertService.toastError("Error saving Sample data");
                });
            }
        };

        $scope.cancel = function () {
            $mdDialog.cancel();
        };

        init();
    }
})();
'use strict';

(function () {
    'use strict';

    angular.module('braininstituteApp').controller('RequestSampleDialogController', RequestSampleDialogController);

    function RequestSampleDialogController($scope, $mdDialog, $log, locals, AlertService, SampleRequest, EntitiesUtil) {
        $scope.sendRequest = sendRequest;

        EntitiesUtil.get(locals.sampleUrl, 'sampleView').then(function (data) {
            $scope.request = {
                sampleInfo: data._links.self.href
            };
            $scope.aliquotsAvailable = data.aliquots;
            $scope.isCountable = data.sampleType.countable;

            if (data.requested) {
                $scope.requestable = false;
                $scope.error = 'You have an open request for this sample.';
            } else if (data.haveRequestsOpen) {
                $scope.requestable = false;
                $scope.error = 'There are open requests for this sample.';
            } else {
                $scope.requestable = true;
            }
        });

        function sendRequest() {
            if (!$scope.requestForm.$valid) return;
            SampleRequest.create($scope.request, function (response) {
                AlertService.toastSuccess("Requested successfully!");
                $mdDialog.hide();
            }, function (err) {
                $log.debug(err);
                AlertService.showError(err);
                $mdDialog.hide();
            });
        }

        $scope.hide = $mdDialog.hide;
        $scope.cancel = $mdDialog.cancel;
    }
})();
'use strict';

(function () {
    'use strict';

    angular.module('braininstituteApp').factory('NewRecordService', function ($mdDialog, $state, _, responsiveDesignService) {
        return {
            //Optional patient, will load the dialog with the patient pre-loaded
            showNewRecordDialog: function showNewRecordDialog(patientCode, options, callback) {

                var defaults = {
                    controller: 'NewRecordDialogController',
                    templateUrl: 'app/sample/new-record-dialog.html',
                    parent: angular.element(document.body),
                    fullscreen: responsiveDesignService.mdDialogFullScreen(),
                    locals: {
                        patientCode: patientCode
                    },
                    clickOutsideToClose: true
                };

                var opt = _.defaults(options, defaults);

                $mdDialog.show(opt).then(function (sampleSaved) {
                    if (sampleSaved && sampleSaved._links) {
                        $state.go('sampleView', { id: sampleSaved._links.self.href });
                    }

                    if (callback) callback();
                }, function () {
                    if (callback) callback();
                });
            }

        };
    });
})();
'use strict';

//this file is temporarily not being used (dialog is shown without its own state)
(function () {
    'use strict';

    angular.module('braininstituteApp').config(function ($stateProvider) {

        $stateProvider.state('newRecord', {
            parent: 'site',
            url: '/newRecord',
            data: {
                authorities: ['OP_COORDINATOR', 'OP_ADMIN'],
                pageTitle: 'global.menu.adminTools.newRecord'
            },
            views: {
                'content@': {
                    templateUrl: 'app/sample/record/new-record-dialog.html',
                    controller: 'newRecordController as newRecord'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('newRecord');
                    $translatePartialLoader.addPart('sampleInfo');
                    $translate.forceAsyncReload(true);

                    return $translate.refresh();
                }]
            }
        });
    });
})();
'use strict';

(function () {
    'use strict';

    angular.module('braininstituteApp').directive("invalidPatient", function () {
        return {
            restrict: "A",
            require: "ngModel",
            link: function link(scope, element, attributes, ngModel) {
                // Listen for change events to enable binding
                element.on('keypress change', function () {
                    scope.invalidPatientCode = false;
                    scope.permission = true;
                    ngModel.$setValidity("invalidpatient", true);
                    ngModel.$setValidity("nopermission", true);
                });

                ngModel.$validators.invalidpatient = function () {
                    return !scope.invalidPatientCode;
                };

                ngModel.$validators.nopermission = function () {
                    return scope.permission;
                };
            }
        };
    }).controller('NewRecordDialogController', NewRecordDialogController);

    function NewRecordDialogController($scope, $mdDialog, $mdBottomSheet, formsService, Molecular, Location, Diagnosis, SampleInfo, AlertService, DateUtils, dateService, Principal, Patient, $q, SearchService, locals, EntitiesUtil) {
        $scope.isSubmitting = false;
        $scope.invalidPatientCode = false;
        $scope.patientFound = false; //Variable to disable Patient fields, if the patient was loaded from DB
        $scope.loadingPatient = false; //Variable to control the Progress circle while loading the patient data
        $scope.permission = true;
        $scope.sampleInfo = {};
        $scope.samples = [];
        $scope.patientUri = null;
        $scope.selectedMoleculars = [];
        $scope.siteLocaiton = null;

        $scope.init = function () {
            $scope.diagnosisDropdownTitles = ['WHO Tumor Classification', 'Histological Subtype Tier 1', 'Histological Subtype Tier 2'];
            $scope.genders = formsService.genders;
            $scope.topDiagnosis = {};
            $scope.topLocation = {};
            $scope.topSampleType = null;

            if (locals && locals.patientCode) {
                $scope.sampleInfo.patientCode = locals.patientCode;
                $scope.onPatientBlur();
            }

            Molecular.resource.query(function (data) {
                $scope.moleculars = data._embeddedItems;
            });

            $scope.DiagnosisQuery = function (callback) {
                Diagnosis.topLevel().then(callback);
            };

            $scope.LocationQuery = function (callback) {
                Location.topLevel().then(callback);
            };

            $scope.isAdmin = Principal.isInRole('OP_ADMIN');

            if (!$scope.isAdmin) {
                Principal.identity().then(function (user) {
                    $scope.siteLocation = user.siteLocation._links.self.href;
                    $scope.siteLocation = $scope.siteLocation.replace('{?projection}', ''); //remove any URI template
                });
            }
        };

        $scope.onPatientBlur = function () {
            $scope.invalidPatientCode = false;
            $scope.patientFound = false;
            $scope.permission = true;

            var code = $scope.sampleInfo.patientCode;
            if (!code || code == '') return;
            //Will show Progress circular
            $scope.loadingPatient = true;
            //Search for the latest Sample for this Patient, to pre-load data.

            var promise;
            if ($scope.isAdmin) {
                //admin can search across all location
                promise = SampleInfo.topByPatientCode(code, 'sampleEdit');
            } else {
                //search only with in the user location
                promise = SampleInfo.topByPatientCodeAndSiteLocation(code, $scope.siteLocation, 'sampleEdit');
            }

            promise.then(function (data) {
                if (data) {
                    loadData(data);

                    var resources = data._resources("patient");
                    resources.get(function (data) {
                        $scope.patientUri = data._links.self.href;
                    });

                    $scope.invalidPatientCode = false;
                    $scope.patientFound = true;
                    $scope.loadingPatient = false;
                }
            }, function (err) {
                if (err.status === 404) {
                    //sample not found
                    Patient.byCode(code).then(function (data) {
                        if (data) {
                            loadData();
                            $scope.patientUri = data._links.self.href;
                            $scope.invalidPatientCode = false;
                            $scope.patientFound = true;
                            $scope.loadingPatient = false;
                        }
                    }, function (err) {
                        //error
                        if (err.status === 404) {
                            AlertService.toastWarning('No patient found with this code.');
                            $scope.patientFound = false;
                            $scope.invalidPatientCode = true;
                            $scope.loadingPatient = false;
                            $scope.recordForm.patientCode.$validate();
                        } else {
                            afterErrorOnFetch(err);
                        }
                    });
                } else {
                    afterErrorOnFetch(err);
                }
            });
        };

        /**
         * Stop the form submission and executed the patient search
         * when enter is pressed on the patient code field
         * @param event
         */
        $scope.onKeyPressed = function (event) {
            if (event.keyCode == 13) {
                //enter pressed
                event.preventDefault();

                $scope.onPatientBlur();
            }
        };

        function afterErrorOnFetch(err) {
            $scope.patientFound = false;
            $scope.invalidPatientCode = true;
            $scope.loadingPatient = false;

            if (err.status == 403) {
                $scope.permission = false;
                $scope.recordForm.patientCode.$validate();
            }
        }

        /**
         * @param sampleInfo - latest SampleInfo related to this patient, can be null
         * Will load the latest data, from this patient, data can be changed
         */
        function loadData(sampleInfo) {
            if (sampleInfo) {
                var reallyLoad = function reallyLoad() {
                    EntitiesUtil.get(sampleInfo._links.moleculars.href, '').then(function (moleculars) {
                        $scope.selectedMoleculars = moleculars._embeddedItems;
                        $scope.sampleInfo = sampleInfo;
                        $scope.sampleInfo.patientCode = sampleInfo.patient.code;
                        formatData(sampleInfo);
                        AlertService.toastSuccess('Your last entries for this patient were repopulated');
                    });
                };
                $mdBottomSheet.show({
                    templateUrl: 'app/sample/new-record-preload-confirm-bottom-sheet.html',
                    controller: function controller($scope, $mdBottomSheet) {
                        $scope.yes = $mdBottomSheet.hide;
                        $scope.no = $mdBottomSheet.cancel;
                    },
                    parent: 'md-dialog'
                }).then(reallyLoad);
            }
        }

        function formatData(sampleInfo) {
            if (sampleInfo) {
                if (sampleInfo.dtDiagnosis) $scope.dtDiagnosisText = dateService.dateToMonthInput(sampleInfo.dtDiagnosis);
                if (sampleInfo.dtSurgery) $scope.dtSurgeryClientModel = DateUtils.convertLocaleYearFromServer(sampleInfo.dtSurgery);
            }
        }

        /**
         *
         * @param st - Sample type object on the list
         * Delete the sample type from the MD-list
         */
        $scope.deleteSampleType = function (st) {
            _.remove($scope.samples, function (obj) {
                return obj == st;
            });
        };

        $scope.init();

        $scope.sampleTypeAdd = function () {
            var copy = angular.copy($scope.sampleInfo);
            copy.sampleType = $scope.topSampleType;
            copy.diagnosis = $scope.topDiagnosis;
            copy.location = $scope.topLocation;
            copy.dtSurgeryClientModel = $scope.dtSurgeryClientModel;
            copy.dtDiagnosisText = $scope.dtDiagnosisText;
            copy.patient = $scope.patientUri;

            $scope.samples.push(copy);
            $scope.sampleInfo.aliquots = null;
            $scope.sampleInfo.code = null;
            $scope.sampleInfo.blocked = false;
            $scope.sampleInfo.sampleType = {}; //send empty object and not null to trigger watcher in the directive
        };

        $scope.submit = function () {
            if (!$scope.recordForm.$valid || $scope.isSubmitting || $scope.samples.length === 0 || !$scope.patientFound) {
                $scope.recordForm.$setSubmitted(true);
                return;
            }

            $scope.isSubmitting = true;

            var samples = angular.copy($scope.samples);

            var promises = [];

            angular.forEach(samples, function (st) {
                if ($scope.selectedMoleculars) {
                    st.moleculars = [];
                    _.forEach($scope.selectedMoleculars, function (molecular) {
                        st.moleculars.push(molecular._links.self.href);
                    });
                } else {
                    st.moleculars = null;
                }

                if (st.diagnosis && st.diagnosis._links) {
                    st.diagnosis = st.diagnosis._links.self.href;
                } else {
                    st.diagnosis = null;
                }

                if (st.location && st.location._links) {
                    st.location = st.location._links.self.href;
                } else {
                    st.location = null;
                }

                if (st.sampleType && st.sampleType._links) {
                    st.sampleType = st.sampleType._links.self.href;
                }

                if (st.dtSurgeryClientModel) {
                    st.dtSurgery = DateUtils.convertLocaleYearToServer(st.dtSurgeryClientModel);
                }

                if (st.dtDiagnosisText) {
                    st.dtDiagnosis = dateService.monthInputToDate(st.dtDiagnosisText);
                }

                promises.push(SampleInfo.create(st));
            });

            $q.all(promises).then(function (result) {
                AlertService.toastSuccess("Sample saved!");
                $mdDialog.hide(result[0]);
                SearchService.resetFormBroadcast('patientCodeRaw', $scope.sampleInfo.patientCode);
            }).catch(function (err) {
                $scope.isSubmitting = false;
                AlertService.toastError("Error saving Sample data");
            });
        };

        $scope.cancel = $mdDialog.cancel;
    }
})();
'use strict';

(function () {
    'use strict';

    angular.module('braininstituteApp').factory('reportsService', [function () {
        return {};
    }]);
})();
'use strict';

(function () {
    'use strict';

    angular.module('braininstituteApp').config(function ($stateProvider) {

        $stateProvider.state('reports', {
            parent: 'site',
            url: '/reports',
            data: {
                authorities: ['OP_AUTHENTICATED'],
                pageTitle: 'global.menu.adminTools.reports'
            },
            views: {
                'content@': {
                    templateUrl: 'app/reports/reports.html',
                    controller: 'reportsController as reports'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('reports');
                    return $translate.refresh();
                }]
            }
        });
    });
})();
'use strict';

(function () {
    'use strict';

    angular.module('braininstituteApp').controller('reportsController', ['$scope', 'reportsService', function ($scope, reportsService) {}]);
})();
'use strict';

(function () {
    'use strict';

    angular.module('braininstituteApp').factory('NewPatientService', function ($mdDialog, AlertService, NewRecordService, _, responsiveDesignService) {
        return {
            showNewPatientDialog: function showNewPatientDialog(options, callback) {
                var defaults = {
                    controller: 'NewPatientDialogController',
                    templateUrl: 'app/patient/new-patient-dialog.html',
                    parent: angular.element(document.body),
                    locals: {},
                    clickOutsideToClose: true,
                    fullscreen: responsiveDesignService.mdDialogFullScreen()
                };

                var opt = _.defaults(options, defaults);
                $mdDialog.show(opt).then(function (result) {
                    if (result && result.action == 'createSample') {
                        AlertService.showConfirm("Add Sample", "Do you want to add a sample for the created patient?").then(function () {
                            NewRecordService.showNewRecordDialog(result.patientCode, {}, callback);
                        }, function () {
                            if (callback) callback();
                        });
                    } else {
                        if (callback) callback();
                    }
                }, function () {
                    //cancelled
                    if (callback) callback();
                });
            }

        };
    });
})();
'use strict';

(function () {
    'use strict';

    angular.module('braininstituteApp').directive('patientFound', function () {
        return {
            restrict: 'A',
            require: 'ngModel',
            link: function link(scope, element, attributes, ngModel) {
                element.on('keypress change', function () {
                    scope.patientFound = false;
                    ngModel.$setValidity('patientfound', true);
                });
                ngModel.$validators.patientfound = function () {
                    return !scope.patientFound;
                };
            }
        };
    }).controller('NewPatientDialogController', NewPatientDialogController);

    function NewPatientDialogController($scope, $mdDialog, formsService, AlertService, $translate, locals, SiteLocation, Principal, Patient, EntitiesUtil) {
        $scope.isSubmitting = false;
        $scope.loadingPatient = true;
        $scope.isEdit = false;
        $scope.patient = {};
        $scope.patientURL = locals.patientURL;

        $scope.cancel = $mdDialog.cancel;

        $scope.init = function () {
            $scope.isAdmin = Principal.isAdmin();

            if (!$scope.isAdmin) {
                Principal.identity().then(function (user) {
                    $scope.patient.siteLocation = user.siteLocation;
                    $scope.patient.siteLocation._links.self.href = $scope.patient.siteLocation._links.self.href.replace('{?projection}', ''); //remove any URI template
                });
            }

            SiteLocation.resource.query(function (data) {
                $scope.siteLocations = data._embeddedItems;

                if (!$scope.patientURL) {
                    $scope.loadingPatient = false;
                }
            });

            if ($scope.patientURL) {
                $scope.isEdit = true;

                EntitiesUtil.get($scope.patientURL, 'withSiteLocation').then(function (data) {
                    var patient = data;
                    if (patient.siteLocation) {
                        patient.siteLocation._links.self.href = patient.siteLocation._links.self.href.replace('{?projection}', ''); //adjust the id
                    }
                    $scope.patient = patient;

                    //The code is editable, but when changing the code it MUST be a code not used, or the original one (cannot use the code of other patient)
                    $scope.validCode = $scope.patient.code;
                    $scope.loadingPatient = false;
                }, function () {
                    $mdDialog.cancel();
                });
            }

            $scope.genders = formsService.genders;
            //Variable to disable Patient fields, if the patient was loaded from DB
            $scope.patientFound = false;
        };

        $scope.onPatientBlur = function () {
            var code = $scope.patient.code;
            if (!code || code === '') return;
            //Will show Progress circular
            $scope.loadingPatient = true;
            Patient.byCode(code).then(function (data) {
                if (data) {
                    //if the found patient, is the one being edited, then that's ok
                    if ($scope.isEdit && $scope.validCode == data.code) {
                        $scope.patientFound = false;
                    } else {
                        $scope.patientFound = true;
                        $scope.recordForm.patientCode.$validate();
                        AlertService.toastWarning($translate.instant('braininstituteApp.patient.messages.error.patientExists'));
                    }
                }
                //Will hide progress
                $scope.loadingPatient = false;
            }, function () {
                //error
                $scope.patientFound = false;
                $scope.loadingPatient = false;
            });
        };

        /**
         * Stop the form submission and executed the patient search
         * when enter is pressed on the patient code field
         * @param event
         */
        $scope.onKeyPressed = function (event) {
            if (event.keyCode == 13) {
                //enter pressed
                event.preventDefault();
                $scope.onPatientBlur();
            }
        };

        function hasWhiteSpace(s) {
            return (/\s/g.test(s)
            );
        }

        $scope.submit = function () {
            if (!$scope.recordForm.$valid || $scope.loadingPatient || $scope.isSubmitting || $scope.patientFound) return;

            $scope.isSubmitting = true;
            var patientData = angular.copy($scope.patient);

            if (hasWhiteSpace(patientData.code)) {
                AlertService.toastError("Error saving Patient data: Remove empty spaces from patient ID.");
                $scope.isSubmitting = false;
                return;
            }

            if ($scope.patient.siteLocation) {
                patientData.siteLocation = $scope.patient.siteLocation._links.self.href.replace('{?projection}', ''); //adjust the id
            }

            if ($scope.patientURL) {
                EntitiesUtil.update($scope.patientURL, patientData).then(function () {
                    $scope.isSubmitting = false;
                    AlertService.toastSuccess("Patient saved!");
                    $mdDialog.hide({ action: 'reload' });
                }, function () {
                    $scope.isSubmitting = false;
                    AlertService.toastError("Error saving Patient data");
                });
            } else {
                Patient.create(patientData).then(function () {
                    $scope.isSubmitting = false;
                    AlertService.toastSuccess("Patient saved!");
                    $mdDialog.hide({ action: 'createSample', patientCode: patientData.code });
                }, function () {
                    $scope.isSubmitting = false;
                    AlertService.toastError("Error saving Patient data");
                });
            }
        };

        $scope.init();
    }
})();
'use strict';

angular.module('braininstituteApp').config(function ($stateProvider) {
    $stateProvider.state('main', {
        url: '/',
        data: {},
        views: {
            'content@': {
                templateUrl: 'app/main/main.html',
                controller: 'MainController'
            }
        },
        resolve: {
            mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                $translatePartialLoader.addPart('global');
                $translatePartialLoader.addPart('main');
                return $translate.refresh();
            }]
        }
    });
});
'use strict';

angular.module('braininstituteApp').controller('MainController', function ($scope, $state) {
    $state.go('search');
});
'use strict';

(function () {
    'use strict';

    angular.module('tcincCommon').directive('searchbarDocuments', function () {
        return {
            restrict: 'E',
            templateUrl: 'app/document/searchbar-documents.html',
            controller: Controller
        };

        function Controller($scope) {}
    });
})();
'use strict';

(function () {
    'use strict';

    angular.module('braininstituteApp').config(function ($stateProvider) {
        $stateProvider.state('documents', {
            parent: 'site',
            url: '/documents',
            data: {
                authorities: ['OP_AUTHENTICATED'],
                pageTitle: 'braininstituteApp.document.pageTitle'
            },
            views: {
                'content@': {
                    templateUrl: 'app/document/document.html',
                    controller: 'DocumentController as ctrl'
                }
            },
            resolve: {
                translatePartialLoader: function translatePartialLoader($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('document');
                    return $translate.refresh();
                }
            }
        });
    });
})();
'use strict';

(function () {
    'use strict';

    angular.module('braininstituteApp').controller('DocumentController', function ($mdDialog, $q, $timeout, $mdSidenav, $sce, $scope, Document, SiteLocation, documentSearch, Principal, _, responsiveDesignService, $mdMedia, AlertService) {
        var vm = this;
        vm.query = [];
        vm.queryOptions = {};
        vm.showSearchUi = false;
        vm.isProcessing = false;
        vm.searched = false;
        vm.searchInput = angular.element(document.querySelector("#searchInput"));
        angular.extend(vm, documentSearch);
        vm.info = { doc: {} };
        vm.pageSize = 20;
        vm.page = 0;
        vm.items = [];
        vm.isLastPage = false;
        vm.sortBy = 'meta.name';
        vm.$mdMedia = $mdMedia;

        vm.hasInvestigator = false;

        vm.mediaQueries = {
            inlineSearchBar: '(min-width: 1300px)',
            fullWidthSearchBar: '(max-width: 1299px)'
        };

        vm.init = function () {
            vm.hasInvestigator = Principal.isInRole("OP_INVESTIGATOR");
        };

        $scope.$watch(function () {
            return $mdMedia(vm.mediaQueries.inlineSearchBar);
        }, function (value) {
            vm.inlineSearchBar = value;
            vm.fullWidthSearchBar = !value;
        });

        $scope.$watchCollection('ctrl.query', function (value) {
            vm.resetData();
        });

        Principal.identity().then(function (account) {
            vm.currentUserId = parseInt(account._links.self.href.substring(account._links.self.href.lastIndexOf('/') + 1));
        });

        vm.openDoc = function (link) {
            window.open(link + '?disposition=inline');
        };

        vm.resetData = function () {
            vm.isLastPage = false;
            vm.page = 0;
            vm.items = [];
            $timeout(function () {
                vm.nextPage();
            });
        };

        vm.uploadFileDialog = function () {
            $mdDialog.show({
                controller: "DocumentUploadController",
                templateUrl: 'app/document/file-form.html',
                parent: angular.element(document.body),
                fullscreen: responsiveDesignService.mdDialogFullScreen(),
                locals: {
                    category: null, //all categories
                    forUser: null, //for logged in user
                    share: true //allow share
                },
                clickOutsideToClose: true
            }).then(function (result) {
                if (result && result == 'success') {
                    vm.resetData();
                }
            }, function () {
                //cancelled
            });
        };

        vm.shareDoc = function (item) {
            $mdDialog.show({
                controller: "DocumentShareController",
                templateUrl: 'app/document/file-share.html',
                parent: angular.element(document.body),
                fullscreen: responsiveDesignService.mdDialogFullScreen(),
                locals: {
                    fileDocument: item
                },
                clickOutsideToClose: true
            }).then(function (result) {
                if (result && result == 'success') {
                    vm.resetData();
                }
            }, function () {
                //cancelled
            });
        };

        vm.downloadDoc = function (item) {
            if (item._links.download) {
                Document.download(item._links.download.href);
            }
        };

        vm.delete = function (item) {
            if (item._links.delete) {
                vm.isProcessing = true;
                Document.delete(item._links.delete.href, item.version).then(function () {
                    vm.resetData();
                }).finally(function () {
                    vm.isProcessing = false;
                });
            }
        };

        vm.showInfo = function (item) {
            vm.info.doc = item;
            vm.loadInstitution(item.user.additional).then(function (data) {
                vm.info.doc.institution = data;
            });
            $mdSidenav('rightInfo', true).toggle();
        };

        vm.closeInfo = function () {
            $mdSidenav('rightInfo', true).close().then(function () {
                vm.info = { doc: {} };
            });
        };

        vm.isShared = function (doc) {
            return _.some(doc.shareUsers, function (o) {
                return o.id == vm.currentUserId;
            });
        };

        vm.openSearch = function (event) {
            if (!vm.showSearchUi) {
                vm.showSearchUi = true;

                vm.searchPlaceholder = "Search Documents";
                $timeout(function () {
                    vm.searchInput.focus();
                });
            }
        };

        vm.handleKeyDown = function (event) {
            if (event.keyCode === 13 && vm.query.length !== 0) {
                vm.resetData();
            }
        };

        vm.clearSearch = function () {
            vm.query = [];
            vm.searchPlaceholder = "";
            vm.searched = false;
            vm.showSearchUi = false;
            vm.resetData();
        };

        vm.closeSearch = function () {
            if (!vm.searched) {
                vm.query = [];
                vm.searchPlaceholder = "";
                vm.searched = false;
                vm.showSearchUi = false;
            }
        };

        vm.deliberatelyTrustDangerousSnippet = function (snippet) {
            var html = "";
            angular.forEach(snippet, function (f) {
                html += JSON.stringify(f.replace(/(\r\n|\n|\r|\t)/gm, " ")) + "<br>";
            });

            return $sce.trustAsHtml(html);
        };

        vm.nextPage = function () {
            if (vm.isLastPage || vm.isProcessing) return;
            vm.isProcessing = true;
            vm.page++;
            Document.search(vm.page, vm.pageSize, vm.sortBy, documentSearch.getSearchQuery(vm.query)).then(function (data) {
                // the two server cals have different structure, this line can be better
                if (data.data) data = data.data;
                vm.items = data.page.totalPages === 0 ? [] : vm.items.concat(data._embeddedItems);
                vm.isLastPage = data.page.totalPages === 0 || data.page.totalPages === data.page.number + 1;
                vm.isProcessing = false;
                vm.searched = vm.query.length !== 0;
            }, function (err) {
                AlertService.toastError("An error ocurred in the search.");
                vm.isProcessing = false;
                vm.clearSearch();
            });
        };

        vm.sort = function (by) {
            vm.sortBy = by;
            vm.resetData();
        };

        vm.isShareable = function (doc) {
            return doc.category[0].name !== 'User Protocol';
        };

        /**
         * Can delete if the user is owner OR if the Document is protocol and the User is Admin, or Coordinator (if the owner is not admin)
         * @param doc
         * @returns {*}
         */
        vm.canDelete = function (doc) {
            return doc.canDelete;
        };

        vm.formatFileOwnerRole = function (groups) {
            return _.map(groups, function (group) {
                return group.description;
            }).join(', ');
        };

        /**
         * for use in sidenav info, get the institution ID from the 'additional' object and
         * query the server for the name.
         */
        vm.loadInstitution = function (additional) {
            // additional == [{ name: 'siteLocationId', value: '1' }];
            var obj = _.find(additional, ['name', 'siteLocationId']);
            if (!obj || !obj.value) return $q.when();
            return SiteLocation.getSiteLocation(obj.value).then(function (data) {
                return data.name;
            });
        };

        vm.init();
    }).directive('infoSectionToggle', function ($compile) {
        return {
            scope: { startCollapsed: '@' },
            link: function link(scope, element, attrs) {
                scope.toggle = toggle;

                var buttons = [
                // '<md-button ng-show="!open" aria-label="Expand" aria-hidden="true" class="md-icon-button md-toggle-icon" ng-class="{toggled: open}">',
                '  <md-icon ng-show="!open" aria-label="Expand" aria-hidden="true" ng-class="{toggled: open}" md-svg-icon="navigation:ic_expand_less_24px"></md-icon>',
                // '</md-button>',
                // '<md-button ng-show="open" aria-label="Collapse" aria-hidden="true" class="md-icon-button md-toggle-icon" ng-class="{toggled: !open}">',
                '  <md-icon ng-show="open" aria-label="Collapse" aria-hidden="true" ng-class="{toggled: !open}" md-svg-icon="navigation:ic_expand_more_24px"></md-icon>'].join('\n');
                var startCollapsed = attrs.startCollapsed === '';
                scope.open = true;
                if (startCollapsed) {
                    toggle();
                }
                buttons = $compile(buttons)(scope);
                element.children().eq(0).children().eq(0).append(buttons);

                // removed ngClick on each mdButton and adding here to make the entire
                // subheader element clickable.
                element.on('click', function (event) {
                    // apply because it's jQuery event
                    scope.$apply(function () {
                        toggle();
                    });
                });

                function toggle() {
                    scope.open = !scope.open;
                    element.next().toggle();
                }
            }
        };
    });
})();
'use strict';

(function () {
    'use strict';

    angular.module('braininstituteApp').controller('DocumentUploadController', function ($scope, $mdDialog, Document, Upload, User, AlertService, $q, $timeout, _, category, forUser, share) {
        $scope.isProcessing = true;
        $scope.collapsedAttirubutes = true;
        $scope.collapsedUser = true;
        $scope.maxUploadSize = '15MB';
        //Auto complete
        $scope.removeUser = removeUser;
        $scope.onUserSelect = onUserSelect;
        $scope.userSearch = userSearch;
        $scope.userSearchText = "";

        $scope.users = [];
        $scope.file = {
            sharedUsers: []
        };
        $scope.share = share;
        $scope.showCategories = !category;

        function init() {
            var promises = {};

            if (!category) {
                promises.categories = Document.getCategories(false);
            } else {
                $scope.file.category = category;
            }

            if (share) {
                promises.users = User.getAllForShareSearch();
            }

            $q.all(promises).then(function (data) {
                if (data.categories) $scope.categories = data.categories;
                if (data.users) $scope.users = data.users;
            }, function (err) {
                AlertService.toastError("Error loading data.");
                $mdDialog.cancel();
            }).finally(function () {
                $scope.isProcessing = false;
            });
        }

        $scope.uploadFile = function () {
            if (!$scope.fileUploadForm.$valid) return;

            $scope.isProcessing = true;
            if ($scope.file.category === 'User Protocol') {
                /* in case the user first adds shared users and then selects type
                   (which results in share div hiding but server still
                   gets/saves/returns that info)  */
                $scope.file.sharedUsers = [];
                $scope.file.sharedWithAll = true; //User Protocol is shared with all
            }
            console.log($scope.file);
            $scope.file.data.upload = Upload.upload({
                url: Document.getUploadURL(),
                data: getData()
            });

            $scope.file.data.upload.then(function (response) {
                $timeout(function () {
                    $scope.file.data.result = response.data;
                    $mdDialog.hide('success');
                });
            }, function (response) {
                if (response.status > 0) {
                    AlertService.toastError("Error :" + response.data.message);
                }
            }, function (evt) {
                // Math.min is to fix IE which reports 200% sometimes
                $scope.file.data.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
            }).finally(function () {
                $scope.isProcessing = false;
            });
        };

        $scope.cancel = function () {
            $mdDialog.cancel();
        };

        function getData() {
            var data = {
                file: $scope.file.data,
                categoryNames: [$scope.file.category],
                shareUsers: _.map($scope.file.sharedUsers, 'id'),
                sharedWithAll: $scope.file.sharedWithAll
            };

            if (forUser) {
                data.forUser = forUser;
            }

            return data;
        }

        /**
         * Callback after the user is selected
         */
        function onUserSelect() {
            if ($scope.selectedUser) {
                var selectedUser = angular.copy($scope.selectedUser);
                $scope.file.sharedUsers.push(selectedUser); //add to the list of users
                //clear the auto complete
                $scope.selectedUser = null;
                $scope.userSearchText = "";
            }
        }

        /**
         * Remove an user from the list
         * @param user
         */
        function removeUser(user) {
            _.remove($scope.file.sharedUsers, function (u) {
                return u._links.self.href == user._links.self.href;
            });
        }

        /**
         * Function for the autocomplete
         * @param text
         * @returns {*}
         */
        function userSearch(text) {
            if (text) {
                return _.filter($scope.users, function (o) {
                    return o.fullName.toLowerCase().indexOf(text.toLowerCase()) === 0 && !_.find($scope.file.sharedUsers, function (u) {
                        return u._links.self.href == o._links.self.href;
                    }); //that will remove the already added users from the auto complete
                });
            }
            return _.filter($scope.users, function (o) {
                return !_.find($scope.file.sharedUsers, function (u) {
                    return u._links.self.href == o._links.self.href;
                }); //that will remove the already added users from the auto complete
            });
        }

        init();
    });
})();
'use strict';

(function () {
    'use strict';

    angular.module('braininstituteApp').controller('DocumentShareController', function ($scope, $mdDialog, fileDocument, Document, Upload, User, AlertService, _) {
        $scope.isProcessing = true;
        $scope.users = [];
        $scope.sharedUsers = [];
        //Auto complete
        $scope.removeUser = removeUser;
        $scope.onUserSelect = onUserSelect;
        $scope.userSearch = userSearch;
        $scope.userSearchText = "";
        $scope.save = saveForm;

        $scope.cancel = function () {
            $mdDialog.cancel();
        };

        function init() {
            User.getAllForShareSearch().then(function (data) {
                $scope.users = data;
            }, function (err) {
                AlertService.toastError("Error loading users.");
                $mdDialog.cancel();
            }).finally(function () {
                $scope.isProcessing = false;
            });

            if (fileDocument.shareUsers) {
                angular.forEach(fileDocument.shareUsers, function (item) {
                    $scope.sharedUsers.push(item);
                });
            }
        }

        function saveForm() {
            if (!$scope.fileShareForm.$valid) return;
            if ($scope.sharedUsers) {
                $scope.isProcessing = true;
                Document.updateSharedUsers(fileDocument.user.id, _.map($scope.sharedUsers, 'id'), fileDocument.version, fileDocument._links.share.href).then(function (response) {
                    $mdDialog.hide('success');
                }).finally(function () {
                    $scope.isProcessing = false;
                });
            }
        }

        /**
         * Callback after the user is selected
         */
        function onUserSelect() {
            if ($scope.selectedUser) {
                var selectedUser = angular.copy($scope.selectedUser);
                $scope.sharedUsers.push(selectedUser); //add to the list of users
                //clear the auto complete
                $scope.selectedUser = null;
                $scope.userSearchText = "";
            }
        }

        /**
         * Remove an user from the list
         * @param user
         */
        function removeUser(user) {
            _.remove($scope.sharedUsers, function (u) {
                return u.id == user.id;
            });
        }

        /**
         * Function for the autocomplete
         * @param text
         * @returns {*}
         */
        function userSearch(text) {
            if (text) {
                return _.filter($scope.users, function (o) {
                    return o.fullName.toLowerCase().indexOf(text.toLowerCase()) === 0 && !_.find($scope.sharedUsers, function (u) {
                        return u.id == o.id;
                    }); //that will remove the already added users from the auto complete
                });
            }
            return _.filter($scope.users, function (o) {
                return !_.find($scope.sharedUsers, function (u) {
                    return u.id == o.id;
                }); //that will remove the already added users from the auto complete
            });
        }

        init();
    });
})();
'use strict';

(function () {
    'use strict';

    angular.module('braininstituteApp').service('documentSearch', function ($mdConstant, Document, AlertService) {
        var self = this;

        var SEARCH_TYPE = {
            SIMPLE: "SIMPLE",
            ADDITIONAL: "ADDITIONAL",
            FULL_TEXT: "FULL_TEXT"
        };

        self.selectedItem = null;
        self.searchText = null;
        self.querySearch = querySearch;
        self.getAutocompleteValues = getAutocompleteValues;
        self.getSearchQuery = getSearchQuery;
        self.transformChip = transformChip;
        self.chipSeparators = [$mdConstant.KEY_CODE.ENTER, $mdConstant.KEY_CODE.COMMA];
        self.validKeys = [{ out: 'File name', in: 'meta.name', type: SEARCH_TYPE.FULL_TEXT }, { out: 'Name', in: 'user.fullName', type: SEARCH_TYPE.FULL_TEXT }, { out: 'Category', in: 'category.name', valueAutocomplete: true, type: SEARCH_TYPE.SIMPLE }, { out: 'Institution', in: 'siteLocationId', valueAutocomplete: true, type: SEARCH_TYPE.ADDITIONAL }, { out: 'Role', in: 'user.groups.description', valueAutocomplete: true, type: SEARCH_TYPE.SIMPLE }, { out: 'Email', in: 'user.email', type: SEARCH_TYPE.SIMPLE }];
        self.validValues = {
            'category.name': [{ id: 'User Protocol', name: 'User Protocol' }, { id: 'Exporter - Excel', name: 'Exporter - Excel' }],
            'siteLocationId': [{ id: '1', name: 'SickKids' }, { id: '4', name: "St. Michael's" }, { id: '3', name: 'Sunnybrook' }, { id: '2', name: 'UHN' }],
            'user.groups.description': [{ id: 'Administrator', name: 'Administrator' }, { id: 'Coordinator', name: 'Coordinator' }, { id: 'Investigator', name: 'Investigator' }]
        };

        /**
         * Allow or disallow adding a new chip based on existing query and new chip type
         */
        function transformChip($chip, existingQuery) {
            // should be stopped when key is given without value:
            if ($chip.name === undefined || // when key name is selected without colon (e.g. "nam" or "name" typed)
            $chip.name === '') {
                // when key name and a colon is typed (e.g. "nam:" or "name:" typed)
                return null;
            }
            var hasFreetextAlready = _.findIndex(existingQuery, { out: 'Search text' }) !== -1;
            var hasChipsAlready = !hasFreetextAlready && existingQuery.length > 0;

            if ($chip.out === 'Search text' && (hasChipsAlready || hasFreetextAlready)) {
                // can't add freetext when having fields or freetext
                AlertService.showAlert('Invalid search', 'Fields and free-text search cannot be mixed in one query.');
                return null;
            } else if ($chip.out !== 'Search text' && hasFreetextAlready) {
                // can't add field when having freetext
                AlertService.showAlert('Invalid search', 'Fields and free-text search cannot be mixed in one query.');
                return null;
            } else // can be added
                return undefined;
        }

        function getAutocompleteValues(key) {
            return self.validValues[key];
        }

        /**
         * Generate the query that the server expects.
         */
        function getSearchQuery(chips) {
            // var examples = [
            //     { field: 'user.groups.description', value: 'Administrator' },
            //     { field: 'siteLocationId', value: '1', isAdditional: true },
            //     { field: 'category.name', value: 'User Protocol' },
            //     { field: 'meta.name', value: 'Redes' }
            // ];
            var hasFreetextAlready = _.findIndex(chips, { out: 'Search text' }) !== -1;
            var hasChipsAlready = !hasFreetextAlready && chips.length > 0;

            if (hasChipsAlready) {
                var newTerm;
                return JSON.stringify(chips.map(function (termIn) {
                    newTerm = {
                        field: termIn.in,
                        value: termIn.id ? termIn.id : termIn.name,
                        type: termIn.type
                    };
                    return newTerm;
                }));
            } else if (hasFreetextAlready) {
                return chips;
            } else {
                return [];
            }
        }

        /**
         * mdAutocomplete will call this to get matching chips
         */
        function querySearch(query) {
            var arr, key, value;

            if (!query) return [];
            arr = query.split(':');
            key = arr[0];
            value = arr[1];

            /* partial match of key part is enough, so user can type cat:exp and then
             * select "category:export", or "ins:sic" and select "institution:sickkids"
             * from the list.
             */
            var keyMatches = query ? self.validKeys.filter(createFilterFor(key)) : [];

            var arr2 = [];
            var newChip;
            var valuesForKey;
            keyMatches.forEach(function (keyM) {
                if (keyM.valueAutocomplete) {
                    // this is a key with autocompeletion
                    valuesForKey = getAutocompleteValues(keyM.in); // get all values for this matching key
                    if (value) // filter to matching ones if part of value is typed
                        valuesForKey = valuesForKey.filter(function (val) {
                            return angular.lowercase(val.name).indexOf(angular.lowercase(value)) === 0;
                        });
                    valuesForKey.forEach(function (val) {
                        arr2.push(makeChip(keyM, val.id, val.name));
                    });
                } else {
                    // now we need to pass value field as is "na:si" --> "name:si"
                    arr2.push(makeChip(keyM, null, value));
                }
            });
            arr2.push({
                out: 'Search text',
                name: key
            });
            return arr2;
        }

        function makeChip(key, valueId, valueName) {
            var chip = angular.copy(key);
            chip.id = valueId;
            chip.name = valueName;
            return chip;
        }

        function createFilterFor(query) {
            var lowercaseQuery = angular.lowercase(query);
            return function filterFn(validKey) {
                return angular.lowercase(validKey.out).indexOf(lowercaseQuery) === 0;
            };
        }
    });
})();
'use strict';

angular.module('braininstituteApp').config(function ($stateProvider) {
    $stateProvider.state('after-logout', {
        url: '/after-logout',
        data: {},
        views: {
            'content@': {
                controller: 'AfterLogoutController'
            }
        },
        resolve: {
            mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {

                return $translate.refresh();
            }]
        }
    });
});
'use strict';

angular.module('braininstituteApp').controller('AfterLogoutController', function ($scope, $location) {
  $location.url('/');
});
'use strict';

(function () {
    'use strict';

    angular.module('braininstituteApp').config(function ($translateProvider, ENV) {
        // Initialize angular-translate
        $translateProvider.useLoader('$translatePartialLoader', {
            urlTemplate: function urlTemplate(part, lang) {
                var urlTemplateLocal;

                if (ENV !== 'prod') {
                    if (part.indexOf('security') != -1) {
                        urlTemplateLocal = 'bower_components/tekstack-security-module/dist//i18n/{lang}/{part}.json';
                    } else {
                        urlTemplateLocal = 'assets/i18n/{lang}/{part}.json';
                    }
                    return urlTemplateLocal.replace(/\{part\}/g, part).replace(/\{lang\}/g, lang);
                } else {
                    var urlTemplate = 'assets/i18n/{lang}/{part}.json';
                    return urlTemplate.replace(/\{part\}/g, part).replace(/\{lang\}/g, lang);
                }
            }
        });

        $translateProvider.preferredLanguage('en');
        $translateProvider.useCookieStorage();
        $translateProvider.useSanitizeValueStrategy('escaped');
        $translateProvider.addInterpolation('$translateMessageFormatInterpolation');
    });
})();
'use strict';

/**
 * Local storage config for the app
 */
(function () {
    'use strict';

    angular.module('braininstituteApp').config(function (localStorageServiceProvider, appId) {
        localStorageServiceProvider.prefix = appId; //storage prefix
        localStorageServiceProvider.storageType = 'sessionStorage'; //session storage and not local storage
    });
})();
'use strict';

(function () {
    'use strict';

    angular.module('braininstituteApp').config(function (tekstackSecurityServiceProvider, afterLogin, afterLogout, clientId, clientSecret) {

        tekstackSecurityServiceProvider.setAddMenuPasswordChange(true);

        //Oauth config
        tekstackSecurityServiceProvider.setClientId(clientId);
        tekstackSecurityServiceProvider.setClientSecret(clientSecret);

        //Page flow config
        tekstackSecurityServiceProvider.setAfterLogin(afterLogin);
        tekstackSecurityServiceProvider.setAfterLogout(afterLogout);
    });
})();
'use strict';

/**
 * Create a new type to be used with UI Router state.
 * It handles URL link served by HATEOAS, to be used as ID's.
 * The URL link is Base 64 encoded.
 *
 * @param $urlMatcherFactoryProvider
 */
(function () {
    'use strict';

    angular.module('braininstituteApp').config(function ($urlMatcherFactoryProvider) {
        $urlMatcherFactoryProvider.type('URL', {}, function (Base64) {
            return {
                pattern: /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/, //pattern for encoded string

                encode: function encode(url) {
                    return Base64.encode(url);
                },
                decode: function decode(url) {
                    return Base64.decode(url);
                },
                is: function is(url) {
                    return (/(http|https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?/gi.test(url)
                    ); //check if the string is URL
                }
            };
        });
    });
})();
'use strict';

angular.module('braininstituteApp').config(function ($resourceProvider, $httpProvider, httpRequestInterceptorCacheBusterProvider, SpringDataRestInterceptorProvider, VERSION) {

    $resourceProvider.defaults.actions = {
        create: { method: 'POST' },
        save: { method: 'POST' },
        update: { method: 'PUT' },
        get: {
            method: 'GET', transformResponse: function transformResponse(data) {
                data = angular.fromJson(data);
                return data;
            }
        },
        query: { method: 'GET', isArray: false }, //getting hateoas object back
        remove: { method: 'DELETE' },
        delete: { method: 'DELETE' }
    };

    SpringDataRestInterceptorProvider.apply();

    //Cache everything except rest api requests
    httpRequestInterceptorCacheBusterProvider.setVersionNumber(VERSION);
    httpRequestInterceptorCacheBusterProvider.setMatchlist([/.*api(?!\/(.*\/search\/topLevel|.*\/search\/children|moleculares|siteLocations|sampleTypes|diagnoses|locations)).*/, /.*protected.*/], true);

    //Spring Security responds to it by not sending a "WWW-Authenticate" header in a 401 response, and thus the browser will not pop up an authentication dialog
    $httpProvider.defaults.headers.common["X-Requested-With"] = 'XMLHttpRequest';

    $httpProvider.interceptors.push('AuthInterceptor');
    $httpProvider.interceptors.push('ErrorInterceptor');
});
'use strict';

angular.module('braininstituteApp').config(function ($mdThemingProvider, $mdIconProvider) {
    $mdIconProvider.iconSet('action', 'assets/images/material-design/sprites/svg-sprite/svg-sprite-action.svg').iconSet('alert', 'assets/images/material-design/sprites/svg-sprite/svg-sprite-alert.svg').iconSet('av', 'assets/images/material-design/sprites/svg-sprite/svg-sprite-av.svg').iconSet('communication', 'assets/images/material-design/sprites/svg-sprite/svg-sprite-communication.svg').iconSet('content', 'assets/images/material-design/sprites/svg-sprite/svg-sprite-content.svg').iconSet('device', 'assets/images/material-design/sprites/svg-sprite/svg-sprite-device.svg').iconSet('editor', 'assets/images/material-design/sprites/svg-sprite/svg-sprite-editor.svg').iconSet('file', 'assets/images/material-design/sprites/svg-sprite/svg-sprite-file.svg').iconSet('hardware', 'assets/images/material-design/sprites/svg-sprite/svg-sprite-hardware.svg').iconSet('image', 'assets/images/material-design/sprites/svg-sprite/svg-sprite-image.svg').iconSet('maps', 'assets/images/material-design/sprites/svg-sprite/svg-sprite-maps.svg').iconSet('navigation', 'assets/images/material-design/sprites/svg-sprite/svg-sprite-navigation.svg').iconSet('notification', 'assets/images/material-design/sprites/svg-sprite/svg-sprite-notification.svg').iconSet('social', 'assets/images/material-design/sprites/svg-sprite/svg-sprite-social.svg').iconSet('toggle', 'assets/images/material-design/sprites/svg-sprite/svg-sprite-toggle.svg').iconSet('core', 'assets/images/material-design/sprites/svg-sprite/svg-sprite-core.svg');

    /*
     * {{foreground-1}} - used for primary text
     * {{foreground-2}} - used for secondary text/divider
     * {{foreground-3}} - used for disabled text
     * {{foreground-4}} - used for dividers
     */
    var DARK_FOREGROUND = {
        name: 'dark',
        '1': 'rgba(0,0,0,0.87)',
        '2': 'rgba(0,0,0,0.54)',
        '3': 'rgba(0,0,0,0.54)',
        '4': 'rgba(0,0,0,0.12)'
    };

    var LIGHT_FOREGROUND = {
        name: 'light',
        '1': 'rgba(255,255,255,1.0)',
        '2': 'rgba(255,255,255,0.7)',
        '3': 'rgba(255,255,255,0.7)',
        '4': 'rgba(255,255,255,0.12)'
    };

    $mdThemingProvider.theme('default').primaryPalette('blue', { 'default': '800' }).accentPalette('pink').warnPalette('red');

    $mdThemingProvider.theme('default').foregroundPalette = DARK_FOREGROUND;

    $mdThemingProvider.theme('default-dark', 'default').primaryPalette('yellow').dark();

    $mdThemingProvider.theme('default-dark').foregroundPalette = LIGHT_FOREGROUND;

    //Header Blue - #1565C0  ?? (font white) - 800
    //Sub-Header Blue - #2196F3  ?? (font white) - 500
    //Sub-sub-header blue - #BBDEFB  ?? (font black) - 100
});
'use strict';

(function () {
    'use strict';

    angular.module('braininstituteApp').config(function (tmhDynamicLocaleProvider, ENV) {
        if (ENV !== 'prod') {
            tmhDynamicLocaleProvider.localeLocationPattern('bower_components/angular-i18n/angular-locale_{{locale}}.js');
        } else {
            tmhDynamicLocaleProvider.localeLocationPattern('scripts/angular-locale_{{locale}}.js');
        }
        tmhDynamicLocaleProvider.useCookieStorage();
        tmhDynamicLocaleProvider.storageKey('NG_TRANSLATE_LANG_KEY');
    });
})();
/**
 * Created by Daniel Costa <danielcosta123@gmail.com> on 5/5/2016.
 */
'use strict';

angular.module('braininstituteApp').config(function (IdleProvider, KeepaliveProvider, idleTime, idleTimeOut) {
    IdleProvider.idle(idleTime - idleTimeOut);
    IdleProvider.timeout(idleTimeOut); // in seconds
    KeepaliveProvider.interval(2); // in seconds
});
"use strict";

angular.module("templates", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("document/document.html", "<md-toolbar id=\"tcinc-main-toolbar\" class=\"documents\" ng-class=\"{\'documents-toolbar-fullwidth\': ctrl.fullWidthSearchBar, \'documents-toolbar-inline\': ctrl.inlineSearchBar}\"><div layout=\"column\"><div class=\"md-toolbar-tools\"><md-button aria-label=\"Menu\" ng-click=\"toggleAppSidenav()\"><md-icon md-svg-icon=\"navigation:ic_menu_24px\"></md-icon></md-button><h3 translate=\"braininstituteApp.document.title\"></h3><span flex></span><searchbar-documents ng-if=\"ctrl.$mdMedia(ctrl.mediaQueries.inlineSearchBar)\"></searchbar-documents><md-menu class=\"md-secondary\" md-position-mode=\"target-right target\"><md-button aria-label=\"Menu\" aria-label=\"menu\" ng-click=\"$mdOpenMenu($event)\"><md-icon md-svg-icon=\"content:ic_sort_24px\"></md-icon></md-button><md-menu-content><md-menu-item><md-button ng-click=\"ctrl.sort(\'meta.name\')\">File Name</md-button></md-menu-item><md-menu-item><md-button ng-click=\"ctrl.sort(\'category.name\')\">Category</md-button></md-menu-item><md-menu-item><md-button ng-click=\"ctrl.sort(\'meta.contentLength\')\">File Size</md-button></md-menu-item><md-menu-item><md-button ng-click=\"ctrl.sort(\'user.firstName\')\">User Name</md-button></md-menu-item></md-menu-content></md-menu><notification-menu></notification-menu></div><searchbar-documents ng-if=\"ctrl.$mdMedia(ctrl.mediaQueries.fullWidthSearchBar)\"></searchbar-documents></div></md-toolbar><md-button class=\"md-fab md-fab-bottom-right\" aria-label=\"Upload Document\" ng-click=\"ctrl.uploadFileDialog()\"><md-icon md-svg-icon=\"file:ic_file_upload_24px\"></md-icon></md-button><md-sidenav class=\"md-sidenav-right md-whiteframe-z2\" md-component-id=\"rightInfo\" ng-include=\"\'document/template/sidenav.html\'\"></md-sidenav><md-content layout=\"column\" flex class=\"main-scroll\"><div layout=\"row\" ng-show=\"ctrl.isProcessing\" class=\"darkClass\" layout-align=\"center center\"><md-progress-circular md-mode=\"indeterminate\"></md-progress-circular></div><div infinite-scroll=\"ctrl.nextPage()\" infinite-scroll-container=\"\'.main-scroll\'\" infinite-scroll-disabled=\"ctrl.isProcessing\" infinite-scroll-distance=\"1\"><md-list id=\"documents-md-list\" flex><md-list-item ng-repeat=\"doc in ctrl.items\" class=\"md-3-line\" ng-click=\"ctrl.openDoc(doc._links.download.href)\" ng-style=\"{\'background-color\': ctrl.isShared(doc) && \'rgba(142, 210, 201, 0.4)\'}\"><div class=\"md-list-item-text\" style=\"padding-left:16px\"><!--<h3>{{::ctrl.getItemTitle(doc)}}</h3>--><h3><span class=\"documents-list-username-emphasis\" ng-if=\"doc.category[0].name ===\'User Protocol\'\">{{doc.user.firstName + \' \' + doc.user.lastName}}</span> {{doc.meta.name}}</h3><md-chips ng-model=\"doc.category\" readonly=\"true\" class=\"documents-list-fix-for-chips\"><md-chip-template>{{$chip.name}}</md-chip-template></md-chips><p ng-bind-html=\"ctrl.deliberatelyTrustDangerousSnippet(doc.highlighted)\" class=\"documents-highlighted-paragraph\"></p></div><md-menu class=\"md-secondary\" md-position-mode=\"target-right target\"><md-button class=\"md-icon-button\" aria-label=\"menu\" ng-click=\"$mdOpenMenu($event)\"><md-icon md-svg-icon=\"navigation:ic_more_vert_24px\" md-menu-origin></md-icon></md-button><md-menu-content><md-menu-item><md-button ng-click=\"ctrl.showInfo(doc)\"><md-icon md-svg-icon=\"action:ic_info_outline_24px\" md-menu-align-target></md-icon>Info</md-button></md-menu-item><md-menu-item><md-button ng-click=\"ctrl.downloadDoc(doc)\"><md-icon md-svg-icon=\"file:ic_file_download_24px\" md-menu-align-target></md-icon>Download</md-button></md-menu-item><md-menu-item ng-if=\"::ctrl.isShareable(doc)\"><md-button ng-click=\"ctrl.shareDoc(doc)\"><md-icon md-svg-icon=\"social:ic_share_24px\" md-menu-align-target></md-icon>Share</md-button></md-menu-item><md-menu-item ng-if=\"::ctrl.canDelete(doc)\"><md-button ng-click=\"ctrl.delete(doc)\"><md-icon md-svg-icon=\"action:ic_delete_24px\" md-menu-align-target></md-icon>Delete</md-button></md-menu-item></md-menu-content></md-menu><md-divider ng-if=\"!$last\"></md-divider></md-list-item></md-list></div></md-content>");
  $templateCache.put("error/accessdenied.html", "<div ng-cloak><div class=\"row\"><div class=\"col-md-8\"><h1 translate=\"error.title\">Error Page!</h1><div class=\"alert alert-danger\" translate=\"error.403\">You are not authorized to access the page.</div></div></div></div>");
  $templateCache.put("error/error.html", "<div ng-cloak><div class=\"row\"><div class=\"col-md-8\"><h1 translate=\"error.title\">Error Page!</h1><div ng-show=\"errorMessage\"><div class=\"alert alert-danger\">{{errorMessage}}</div></div></div></div></div>");
  $templateCache.put("includes/constants-template.html", "<script th:inline=\"javascript\">/*<![CDATA[*/\r\nangular.module(\"braininstituteApp.constants\")\r\n    .constant(\"baseUri\", /*[[${baseUri}]]*/)\r\n    .constant(\"tokenUri\", /*[[${tokenUri}]]*/)\r\n    .constant(\"stompUri\", /*[[${stompUri}]]*/);\r\n/*]]>*/</script>");
  $templateCache.put("logRequestView/logRequestView.html", "<md-content><form><md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\"><md-button aria-label=\"Close\" ng-click=\"cancel()\"><md-icon md-svg-icon=\"navigation:ic_arrow_back_24px\"></md-icon></md-button><h2>Logs</h2><span flex></span></div></md-toolbar><md-dialog-content><div ng-show=\"loading\"><md-progress-circular md-mode=\"indeterminate\"></md-progress-circular></div><md-list ng-hide=\"loading\"><md-list-item class=\"md-2-line\" ng-repeat=\"log in formattedLogs\"><div class=\"md-list-item-text\"><h5>{{ log.text }}</h5><h5 ng-if=\"log.message\">{{ log.message }}</h5><p>{{ log.date }}</p></div></md-list-item></md-list></md-dialog-content></form></md-content>");
  $templateCache.put("main/main.html", "<div style=\"overflow: auto\"><div class=\"homepage-logos-top\" layout=\"row\" layout-margin layout-padding layout-align=\"space-around center\"><div flex><img class=\"homepage-logo\" alt=\"Brain Tumour Bank Network University of Toronto\" src=\"assets/images/home/Main_Logo.jpg\"></div><div flex><img class=\"homepage-logo-sponsor\" alt=\"Brain Tumour Bank Network University of Toronto\" src=\"assets/images/home/Brain_tumour_bank_header.jpg\"></div><md-button flex class=\"login-button\" aria-label=\"Sign in\" ui-sref=\"login\" layout-align=\"center\"><img src=\"assets/images/home/Signin.png\" class=\"homepage-signin-image\"></md-button></div><div class=\"slider-container\"><flex-slider id=\"tcSlider\" flex-slide=\"s in slides track by s.id\" slideshow-speed=\"4000\" direction-nav=\"false\"><li><img ng-src=\"{{s.image}}\"><div class=\"caption-container container\"><div class=\"caption-title\">{{s.title}}</div><div class=\"caption-desc\">{{s.subtitle}}</div></div></li></flex-slider></div><div class=\"homepage-logos-bottom\" layout=\"row\" flex-sm layout-margin layout-align=\"space-around center\"><div flex-xs=\"20\" flex-sm=\"20\"><img src=\"assets/images/home/Logo1_SickKids.png\"></div><div flex-xs=\"20\" flex-sm=\"20\"><img src=\"assets/images/home/Logo2_StMichaels.png\"></div><div flex-xs=\"30\" flex-sm=\"30\"><img src=\"assets/images/home/Logo3_Sunnybrook.png\"></div><div flex-xs=\"30\" flex-sm=\"30\"><img src=\"assets/images/home/Logo4_UHN.jpg\"></div></div><div class=\"homepage-main-footer\"><div layout=\"row\"><div><ul class=\"footer-addr\"><li><span class=\"homepage-text-large\">CONTACT</span></li><li><span class=\"homepage-text-contact-1\">For questions, comments and further information:</span></li><li class=\"homepage-text-contact-2-li\"><span class=\"homepage-text-contact-2\">James Loukides</span></li><li><span class=\"homepage-text-contact-3\">Tumour Bank Manager</span></li><li><span class=\"homepage-text-contact-3\">SickKids Hospital</span></li><li><span class=\"homepage-text-contact-3\">james.loukides@sickkids.ca</span></li></ul></div></div></div><div class=\"homepage-real-footer\"><div class=\"homepage-text-real-footer\">© 2016 University of Toronto Brain Tumour Network. All Rights Reserved.</div></div></div>");
  $templateCache.put("reports/reports.html", "<div layout=\"column\" layout-fill><div layout=\"row\" layout-align=\"space-between center\"><div layout=\"column\"><h2>Reports</h2></div></div><div layout=\"row\" layout-fill><md-content class=\"md-padding\" layout-fill></md-content></div></div>");
  $templateCache.put("requests/logDialog.html", "<md-dialog aria-label=\"Logs\" ng-cloak><form><md-toolbar><div class=\"md-toolbar-tools\"><h2>Logs</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon md-svg-icon=\"content:ic_clear_24px\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div ng-show=\"loading\"><md-progress-circular md-mode=\"indeterminate\"></md-progress-circular></div><md-list ng-hide=\"loading\"><md-list-item class=\"md-2-line\" ng-repeat=\"log in formattedLogs\"><div class=\"md-list-item-text\"><h5>{{ log.text }}</h5><h5 ng-if=\"log.message\">{{ log.message }}</h5><p>{{ log.date }}</p></div></md-list-item></md-list></md-dialog-content></form></md-dialog>");
  $templateCache.put("requests/requestErrorDialog.html", "<md-dialog aria-label=\"Errors\" ng-cloak><form><md-toolbar><div class=\"md-toolbar-tools\"><h2>Some errors happened</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon md-svg-icon=\"content:ic_clear_24px\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content style=\"padding: 20px\"><h3>{{errors.length}} of {{success.length + errors.length}} requests updates failed, due to:</h3><md-list><md-list-item class=\"md-2-line\" ng-repeat=\"err in errors\"><div class=\"md-list-item-text\"><h5>{{err.reason.data.message}}</h5></div></md-list-item></md-list></md-dialog-content></form></md-dialog>");
  $templateCache.put("requests/requests.html", "<md-toolbar id=\"tcinc-main-toolbar\"><div class=\"md-toolbar-tools\"><md-button aria-label=\"Menu\" ng-click=\"toggleAppSidenav()\"><md-icon md-svg-icon=\"navigation:ic_menu_24px\"></md-icon></md-button><h3>Requests</h3><span flex></span><!--<md-button aria-label=\"Filter by year\" ng-click=\"\">\r\n            <md-icon md-svg-icon=\"action:ic_list_24px\"></md-icon>\r\n        </md-button>--><md-select ng-model=\"requests.year\" placeholder=\"Year\" ng-change=\"requests.yearChanged()\"><md-option ng-value=\"2017\">2017</md-option><md-option ng-value=\"2016\">2016</md-option><md-option ng-value=\"2015\">2015</md-option><md-option ng-value=\"null\">Any year</md-option></md-select><notification-menu></notification-menu></div></md-toolbar><md-content layout=\"row\" ng-class=\"{\'layout-fill\': (isLoadingRequests || requests.$mdMedia(\'gt-sm\') )}\"><div ng-show=\"isLoadingRequests\" layout=\"row\" class=\"darkClass\" layout-align=\"center center\"><md-progress-circular md-mode=\"indeterminate\"></md-progress-circular></div><div layout=\"column\" class=\"table-container\" ng-show=\"requests.isViewShown(\'requests\')\"><md-data-table-toolbar class=\"alternate nagy-table-alternative-header\" ng-show=\"requests.selected.length\"><div class=\"\"><div>{{requests.selected.length}} {{requests.selected.length > 1 ? \'items\' : \'item\'}} selected</div><span flex></span> <span ng-repeat=\"btn in requests.tableButtons\" ng-show=\"requests.selected.length > 0\"><md-button class=\"md-raised\" aria-label=\"{{btn.title}}\" ng-class=\"btn.style\" ng-click=\"btn.callback(requests.selected, btn)\" ng-show=\"btn.show(requests.selected)\">{{btn.title.toUpperCase()}}</md-button></span></div></md-data-table-toolbar><md-content class=\"main-scroll\"><md-table-container ng-class=\"{\'extra-padding\': requests.cardModeOn() }\"><table md-card-mode=\"requests.cardModeOn()\" data-md-table ng-class=\"{\'table-striped\': !requests.cardModeOn() }\" class=\"requests-table\" md-row-select=\"requests.selected\" multiple=\"true\" ng-model=\"requests.selected\" md-progress=\"requests.promise\"><thead md-head><tr md-row><th md-column ng-repeat=\"column in requests.headers\" ng-attr-numeric=\"{{column.numeric}}\" name=\"{{column.name}}\"><span>{{column.name}}</span></th></tr></thead><tbody md-body infinite-scroll=\"requests.nextPageInfiniteScroll()\" infinite-scroll-distance=\"1\" infinite-scroll-disabled=\"!requests.cardModeOn()\" infinite-scroll-container=\"\'.main-scroll\'\"><tr md-row md-select=\"item\" md-select-id=\"id\" ng-repeat=\"item in requests.content track by $index\" ng-click=\"requests.onRowClick(item)\"><td md-cell data-title=\"Requester User\">{{item.userName}}</td><td md-cell data-title=\"Requester Institution\">{{item.requesterInstitution.name}}</td><td md-cell data-title=\"Aliquots req\">{{item.aliquotsRequested || \"Y\"}}</td><td md-cell data-title=\"Aliquots available\">{{item.sampleInfo.aliquots || item.sampleInfo.containAliquots}}</td><td md-cell data-title=\"Patient ID\">{{item.patient.code}}</td><td md-cell data-title=\"Sample ID\">{{item.sampleInfo.code}}</td><td md-cell data-title=\"Sample type\">{{item.sampleName}}</td><td md-cell data-title=\"Status\">{{item.currentStatus.description.toUpperCase()}}</td><td md-cell ng-show=\"requests.cardModeOn() && requests.needActionButtons(item)\"><md-card-actions><md-button class=\"md-raised\" aria-label=\"{{btn.title}}\" ng-class=\"btn.style\" ng-click=\"$event.stopPropagation(); btn.callback([item], btn)\" ng-show=\"btn.show([item])\" ng-repeat=\"btn in requests.tableButtons\">{{btn.title.toUpperCase()}}</md-button></md-card-actions></td></tr></tbody></table></md-table-container><data-md-table-pagination ng-hide=\"isLoadingRequests || requests.cardModeOn()\" md-limit=\"requests.limit\" accesskey=\"\" md-page=\"requests.pageNumber\" md-total=\"{{requests.totalElements}}\" md-on-paginate=\"requests.onpagechange\"></data-md-table-pagination></md-content></div><div ui-view=\"logRequestView\" ng-show=\"requests.isViewShown(\'logRequestView\')\" layout-fill flex></div></md-content>");
  $templateCache.put("sampleView/sampleView.html", "<!--<pre>{{ sampleView.prettySearchJson }}</pre>--><md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\" style=\"padding-right: 30px\"><md-button aria-label=\"{{ \'braininstituteApp.sampleInfo.goBackToSearchResults\' | translate }}\" ng-click=\"sampleView.goBackToSearchClicked()\"><md-icon md-svg-icon=\"navigation:ic_arrow_back_24px\"></md-icon></md-button><h3 class=\"sub-title\">Sample details</h3><span flex></span><md-button aria-label=\"Request\" ng-disabled=\"!sampleView.buttons.requestBtn.enabled\" ng-click=\"sampleView.requestSampleClicked()\"><md-tooltip>{{ sampleView.buttons.requestBtn.tooltip }}</md-tooltip><md-icon md-svg-icon=\"action:ic_shopping_cart_24px\"></md-icon></md-button><md-menu md-position-mode=\"target-right target\"><md-button ng-show=\"sampleView.buttons.editBtn.enabled\" aria-label=\"Menu for editing commands\" class=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\"><md-icon md-svg-icon=\"editor:ic_mode_edit_24px\"></md-icon></md-button><md-menu-content width=\"4\"><md-menu-item><md-button ng-click=\"sampleView.editSampleClicked()\"><md-icon md-svg-icon=\"editor:ic_mode_edit_24px\"></md-icon>Edit sample</md-button></md-menu-item><md-menu-item><md-button ng-click=\"sampleView.editPatientClicked()\"><md-icon md-svg-icon=\"editor:ic_mode_edit_24px\"></md-icon>Edit patient</md-button></md-menu-item></md-menu-content></md-menu><md-menu ng-show=\"::sampleView.buttons.deleteMenuBtn.visible\" md-position-mode=\"target-right target\"><md-button aria-label=\"Menu for deleting commands\" class=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\"><md-icon md-menu-origin md-svg-icon=\"action:ic_delete_24px\"></md-icon></md-button><md-menu-content width=\"4\"><md-menu-item><md-button ng-click=\"sampleView.deleteSampleClicked()\"><md-icon md-svg-icon=\"action:ic_delete_24px\"></md-icon>Delete sample</md-button></md-menu-item><md-menu-item><md-button ng-click=\"sampleView.deletePatientClicked()\"><md-icon md-svg-icon=\"action:ic_delete_24px\"></md-icon>Delete patient</md-button></md-menu-item></md-menu-content></md-menu></div></md-toolbar><md-content class=\"display-table-view\" layout-fill><div layout=\"row\" layout-fill ng-show=\"sampleView.isLoadingData\" class=\"\" layout-align=\"center center\"><md-progress-circular md-mode=\"indeterminate\"></md-progress-circular></div><div ng-hide=\"sampleView.isLoadingData\" class=\"inner-section-display\" layout=\"column\" layout-margin><h4 class=\"sub-title\">Sample</h4><dl><dt>Sample ID</dt><dd>{{sampleView.sample.code}}</dd><dt>Date of treatment</dt><dd>{{sampleView.sample.dtSurgery}}</dd><dt ng-repeat-start=\"diag in sampleView.sample.diagnoses\">{{ diag.title }}</dt><dd ng-repeat-end>{{ diag.name }}</dd><dt>Molecular</dt><dd>{{ sampleView.sample.molecular }}</dd><dt>Date of diagnosis</dt><dd>{{ sampleView.sample.dtDiagnosis }}</dd><dt>Diagnosis comment</dt><dd>{{ sampleView.sample.diagnosisNotes }}</dd><dt>Location</dt><dd>{{ sampleView.sample.locations }}</dd><dt>Location comment</dt><dd>{{ sampleView.sample.locationNotes }}</dd><dt>Sample Type</dt><dd>{{ sampleView.sample.sampleTypes }}</dd><dt>Aliquots</dt><dd>{{ sampleView.sample.aliquots }}</dd></dl><h4 class=\"sub-title\">Patient - {{ sampleView.patient.code }} <em><a ng-click=\"sampleView.resetFormWithPatient(sampleView.patient.code)\">[search]</a></em><dl><dt>Gender</dt><dd>{{ sampleView.patient.gender }}</dd><dt>Length of Survival</dt><dd>{{ sampleView.patient.lengthOfSurvival }}</dd></dl><h4 class=\"sub-title\">Availability</h4><dl><dt>Availability</dt><dd>{{ sampleView.sample.availability }}</dd><dt>Sample site location</dt><dd>{{ sampleView.patient.siteLocation }}</dd><!--Padding for mdToolbar weirdness compensation, making sure the last field is visible--><!-- <dt>&nbsp;</dt>\r\n            <dt>&nbsp;</dt> --></dl></h4></div></md-content>");
  $templateCache.put("search/returnSampleDialog.html", "<md-dialog flex=\"75\"><form name=\"returnSampleForm\" ng-submit=\"returnSampleForm.$valid && submitReturn()\" novalidate><md-dialog-content><h1 class=\"md-title\">Return Sample</h1><div ng-show=\"isLoadingRequests\" style=\"width: 0; margin:0 auto\"><md-progress-circular md-mode=\"indeterminate\"></md-progress-circular></div><div ng-hide=\"isLoadingRequests\" layout-fill><md-table-mod count=\"perPage\" table-page=\"page\" links=\"links\" headers=\"headers\" content=\"content\" buttons=\"tableButtons\"></md-table-mod></div></md-dialog-content><md-dialog-actions><md-button ng-click=\"hide()\" class=\"md-primary\">Close</md-button></md-dialog-actions></form></md-dialog>");
  $templateCache.put("search/search.html", "<md-toolbar id=\"tcinc-main-toolbar\"><div class=\"md-toolbar-tools\"><md-button aria-label=\"Menu\" ng-click=\"toggleAppSidenav()\" id=\"btnMenu\"><md-icon md-svg-icon=\"navigation:ic_menu_24px\"></md-icon></md-button><h3 ellipsis class=\"search-toolbar-title\" ng-bind=\"search.searchToolbarTitle\"></h3><span flex></span> <span ng-show=\"!search.cardModeOn\"><md-button aria-label=\"Show filters\" ng-click=\"search.doToggleSearchToolbarTitle()\" ng-class=\"{\'button-toggled-on\': search.$mdSidenav(\'rightInfo\', true).isOpen()}\"><md-tooltip>Show filters Info</md-tooltip><md-icon md-svg-icon=\"image:ic_remove_red_eye_24px\"></md-icon></md-button><!--<span flex></span>--><md-button id=\"export-search-results\" aria-label=\"Export\" ng-click=\"search.exportData()\"><md-tooltip>Export</md-tooltip><md-icon md-svg-icon=\"file:ic_cloud_download_24px\"></md-icon></md-button></span><md-menu ng-show=\"search.cardModeOn\"><md-button aria-label=\"More options\" class=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\" ng-class=\"{\'button-toggled-on\': search.$mdSidenav(\'rightInfo\', true).isOpen() }\"><md-icon md-menu-origin md-svg-icon=\"navigation:ic_more_vert_24px\"></md-icon></md-button><md-menu-content width=\"2\"><md-menu-item><md-button aria-label=\"Show filters\" ng-click=\"search.doToggleSearchToolbarTitle()\" ng-class=\"{\'button-toggled-on\': search.$mdSidenav(\'rightInfo\', true).isOpen() }\"><md-icon md-menu-align-target md-svg-icon=\"image:ic_remove_red_eye_24px\"></md-icon><span md-menu-align-target>Show filters Info</span></md-button></md-menu-item><md-menu-item><md-button aria-label=\"Export\" ng-click=\"search.exportData()\"><md-icon md-menu-align-target md-svg-icon=\"file:ic_cloud_download_24px\"></md-icon><span md-menu-align-target>Export</span></md-button></md-menu-item></md-menu-content></md-menu><md-button aria-label=\"Filter Samples\" ng-click=\"search.searchbarToggle()\" id=\"btnFilterSamples\" ng-class=\"{\'button-toggled-on\': search.$mdSidenav(\'sidenavSearchFilters\', true).isOpen() || search.getSearchbarLockedOpen() }\"><md-tooltip>Filter Sample</md-tooltip><md-icon md-svg-icon=\"content:ic_filter_list_24px\"></md-icon></md-button><notification-menu id=\"search-notification-menu\"></notification-menu></div></md-toolbar><md-content layout=\"row\" style=\"height: 100%\"><md-sidenav class=\"md-sidenav-left tcinc-search-sidenav\" md-component-id=\"sidenavSearchFilters\" md-is-locked-open=\"search.getSearchbarLockedOpen()\"><md-toolbar class=\"md-theme-light\" ng-show=\"search.$mdSidenav(\'sidenavSearchFilters\', true).isOpen() && !search.getSearchbarLockedOpen()\"><div class=\"md-toolbar-tools\"><md-button aria-label=\"Go back\" ng-click=\"search.$mdSidenav(\'sidenavSearchFilters\', true).toggle()\"><md-icon md-svg-icon=\"navigation:ic_arrow_back_24px\"></md-icon></md-button><h1>Filters</h1></div></md-toolbar><form name=\"searchForm\" ng-submit=\"searchForm.$valid && search.submit(search.model)\" novalidate><many-tabs><many-tabs-pane the-title=\"{{ \'braininstituteApp.sampleInfo.sampleInformation\' | translate }}\" clear=\"search.clearInputGroup(\'sample\'); search.submit()\" close=\"search.searchbarToggle()\" change-filter-visibility-callback=\"search.showChangeInputVisibilityDialog(\'sample\')\" changed-count=\"search.changedCounts.sample\"><div layout=\"column\" ng-include=\"\'search/template/cardSample.html\'\"></div></many-tabs-pane><many-tabs-pane the-title=\"{{ \'braininstituteApp.patient.patientInformation\' | translate }}\" clear=\"search.clearInputGroup(\'patient\'); search.submit()\" change-filter-visibility-callback=\"search.showChangeInputVisibilityDialog(\'patient\')\" changed-count=\"search.changedCounts.patient\"><div layout=\"column\" ng-include=\"\'search/template/cardPatient.html\'\"></div></many-tabs-pane><many-tabs-pane the-title=\"{{ \'braininstituteApp.sampleInfo.availabilityInformation\' | translate }}\" clear=\"search.clearInputGroup(\'avail\'); search.submit()\" change-filter-visibility-callback=\"search.showChangeInputVisibilityDialog(\'avail\')\" changed-count=\"search.changedCounts.avail\"><div layout=\"column\" ng-include=\"\'search/template/cardAvailability.html\'\"></div></many-tabs-pane></many-tabs><div style=\"text-align: center\"><md-button class=\"md-raised md-accent\" ng-click=\"search.resetFilters()\" ng-disabled=\"!search.filters\">Clear all filters</md-button></div></form></md-sidenav><div layout=\"row\" ng-show=\"search.isLoadingData\" class=\"darkClass\" layout-fill layout-align=\"center center\"><md-progress-circular md-mode=\"indeterminate\"></md-progress-circular></div><!--Search results table--><div layout=\"column\" class=\"table-container search-table-container\" ng-show=\"search.isViewShown(\'search\')\"><md-data-table-toolbar class=\"alternate nagy-table-alternative-header\" ng-show=\"search.selected.length\"><div><div>{{search.selected.length}} {{search.selected.length > 1 ? \'items\' : \'item\'}} selected</div><span flex></span><md-button aria-label=\"Request\" ng-click=\"search.requestMultiple(search.selected)\"><md-icon md-svg-icon=\"action:ic_shopping_cart_24px\"></md-icon></md-button></div></md-data-table-toolbar><md-content class=\"search-results\" layout=\"column\"><md-table-container class=\"main-scroll\"><table md-card-mode=\"search.cardModeOn\" ng-class=\"{\'table-striped\' : !search.cardModeOn}\" data-md-table md-row-click=\"search.rowClick\" md-row-select ng-model=\"search.selected\" multiple=\"true\" md-row-update-callback=\"search.rowClick\" md-progress=\"search.promise\"><thead md-head md-order=\"search.sort\" md-on-reorder=\"search.onorderchange\"><tr md-row><th md-column ng-repeat=\"column in search.headers\" md:order:by=\"{{column.orderBy}}\" ng-attr-order-by=\"{{column.orderBy}}\" name=\"{{column.name}}\" ng-attr-numeric=\"{{column.numeric}}\"><span>{{ column.name }}</span></th></tr></thead><tbody md-body infinite-scroll=\"search.nextPageInfiniteScroll()\" infinite-scroll-distance=\"1\" infinite-scroll-disabled=\"!search.cardModeOn\" infinite-scroll-container=\"\'.main-scroll\'\"><tr ng-click=\"search.rowClick(item)\" md-row md-select=\"item\" data-ng-repeat=\"item in search.data track by item._links.self.href\"><td md-cell data-title=\"Patient ID\" data=\"item.patient.code\">{{item.patient.code}}</td><td md-cell data-title=\"Age Year\" data=\"item.ageAtDiagnosisYear\">{{item.ageAtDiagnosisYear}}</td><td md-cell data-title=\"Age Month\" data=\"item.ageAtDiagnosisMonth\">{{item.ageAtDiagnosisMonth}}</td><td md-cell data-title=\"Sample Type\">{{item.sampleType.name}}</td><td md-cell data-title=\"Aliquots\">{{search.formatSampleAliquots(item)}}</td></tr></tbody></table></md-table-container><div ng-show=\"!search.data.length && !search.isLoadingData\" style=\"padding: 15px; text-align: center\">No items available.<md-button class=\"md-raised md-accent\" ng-click=\"search.resetFilters()\" ng-disabled=\"!search.filters\">Clear all filters</md-button></div><data-md-table-pagination ng-hide=\"search.isLoadingData || search.cardModeOn\" md-limit=\"search.limit\" accesskey=\"\" md-page=\"search.pageNumber\" md-total=\"{{search.totalElements}}\" md-on-paginate=\"search.onpagechange\"></data-md-table-pagination></md-content></div><!--Sample view--><div ui-view=\"sampleInSearchView\" layout-fill ng-show=\"search.isViewShown(\'sampleView\')\" flex></div><md-sidenav class=\"md-sidenav-right md-whiteframe-z2\" md-component-id=\"rightInfo\"><md-toolbar class=\"md-theme-light\"><div class=\"md-toolbar-tools\"><md-button aria-label=\"Go back\" ng-click=\"search.$mdSidenav(\'rightInfo\', true).toggle()\"><md-icon md-svg-icon=\"navigation:ic_arrow_forward_24px\"></md-icon></md-button><h1>Filters Info</h1></div></md-toolbar><md-content><md-list style=\"padding-top: 10px\"><md-list-item ng-show=\"search.filters\" class=\"md-2-line\" ng-repeat=\"item in search.filters\"><div class=\"md-list-item-text\"><h4>{{ item.title }}</h4><p>{{ item.data }}</p></div><md-divider></md-divider></md-list-item><md-list-item ng-show=\"!search.filters || search.filters.length <= 0\"><h4>No filters</h4></md-list-item></md-list></md-content></md-sidenav></md-content><md-sidenav md-component-id=\"sidenavDiagnosis\" layout=\"column\" md-is-open=\"search.sidenavDiagnosisIsOpen\" class=\"filter-checkboxes-nav md-sidenav-left md-whiteframe-z2 search-sidenav-wider\" layout-padding><h1 class=\"md-toolbar-tools\" translate=\"search.searchCards.sampleInfo.lookup.diagnosis\">Diagnosis!!!</h1><md-content layout-padding><div ivh-treeview=\"search.inputs.sample.diagnosis.value\" ivh-treeview-options=\"::search.treeviewOpts\"></div></md-content><md-fab-toolbar md-open md-whiteframe=\"2\"><md-button ng-click=\"search.sidenavDiagnosisIsOpen = false\" class=\"md-primary\">Done</md-button><md-button ng-click=\"search.clearTreeviewModel(search.inputs.sample.diagnosis)\" class=\"md-secondary\">Clear</md-button></md-fab-toolbar></md-sidenav><md-sidenav md-component-id=\"sidenavLocations\" md-is-open=\"search.sidenavLocationsIsOpen\" class=\"md-sidenav-left md-whiteframe-z2 search-sidenav-wider\"><md-content layout-padding><h1 class=\"md-toolbar-tools\" translate=\"search.searchCards.sampleInfo.lookup.locations\">Locations</h1><div ivh-treeview=\"search.inputs.sample.location.value\" ivh-treeview-options=\"::search.treeviewOpts\"></div><md-button ng-click=\"search.sidenavLocationsIsOpen = false\" class=\"md-primary\">Done</md-button><md-button ng-click=\"search.clearTreeviewModel(search.inputs.sample.location)\" class=\"md-secondary\">Clear</md-button></md-content></md-sidenav><md-sidenav md-component-id=\"sidenavSampleTypes\" md-is-open=\"search.sidenavSampleTypesIsOpen\" class=\"md-sidenav-left md-whiteframe-z2 search-sidenav-wider\"><md-content layout-padding><h1 class=\"md-toolbar-tools\" translate=\"search.searchCards.sampleInfo.lookup.sampleTypes\">Sample Types</h1><div ivh-treeview=\"search.inputs.sample.sampleType.value\" ivh-treeview-options=\"::search.treeviewOpts\"></div><md-button href ng-click=\"search.sidenavSampleTypesIsOpen = false\" class=\"md-primary\">Done</md-button><md-button href ng-click=\"search.clearTreeviewModel(search.inputs.sample.sampleType)\" class=\"md-secondary\">Clear</md-button></md-content></md-sidenav><md-fab-speed-dial ng-if=\"search.isAdmin || search.isCoordinator\" class=\"fab-speed-hover md-fab-bottom-right md-fling\" md-open=\"search.isFabOpen\" md-direction=\"up\"><md-fab-trigger><md-button class=\"md-fab md-warn\">NEW</md-button></md-fab-trigger><md-fab-actions><md-button onblur=\"\" ng-click=\"search.showNewRecordDialog()\" aria-label=\"{{ \'braininstituteApp.sampleInfo.addSample\' | translate }}\" class=\"md-fab md-raised md-mini\"><md-tooltip md-visible=\"search.tooltipVisible\" md-autohide=\"false\" md-direction=\"left\"><span translate=\"braininstituteApp.sampleInfo.addSample\">Add Sample</span></md-tooltip><md-icon style=\"color: grey\" md-svg-icon=\"content:ic_add_24px\"></md-icon></md-button><md-button onblur=\"\" ng-click=\"search.showNewPatientDialog()\" aria-label=\"{{ \'braininstituteApp.patient.addPatient\' | translate }}\" class=\"md-fab md-raised md-mini\"><md-tooltip md-visible=\"search.tooltipVisible\" md-autohide=\"false\" md-direction=\"left\"><span translate=\"braininstituteApp.patient.addPatient\">Add Patient</span></md-tooltip><md-icon style=\"color: grey\" md-svg-icon=\"content:ic_add_24px\"></md-icon></md-button></md-fab-actions></md-fab-speed-dial>");
  $templateCache.put("users/users.html", "<md-toolbar id=\"tcinc-main-toolbar\"><div class=\"md-toolbar-tools\"><md-button aria-label=\"Menu\" ng-click=\"toggleAppSidenav()\"><md-icon md-svg-icon=\"navigation:ic_menu_24px\"></md-icon></md-button><h3>User management</h3><span flex></span><md-switch id=\"switch-disabled-users\" ng-model=\"ctrl.showDisabledUsers\" aria-label=\"Show Disabled Users\">Disabled Users</md-switch><notification-menu></notification-menu></div></md-toolbar><md-button class=\"md-fab md-fab-bottom-right md-warn\" aria-label=\"Add Users\" ng-click=\"usersCtrl.goCreateUser()\">NEW</md-button><md-content><md-list><md-list-item class=\"md-2-line\" ng-repeat=\"user in users\" ng-hide=\"!ctrl.showDisabledUsers && !user.enabled\" ng-click=\"usersCtrl.goEditUser(user)\"><div class=\"md-list-item-text\"><h4>{{user.fullName}}</h4><p>{{user.email}} <span class=\"text-danger\" ng-hide=\"user.enabled\">&nbsp;&nbsp;Disabled</span> <span class=\"text-danger\" ng-hide=\"user.activated\">&nbsp;&nbsp;Not Active</span> <span class=\"text-danger\" ng-hide=\"user.accountNonLocked\">&nbsp;&nbsp;Locked</span></p></div><md-menu class=\"md-secondary\" md-position-mode=\"target-right target\" ng-hide=\"usersCtrl.isTCUser(user)\"><md-button class=\"md-icon-button\" aria-label=\"menu\" ng-click=\"$mdOpenMenu($event)\"><md-icon md-svg-icon=\"navigation:ic_more_vert_24px\" md-menu-origin></md-icon></md-button><md-menu-content width=\"3\"><md-menu-item><md-button ng-click=\"usersCtrl.deleteUser(user)\"><md-icon md-svg-icon=\"action:ic_delete_24px\" md-menu-align-target></md-icon><p>Delete User</p></md-button></md-menu-item><!--<md-menu-divider></md-menu-divider>--><md-menu-item ng-hide=\"user.accountNonLocked\"><md-button ng-click=\"usersCtrl.unlockUser(user.email)\"><md-icon md-svg-icon=\"action:ic_lock_open_24px\" md-menu-align-target></md-icon><p>Unlock User</p></md-button></md-menu-item><md-menu-item><md-button ng-click=\"usersCtrl.uploadProtocol(user)\"><md-icon md-svg-icon=\"file:ic_file_upload_24px\" md-menu-align-target></md-icon><p>Upload Protocol</p></md-button></md-menu-item></md-menu-content></md-menu><!--<md-icon  class=\"md-secondary\" aria-label=\"Reset Password\"--><!--ng-click=\"\"></md-icon>--><md-divider ng-if=\"!$last\"></md-divider></md-list-item></md-list></md-content>");
  $templateCache.put("account/activate/activate.html", "<md-toolbar><div class=\"md-toolbar-tools\"><md-button aria-label=\"Menu\" ng-click=\"toggleAppSidenav()\"><md-icon md-svg-icon=\"navigation:ic_menu_24px\"></md-icon></md-button><h3>Login</h3><span flex></span><notification-menu></notification-menu></div></md-toolbar><md-content><div layout=\"row\" layout-align=\"center center\"><md-card class=\"md-whiteframe-z3\"><md-card-content><h1 translate=\"activate.title\">Activation</h1><br><h5 translate=\"activate.subTitle\">Please set your password</h5><form ng-hide=\"success\" name=\"form\" ng-submit=\"activate()\" novalidate><div layout=\"column\"><md-input-container><label translate=\"global.form.newpassword\">New password</label><input ng-pattern=\"/^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,50}$/\" type=\"password\" name=\"password\" ng-model=\"password\" ng-minlength=\"8\" ng-maxlength=\"50\" required><div ng-messages=\"form.password.$error\" ng-show=\"form.password.$dirty && form.password.$invalid\"><div ng-message=\"required\"><span translate=\"global.messages.validate.newpassword.required\">Your password is required.</span></div><div ng-message=\"minlength\"><span translate=\"global.messages.validate.newpassword.minlength\">Your password is required to be at least 5 characters.</span></div><div ng-message=\"pattern\"><span translate=\"global.messages.validate.newpassword.pattern\">The password does not follow the required pattern.</span></div><div ng-message=\"maxlength\"><span translate=\"global.messages.validate.newpassword.maxlength\">Your password cannot be longer than 50 characters.</span></div></div></md-input-container><password-strength-bar layout=\"row\" password-to-check=\"password\"></password-strength-bar><md-input-container><label translate=\"global.form.confirmpassword\">New password confirmation</label><input ng-pattern=\"/^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,50}$/\" type=\"password\" name=\"confirmPassword\" ng-model=\"confirmPassword\" ng-minlength=\"8\" ng-maxlength=\"50\" required><div ng-messages=\"form.confirmPassword.$error\" ng-show=\"form.confirmPassword.$dirty\"><div ng-message=\"required\"><span translate=\"global.messages.validate.confirmpassword.required\">Your password confirmation is required.</span></div><div ng-message=\"pattern\"><span translate=\"global.messages.validate.confirmpassword.pattern\">The password does not follow the required pattern.</span></div><div ng-message=\"minlength\"><span translate=\"global.messages.validate.confirmpassword.minlength\">Your password is required to be at least 5 characters.</span></div><div ng-message=\"maxlength\"><span translate=\"global.messages.validate.confirmpassword.maxlength\">Your password cannot be longer than 50 characters.</span></div></div></md-input-container><h3>Password must meet the following criteria:</h3><ul><li>Must be at least 8 characters.</li><li>Cannot exceed 50 characters.</li><li>Needs at least one upper case letter.</li><li>Needs at least one lower case letter.</li><li>Needs at least one number.</li><li>Needs at least one special character.</li></ul></div><div layout=\"row\" layout-align=\"end center\"><md-button type=\"submit\" ng-disabled=\"form.$invalid\" class=\"md-raised md-primary\" translate=\"activate.form.button\">Activate</md-button></div></form><div layout=\"column\" ng-show=\"success\"><div translate=\"activate.messages.success\"><strong>Your user has been activated.</strong></div><md-button ui-sref=\"login\">Sign in</md-button></div></md-card-content></md-card></div></md-content>");
  $templateCache.put("account/login/login.html", "<md-toolbar><div class=\"md-toolbar-tools\"><md-button aria-label=\"Menu\" ng-click=\"toggleAppSidenav()\"><md-icon md-svg-icon=\"navigation:ic_menu_24px\"></md-icon></md-button><h3>Login</h3><span flex></span><notification-menu></notification-menu></div></md-toolbar><md-content><div layout=\"row\" layout-align=\"center center\"><div layout=\"column\"><md-card><md-card-content><h2 class=\"md-toolbar-tools\" translate=\"login.title\">Login</h2><div layout=\"row\" class=\"login-message\" ng-show=\"message\">{{message}}</div><div layout=\"row\" layout-padding layout-align=\"center center\"><form name=\"loginForm\" ng-submit=\"login(loginForm)\" novalidate><div layout=\"column\" layout-align=\"center center\"><md-input-container><label translate=\"global.form.email\">Email</label><input id=\"email\" ng-model=\"email\" name=\"email\" type=\"email\" ng-required=\"true\" ng-trim=\"false\" to-lower-case><div ng-messages=\"loginForm.email.$error\" ng-show=\"loginForm.email.$dirty\" role=\"alert\"><div ng-message=\"required\"><span translate=\"global.messages.validate.email.required\">This is required.</span></div><div ng-message=\"email\"><span translate=\"global.messages.validate.email.invalid\">Invalid E-mail.</span></div></div></md-input-container><md-input-container><label translate=\"login.form.password\">Password</label><input id=\"password\" type=\"password\" name=\"password\" ng-model=\"password\" ng-required=\"true\"><div ng-messages=\"loginForm.password.$error\" ng-show=\"loginForm.password.$dirty\" role=\"alert\"><div ng-message=\"required\"><span translate=\"global.messages.validate.password.required\">This is required.</span></div></div></md-input-container><md-button class=\"md-raised md-primary\" type=\"submit\" translate=\"login.form.button\">Sign In</md-button></div></form></div></md-card-content></md-card><div layout=\"row\" layout-align=\"space-around center\"><md-button translate=\"global.messages.info.reset\" href=\"#/reset/request\">Reset my password</md-button><!--<md-button translate=\"global.messages.info.register\" href=\"#/register\">Register</md-button>--></div><div layout=\"column\" layout-align=\"center center\" class=\"version\"><span>Powered by TEKStack Platform © 2016 All rights reserved</span> <span><a href=\"http://www.translucentcomputing.com\" target=\"_blank\">Translucent Computing Inc.</a></span> <span>Version:&nbsp;<span app-version></span></div></div></div></md-content>");
  $templateCache.put("account/password/password.html", "<md-dialog aria-label=\"User\" ng-cloak class=\"change-password-dialog\"><md-toolbar><div class=\"md-toolbar-tools\"><h2 translate=\"password.title\">Change Password</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon md-svg-icon=\"content:ic_clear_24px\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><form name=\"form\" role=\"form\" novalidate ng-submit=\"changePassword()\"><md-dialog-content><div class=\"md-dialog-content\"><div layout=\"row\" layout-sm=\"column\" ng-show=\"isSubmitting\" class=\"darkClass\" layout-align=\"center center\"><md-progress-circular md-mode=\"indeterminate\"></md-progress-circular></div><div layout=\"column\"><md-input-container><label translate=\"global.form.newpassword\">New password</label><input type=\"password\" name=\"password\" ng-pattern=\"/^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,50}$/\" ng-model=\"password\" ng-minlength=\"8\" ng-maxlength=\"50\" required><div ng-messages=\"form.password.$error\" ng-show=\"form.password.$dirty && form.password.$invalid\"><div ng-message=\"required\"><span translate=\"global.messages.validate.newpassword.required\">Your password is required.</span></div><div ng-message=\"pattern\"><span translate=\"global.messages.validate.newpassword.pattern\">The password does not follow the required pattern.</span></div><div ng-message=\"minlength\"><span translate=\"global.messages.validate.newpassword.minlength\">Your password is required to be at least 8 characters.</span></div><div ng-message=\"maxlength\"><span translate=\"global.messages.validate.newpassword.maxlength\">Your password cannot be longer than 50 characters.</span></div></div></md-input-container><password-strength-bar password-to-check=\"password\"></password-strength-bar><br><md-input-container><label translate=\"global.form.confirmpassword\">New password confirmation</label><input type=\"password\" name=\"confirmPassword\" ng-pattern=\"/^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,50}$/\" ng-model=\"confirmPassword\" ng-minlength=\"8\" ng-maxlength=\"50\" required><div ng-messages=\"form.confirmPassword.$error\" ng-show=\"form.confirmPassword.$dirty && form.confirmPassword.$invalid\"><div ng-message=\"required\"><span translate=\"global.messages.validate.confirmpassword.required\">Your confirmation password is required.</span></div><div ng-message=\"pattern\"><span translate=\"global.messages.validate.confirmpassword.pattern\">The password does not follow the required pattern.</span></div><div ng-message=\"minlength\"><span translate=\"global.messages.validate.confirmpassword.minlength\">Your confirmation password is required to be at least 8 characters.</span></div><div ng-message=\"maxlength\"><span translate=\"global.messages.validate.confirmpassword.maxlength\">Your confirmation password cannot be longer than 50 characters.</span></div></div></md-input-container><h3>Password must meet the following criteria:</h3><ul><li>Must be at least 8 characters.</li><li>Cannot exceed 50 characters.</li><li>Needs at least one upper case letter.</li><li>Needs at least one lower case letter.</li><li>Needs at least one number.</li><li>Needs at least one special character.</li></ul></div></div></md-dialog-content><md-dialog-actions><md-button ng-hide=\"isSubmitting\" type=\"submit\" class=\"md-raised md-primary\" translate=\"password.form.change\">Save</md-button></md-dialog-actions></form></md-dialog>");
  $templateCache.put("account/password/password_template.html", "<div id=\"strength\"><small translate=\"global.messages.validate.newpassword.strength\">Password strength:</small><ul id=\"strengthBar\"><li class=\"point\"></li><li class=\"point\"></li><li class=\"point\"></li><li class=\"point\"></li><li class=\"point\"></li></ul></div>");
  $templateCache.put("account/register/register.html", "<div layout=\"row\" layout-align=\"center center\"><md-card><md-card-content><div layout=\"row\"><h2 translate=\"register.title\">Registration</h2></div><div layout=\"row\" layout-align=\"center center\"><form ng-show=\"!success\" name=\"form\" ng-submit=\"register()\" novalidate><md-input-container><label translate=\"global.form.email\">E-mail</label><input type=\"email\" name=\"email\" ng-model=\"registerAccount.email\" ng-minlength=\"5\" ng-maxlength=\"100\" ng-required=\"true\"><div ng-messages=\"form.email.$error\" ng-show=\"form.email.$dirty\"><div ng-message=\"required\"><span translate=\"global.messages.validate.email.required\">Your e-mail is required.</span></div><div ng-message=\"email\"><span translate=\"global.messages.validate.email.invalid\">Your e-mail is invalid.</span></div><div ng-message=\"minlength, maxlength\"><span translate=\"global.messages.validate.email.minMaxLength\">Your e-mail is required to be at least 5 characters no be longer than 100 characters</span></div></div></md-input-container><password-strength-bar layout=\"row\" password-to-check=\"registerAccount.password\"></password-strength-bar><md-input-container><label translate=\"global.form.newpassword\">New password</label><input type=\"password\" name=\"password\" ng-model=\"registerAccount.password\" ng-minlength=\"5\" ng-maxlength=\"50\" required><div ng-messages=\"form.password.$error\" ng-show=\"form.password.$dirty && form.password.$invalid\"><div ng-message=\"required\"><span translate=\"global.messages.validate.newpassword.required\">Your password is required.</span></div><div ng-message=\"minlength\"><span translate=\"global.messages.validate.newpassword.minlength\">Your password is required to be at least 5 characters.</span></div><div ng-message=\"maxlength\"><span translate=\"global.messages.validate.newpassword.maxlength\">Your password cannot be longer than 50 characters.</span></div></div></md-input-container><md-input-container><label translate=\"global.form.confirmpassword\">New password confirmation</label><input type=\"password\" name=\"confirmPassword\" ng-model=\"confirmPassword\" ng-minlength=\"5\" ng-maxlength=\"50\" required><div ng-messages=\"form.confirmPassword.$error\" ng-show=\"form.confirmPassword.$dirty\"><div ng-message=\"required\"><span translate=\"global.messages.validate.confirmpassword.required\">Your password confirmation is required.</span></div><div ng-message=\"minlength\"><span translate=\"global.messages.validate.confirmpassword.minlength\">Your password is required to be at least 5 characters.</span></div><div ng-message=\"maxlength\"><span translate=\"global.messages.validate.confirmpassword.maxlength\">Your password cannot be longer than 50 characters.</span></div></div></md-input-container><md-input-container><label>Select a location</label><md-select name=\"siteLocation\" ng-model=\"registerAccount.siteLocation\" required><md-option ng-value=\"location\" ng-repeat=\"location in locations\">{{location.name}}</md-option></md-select></md-input-container><div layout=\"row\" layout-align=\"end center\"><md-button type=\"submit\" ng-disabled=\"form.$invalid || !registerAccount.siteLocation\" class=\"md-raised md-primary\" translate=\"register.form.button\">Register</md-button></div></form></div></md-card-content></md-card></div>");
  $templateCache.put("components/form/pager.html", "<nav><ul class=\"braininstituteApp-pager\"><li ng-show=\"links[\'first\']\" ng-click=\"loadPage(links[\'first\'])\"><a href=\"#\">&lt;&lt;</a></li><li ng-show=\"links[\'prev\']\" ng-click=\"loadPage(links[\'prev\'])\"><a href=\"#\">&lt;</a></li><li ng-show=\"links[\'next\']\" ng-click=\"loadPage(links[\'next\'])\"><a href=\"#\">&gt;</a></li><li ng-show=\"links[\'last\']\" ng-click=\"loadPage(links[\'last\'])\"><a href=\"#\">&gt;&gt;</a></li></ul></nav>");
  $templateCache.put("components/form/pagination.html", "<nav><ul class=\"braininstituteApp-pagination\"><li ng-show=\"links[\'first\']\" ng-click=\"loadPage(links[\'first\'])\"><a>&lt;&lt;</a></li><li ng-show=\"links[\'prev\']\" ng-click=\"loadPage(links[\'prev\'])\"><a>&lt;</a></li><li ng-show=\"page > 2\" ng-click=\"loadPage(page - 2)\"><a>{{page - 2}}</a></li><li ng-show=\"page > 1\" ng-click=\"loadPage(page - 1)\"><a>{{page - 1}}</a></li><li class=\"active\"><a>{{page}}</a></li><li ng-show=\"page < links[\'last\']\" ng-click=\"loadPage(page + 1)\"><a>{{page + 1}}</a></li><li ng-show=\"page < links[\'last\'] - 1\" ng-click=\"loadPage(page + 2)\"><a>{{page + 2}}</a></li><li ng-show=\"links[\'next\']\" ng-click=\"loadPage(links[\'next\'])\"><a>&gt;</a></li><li ng-show=\"links[\'last\']\" ng-click=\"loadPage(links[\'last\'])\"><a>&gt;&gt;</a></li></ul></nav>");
  $templateCache.put("components/navbar/navbar.html", "<md-sidenav class=\"md-sidenav-left md-whiteframe-z2 site-sidenav\" md-component-id=\"navbar\" id=\"sideNavMenu\"><header class=\"nav-header\" layout-align=\"center center\"><span class=\"nav-title\" translate=\"global.title\">Brain Tumour Bank Network University of Toronto</span><user-info user=\"user\" ng-if=\"isAuthenticated()\"></user-info></header><md-list><span ng-repeat=\"page in menu.pages()\"><span ng-if=\"page.url\"><md-list-item ng-click=\"menu.toggleSideNav()\" ui-sref=\"{{page.url}}\" ui-sref-active=\"navbar-active\" aria-label=\"Menu Item\"><md-icon ng-if=\"page.icon\" md-svg-icon=\"{{page.icon}}\"></md-icon><p translate=\"{{page.name}}\"></p></md-list-item></span> <span ng-if=\"page.click\"><md-list-item ng-click=\"page.click(); menu.toggleSideNav()\" _class=\"md-no-style\" aria-label=\"Menu Item\"><md-icon ng-if=\"page.icon\" md-svg-icon=\"{{page.icon}}\"></md-icon><p translate=\"{{page.name}}\"></p></md-list-item></span></span></md-list><div class=\"footer\">Powered by TEKStack Platform © 2016 All rights reserved<br><a href=\"http://www.translucentcomputing.com\" target=\"_blank\">Translucent Computing Inc.</a></div></md-sidenav>");
  $templateCache.put("document/directive/searchbar.html", "<span class=\"md-flex documents-toolbar-row-2\"><div flex class=\"search-bar\" ng-class=\"{\'search-open\': ctrl.showSearchUi, \'search-open-query\': ctrl.query.length!==0}\" ng-mousedown=\"ctrl.openSearch($event)\" layout><span class=\"search-icon\"><md-icon md-svg-icon=\"action:ic_search_24px\"></md-icon></span><md-chips ng-model=\"ctrl.query\" md-autocomplete-snap md-require-match=\"true\" md-separator-keys=\"ctrl.chipSeparators\" md-transform-chip=\"ctrl.transformChip($chip, ctrl.query)\"><md-autocomplete md-selected-item=\"ctrl.selectedItem\" md-search-text=\"ctrl.searchText\" md-items=\"item in ctrl.querySearch(ctrl.searchText)\" md-item-text=\"item.name\" placeholder=\"{{ctrl.searchPlaceholder}}\"><span md-highlight-text=\"ctrl.searchText\">{{item.out}}: {{item.name}}</span></md-autocomplete><md-chip-template>{{$chip.out}}: <em>{{$chip.name}}</em></md-chip-template></md-chips><span flex></span><md-button class=\"search-clear\" aria-label=\"Clear search\" ng-show=\"ctrl.searched\" ng-click=\"ctrl.clearSearch()\"><md-icon md-svg-icon=\"content:ic_clear_24px\"></md-icon></md-button></div></span>");
  $templateCache.put("document/template/fileForm.html", "<md-dialog aria-label=\"File Upload\" ng-cloak><md-toolbar><div class=\"md-toolbar-tools\"><h2 translate=\"braininstituteApp.document.upload.title\">File Upload</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon md-svg-icon=\"content:ic_clear_24px\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><form name=\"fileUploadForm\" ng-submit=\"uploadFile()\" novalidate><md-dialog-content style=\"width: 330px\"><div layout=\"row\" layout-sm=\"column\" ng-show=\"isProcessing\" class=\"darkClass\" layout-align=\"center center\"><md-progress-circular md-mode=\"indeterminate\"></md-progress-circular></div><div layout=\"column\" layout-padding><md-input-container ng-if=\"showCategories\"><label for=\"category\">Category</label><md-select id=\"category\" name=\"category\" ng-model=\"file.category\" required><md-option ng-value=\"category.name\" ng-repeat=\"category in categories\">{{category.name}}</md-option></md-select><div ng-messages=\"fileUploadForm.category.$error\"><div ng-message=\"required\"><span>Category is required.</span></div></div></md-input-container><md-input-container><input type=\"file\" ngf-select ng-model=\"file.data\" name=\"file\" accept=\"application/msword,application/vnd.ms-excel,application/vnd.ms-powerpoint,text/plain,application/pdf\" ngf-max-size=\"{{maxUploadSize}}\" ngf-model-invalid=\"errorFile\" required><div ng-messages=\"fileUploadForm.file.$error\"><div ng-message=\"required\"><span>File is required.</span></div><div ng-message=\"maxSize\"><span>File too large {{errorFile.size / 1000000|number:1}}MB: max {{maxUploadSize}}</span></div></div><md-button class=\"md-raised\" ng-click=\"file.data = null\" ng-show=\"file.data\">Remove</md-button></md-input-container></div><div ng-show=\"share && file.category !== \'User Protocol\'\"><div layout=\"row\" ng-click=\"collapsedUser=!collapsedUser\" layout-padding style=\"outline: none\">Shared with <span flex></span> <span aria-hidden=\"true\" class=\"md-toggle-icon\" ng-class=\"{\'toggled\' : collapsedUser}\"><md-icon md-svg-icon=\"hardware:ic_keyboard_arrow_down_24px\"></md-icon></span></div><md-content layout=\"column\" md-theme=\"default\" ng-hide=\"collapsedUser\" layout-padding><md-autocomplete md-no-cache=\"true\" md-selected-item=\"selectedUser\" md-search-text=\"userSearchText\" md-items=\"item in userSearch(userSearchText)\" md-item-text=\"item.fullName\" md-min-length=\"0\" placeholder=\"Type to search for an user..\"><md-item-template><span class=\"item-title\" md-highlight-text=\"userSearchText\" md-highlight-flags=\"^i\">{{item.fullName}}</span> <span class=\"item-metadata\">{{item.email}}</span></md-item-template><md-not-found>No user matching \"{{userSearchText}}\" were found.</md-not-found></md-autocomplete><md-button class=\"md-raised md-primary\" ng-click=\"onUserSelect()\">Add User</md-button><md-subheader>Users:</md-subheader><md-subheader ng-show=\"file.sharedUsers.length == 0\">No users selected.</md-subheader><md-list><md-list-item class=\"md-2-line\" ng-repeat=\"user in file.sharedUsers | orderBy: \'fullName\'\"><div class=\"md-list-item-text\"><h4>{{user.fullName}}</h4><p>{{user.email}}</p></div><md-icon class=\"md-secondary\" md-svg-icon=\"action:ic_delete_24px\" ng-click=\"removeUser(user)\"></md-icon></md-list-item></md-list></md-content></div></md-dialog-content><md-dialog-actions layout=\"row\"><span ng-hide=\"isProcessing\" flex></span><md-button ng-hide=\"isProcessing\" ng-disabled=\"disableEdit\" class=\"md-raised md-primary\" type=\"submit\">Save</md-button><md-progress-linear ng-show=\"isProcessing && file.data.progress >= 0\" md-mode=\"determinate\" value=\"{{file.data.progress}}\"></md-progress-linear></md-dialog-actions></form></md-dialog>");
  $templateCache.put("document/template/fileShare.html", "<md-dialog aria-label=\"Shared with\" ng-cloak><md-toolbar><div class=\"md-toolbar-tools\"><h2 translate=\"braininstituteApp.document.share.title\">Shared With</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon md-svg-icon=\"content:ic_clear_24px\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><form name=\"fileShareForm\" ng-submit=\"save()\" novalidate><md-dialog-content><div layout=\"row\" layout-sm=\"column\" ng-show=\"isProcessing\" class=\"darkClass\" layout-align=\"center center\"><md-progress-circular md-mode=\"indeterminate\"></md-progress-circular></div><md-content layout=\"column\" layout-padding><md-autocomplete md-no-cache=\"true\" md-selected-item=\"selectedUser\" md-search-text=\"userSearchText\" md-items=\"item in userSearch(userSearchText)\" md-item-text=\"item.fullName\" md-min-length=\"0\" placeholder=\"Type to search for an user..\"><md-item-template><span class=\"item-title\" md-highlight-text=\"userSearchText\" md-highlight-flags=\"^i\">{{item.fullName}}</span> <span class=\"item-metadata\">{{item.email}}</span></md-item-template><md-not-found>No user matching \"{{userSearchText}}\" were found.</md-not-found></md-autocomplete><md-button class=\"md-raised md-primary\" ng-click=\"onUserSelect()\">Add User</md-button><md-subheader>Users:</md-subheader><md-subheader ng-show=\"sharedUsers.length == 0\">No users selected.</md-subheader><md-list><md-list-item class=\"md-2-line\" ng-repeat=\"user in sharedUsers | orderBy: \'fullName\'\"><div class=\"md-list-item-text\"><h4>{{user.fullName}}</h4><p>{{user.email}}</p></div><md-icon class=\"md-secondary\" md-svg-icon=\"action:ic_delete_24px\" ng-click=\"removeUser(user)\"></md-icon></md-list-item></md-list></md-content></md-dialog-content><md-dialog-actions layout=\"row\"><span flex></span><md-button ng-hide=\"isProcessing\" class=\"md-raised md-primary\" type=\"submit\">Save</md-button></md-dialog-actions></form></md-dialog>");
  $templateCache.put("document/template/sidenav.html", "<md-toolbar class=\"md-theme-light\"><h1 class=\"md-toolbar-tools\">Info</h1></md-toolbar><md-content><md-subheader info-section-toggle class=\"md-primary documents-info-sidenav-expansion-header\">Owner</md-subheader><md-list><md-list-item class=\"md-2-line\"><div class=\"md-list-item-text\"><h4>Name</h4><p>{{[ctrl.info.doc.user.firstName, ctrl.info.doc.user.lastName].join(\' \')}}</p></div></md-list-item><md-divider></md-divider><md-list-item class=\"md-2-line\"><div class=\"md-list-item-text\"><h4>Email</h4><p>{{ctrl.info.doc.user.email}}</p></div></md-list-item><md-divider></md-divider><md-list-item class=\"md-2-line\"><div class=\"md-list-item-text\"><h4>Phone number</h4><p>{{ctrl.info.doc.user.phone}}</p></div></md-list-item><md-divider></md-divider><md-list-item class=\"md-2-line\"><div class=\"md-list-item-text\"><h4>Institution</h4><p>{{ctrl.info.doc.institution}}</p></div></md-list-item><md-divider></md-divider><md-list-item class=\"md-2-line\"><div class=\"md-list-item-text\"><h4>Role</h4><p>{{ctrl.formatFileOwnerRole(ctrl.info.doc.user.groups)}}</p></div></md-list-item></md-list><md-subheader info-section-toggle start-collapsed class=\"md-primary documents-info-sidenav-expansion-header\">File</md-subheader><md-list ng-show=\"ctrl.info.doc.meta\"><md-list-item class=\"md-2-line\"><div class=\"md-list-item-text\"><h4>File Name</h4><p>{{ctrl.info.doc.meta.name}}</p></div></md-list-item><md-divider></md-divider><md-list-item class=\"md-2-line\"><div class=\"md-list-item-text\"><h4>File Title</h4><p>{{ctrl.info.doc.meta.title}}</p></div></md-list-item><md-divider></md-divider><md-list-item class=\"md-2-line\"><div class=\"md-list-item-text\"><h4>Author</h4><p>{{ctrl.info.doc.meta.author}}</p></div></md-list-item><md-divider></md-divider><md-list-item class=\"md-2-line\"><div class=\"md-list-item-text\"><h4>Keywords</h4><p>{{ctrl.info.doc.meta.keywords}}</p></div></md-list-item><md-divider></md-divider><md-list-item class=\"md-2-line\"><div class=\"md-list-item-text\"><h4>Create Date</h4><p>{{ctrl.info.doc.meta.cratedDate}}</p></div></md-list-item><md-divider></md-divider><md-list-item class=\"md-2-line\"><div class=\"md-list-item-text\"><h4>Last Modifed Date</h4><p>{{ctrl.info.doc.meta.modDate}}</p></div></md-list-item><md-divider></md-divider><md-list-item class=\"md-2-line\"><div class=\"md-list-item-text\"><h4>Type</h4><p>{{ctrl.info.doc.meta.contentType}}</p></div></md-list-item><md-divider></md-divider><md-list-item class=\"md-2-line\"><div class=\"md-list-item-text\"><h4>Size</h4><p>{{ctrl.info.doc.meta.contentLength | bytes}}</p></div></md-list-item></md-list><md-subheader info-section-toggle start-collapsed class=\"md-primary documents-info-sidenav-expansion-header\" ng-show=\"ctrl.info.doc.shareUsers && ctrl.info.doc.shareUsers.length\">Shared with</md-subheader><md-list ng-show=\"ctrl.info.doc.shareUsers && ctrl.info.doc.shareUsers.length\"><md-list-item class=\"md-2-line\" ng-repeat=\"su in ctrl.info.doc.shareUsers\"><div class=\"md-list-item-text\"><h4>{{su.email}}</h4><p>{{su.lastName + \", \" + su.firstName}}</p></div><md-divider></md-divider></md-list-item></md-list><md-button ng-click=\"ctrl.closeInfo()\" class=\"md-primary\">Close</md-button></md-content>");
  $templateCache.put("newPatient/template/newPatientDialog.html", "<md-dialog aria-label=\"New Record\" ng-cloak><form name=\"recordForm\" ng-submit=\"submit()\" novalidate><md-toolbar><div class=\"md-toolbar-tools\"><div ng-switch=\"isEdit\"><h2 ng-switch-when=\"false\">New Patient</h2><h2 ng-switch-when=\"true\">Edit Patient</h2></div><span flex></span><md-button type=\"button\" class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon md-svg-icon=\"content:ic_clear_24px\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content class=\"record-dialog-content\"><div class=\"md-dialog-content\"><div layout=\"row\" layout-sm=\"column\" ng-show=\"loadingPatient || isSubmitting\" class=\"darkClass\" layout-align=\"center center\"><md-progress-circular md-mode=\"indeterminate\"></md-progress-circular></div><div layout=\"column\"><h3 class=\"ng-binding sub-title\">Patient data</h3><md-input-container><label>Patient ID</label><input name=\"patientCode\" patient-found=\"patientFound\" type=\"text\" ng-blur=\"onPatientBlur()\" ng-keypress=\"onKeyPressed($event)\" ng-model=\"patient.code\" required><div ng-messages=\"recordForm.patientCode.$error\"><div ng-message=\"required\"><span>This field is required</span></div><div ng-message=\"patientfound\"><span>There is already a patient with this code</span></div></div></md-input-container><md-input-container><label>Gender</label><md-select ng-model=\"patient.fgGender\"><md-option ng-value=\"gender.id\" ng-repeat=\"gender in genders\">{{gender.name}}</md-option></md-select></md-input-container><md-input-container><label>Length of survival – year</label><input type=\"number\" min=\"0\" step=\"1\" pattern=\"\\d+\" name=\"lengthOfSurvivalYear\" ng-model=\"patient.lengthOfSurvivalYear\"><div ng-messages=\"recordForm.lengthOfSurvivalYear.$error\"><div ng-message=\"min\"><span translate=\"entity.validation.min\" translate-values=\"{min: 0}\"></span></div><div ng-message=\"pattern\"><span translate=\"entity.validation.pattern\" translate-values=\"{pattern: \'YYYY\'}\"></span></div></div></md-input-container><md-input-container><label>Length of survival – month</label><input type=\"number\" min=\"0\" max=\"12\" ng-model=\"patient.lengthOfSurvivalMonth\"></md-input-container><md-input-container ng-if=\"isAdmin\"><label>Site location</label><md-select name=\"siteLocation\" ng-model=\"patient.siteLocation\" required ng-model-options=\"{ trackBy: \'$value._links.self.href\' }\"><md-option ng-value=\"location\" ng-repeat=\"location in siteLocations\">{{location.name}}</md-option></md-select><div ng-messages=\"recordForm.siteLocation.$error\"><div ng-message=\"required\"><span>Site location is required.</span></div></div></md-input-container></div></div></md-dialog-content><md-dialog-actions><md-button class=\"md-raised md-primary\" type=\"submit\">Submit</md-button></md-dialog-actions></form></md-dialog>");
  $templateCache.put("newRecord/template/newRecordDialog.html", "<md-dialog aria-label=\"New Record\" ng-cloak><form name=\"recordForm\" ng-submit=\"recordForm.$valid && submit()\" novalidate><md-toolbar><div class=\"md-toolbar-tools\"><h2>New Record</h2><span flex></span><md-button type=\"button\" class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon md-svg-icon=\"content:ic_clear_24px\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content class=\"record-dialog-content\"><div class=\"md-dialog-content\"><div layout=\"row\" layout-sm=\"column\" ng-show=\"isSubmitting\" class=\"darkClass\" layout-align=\"center center\"><md-progress-circular md-mode=\"indeterminate\"></md-progress-circular></div><div layout=\"column\" layout-margin><div layout=\"row\"><h1 class=\"md-headline\">Patient&nbsp; &nbsp;</h1><h3 class=\"md-headline\">{{sampleInfo.patientCode}}</h3></div><md-input-container ng-hide=\"patientFound\"><label>Patient ID</label><input type=\"text\" name=\"patientCode\" ng-blur=\"onPatientBlur()\" ng-keypress=\"onKeyPressed($event)\" ng-model=\"sampleInfo.patientCode\" invalid-patient=\"invalidPatientCode\" required><div ng-messages=\"recordForm.patientCode.$error\" ng-show=\"recordForm.patientCode.$touched\"><div ng-message=\"required\"><span>Patient ID is required</span></div><div ng-message=\"invalidpatient\"><span>You need to type an existing patient ID.</span></div><div ng-message=\"nopermission\"><span>You do not have permission to add Samples for this Patient.</span></div></div></md-input-container><md-progress-circular ng-show=\"loadingPatient\" md-mode=\"indeterminate\"></md-progress-circular><h1 class=\"md-headline\">Sample Details</h1><md-input-container><label>Date of treatment (Surgical)</label><input name=\"dtSurgery\" type=\"number\" min=\"1900\" max=\"2100\" ng-model=\"dtSurgeryClientModel\" required><div ng-messages=\"recordForm.dtSurgery.$error\"><div ng-message=\"required\"><span>This field is required.</span></div><div ng-message=\"min\"><span>Year should be 1900 at least.</span></div><div ng-message=\"max\"><span>Maximum year is 2100.</span></div></div></md-input-container><md-input-container><label>Age at diagnosis Year</label><input name=\"ageAtDiagnosisYear\" type=\"number\" min=\"0\" max=\"130\" step=\"1\" pattern=\"\\d+\" ng-model=\"sampleInfo.ageAtDiagnosisYear\"><div ng-messages=\"recordForm.ageAtDiagnosisYear.$error\"><div ng-message=\"max\"><span>Maximum year is 130.</span></div></div></md-input-container><md-input-container><label>Age at diagnosis Month</label><input type=\"number\" min=\"0\" step=\"1\" pattern=\"\\d+\" ng-model=\"sampleInfo.ageAtDiagnosisMonth\"></md-input-container><md-input-container><label>Date of diagnosis</label><input name=\"dtDiagnosisText\" ng-model=\"dtDiagnosisText\" month-input required><div ng-messages=\"recordForm.dtDiagnosisText.$error\"><div ng-message=\"required\"><span>This field is required</span></div><div ng-message=\"pattern\"><span>Invalid Date</span></div></div></md-input-container><md-input-container><label>Molecular</label><md-select multiple=\"multiple\" ng-model=\"selectedMoleculars\" ng-model-options=\"{ trackBy: \'$value._links.self.href\'}\"><md-option ng-value=\"molecular\" ng-repeat=\"molecular in moleculars\">{{molecular.name}}</md-option></md-select></md-input-container><md-input-container><label>Notes</label><textarea name=\"notes\" ng-model=\"sampleInfo.notes\">Notes</textarea></md-input-container><h1 class=\"md-title\">Diagnosis</h1><dependent-dropdown title=\"Diagnosis\" top-model=\"topDiagnosis\" initial-data=\"sampleInfo.diagnosis\" number-of-levels=\"3\" querier=\"DiagnosisQuery(callback)\" show-selects-as-needed=\"true\" titles-array=\"diagnosisDropdownTitles\"></dependent-dropdown><md-input-container><label>Diagnosis comment</label><textarea columns=\"1\" rows=\"3\" type=\"text\" ng-model=\"sampleInfo.diagnosisNotes\"></textarea></md-input-container><h1 class=\"md-title\">Location</h1><dependent-dropdown title=\"Location\" top-model=\"topLocation\" initial-data=\"sampleInfo.location\" number-of-levels=\"4\" show-selects-as-needed=\"true\" querier=\"LocationQuery(callback)\"></dependent-dropdown><md-input-container><label>Location comment</label><textarea columns=\"1\" rows=\"3\" ng-model=\"sampleInfo.locationNotes\"></textarea></md-input-container><h1 class=\"md-title\">Sample type</h1><sample-type-selector top-model=\"topSampleType\" sample=\"sampleInfo\"></sample-type-selector><md-button type=\"button\" ng-click=\"sampleTypeAdd()\" class=\"md-raised md-primary\" translate=\"braininstituteApp.sampleInfo.addSample\" ng-disabled=\"!topSampleType || (topSampleType.countable && (sampleInfo.aliquots == undefined || sampleInfo.aliquots == null))\">Add Sample</md-button><md-list><md-list-item ng-repeat=\"st in samples track by $index\"><div class=\"md-list-item-text\"><h4>{{st.sampleType.name}}</h4><p>Aliquots:{{st.aliquots || (st.containAliquots ? \"Yes\" : \"No\")}}<span ng-show=\"st.code\">- {{st.code}}</span></p></div><md-icon md-svg-icon=\"action:ic_delete_24px\" class=\"md-secondary\" ng-click=\"deleteSampleType(st)\"></md-icon></md-list-item></md-list><div ng-messages=\"samples.length == 0\"><div><span ng-show=\"samples.length == 0\" class=\"invalid-message\">You need to add at least one sample type</span></div></div></div></div></md-dialog-content><md-dialog-actions layout=\"row\"><span flex></span><md-button ng-hide=\"isSubmitting\" class=\"md-raised md-primary\" type=\"submit\">Submit record</md-button></md-dialog-actions></form></md-dialog>");
  $templateCache.put("newRecord/template/preloadConfirmBottomSheet.html", "<md-bottom-sheet class=\"md-list md-has-header\" ng-cloak><md-subheader>Pre-load data?</md-subheader><p>You are creating a record for an existing Patient ID. Would you like to load the most recent data for Diagnosis Date, Surgery Date, Diagnosis, Molecular and Location fields?</p><md-list><md-list-item><md-button ng-click=\"yes()\" md-autofocus=\"true\" class=\"md-list-item-content\"><!--<md-icon md-svg-src=\"{{item.icon}}\"></md-icon>--><span class=\"md-inline-list-icon-label\">Yes</span></md-button></md-list-item><md-list-item><md-button ng-click=\"no()\" class=\"md-list-item-content\"><!--<md-icon md-svg-src=\"{{item.icon}}\"></md-icon>--><span class=\"md-inline-list-icon-label\">No</span></md-button></md-list-item></md-list></md-bottom-sheet>");
  $templateCache.put("sampleEdit/template/sampleEditForm.html", "<md-dialog aria-label=\"Sample Data\" ng-cloak><form name=\"sampleForm\" ng-submit=\"sampleForm.$valid && sampleFormSubmit()\" novalidate><md-toolbar><div class=\"md-toolbar-tools\"><h2>Edit sample {{ sampleInfo.code }}</h2><span flex></span><md-button type=\"button\" class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon md-svg-icon=\"content:ic_clear_24px\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content class=\"record-dialog-content\"><div class=\"md-dialog-content\"><div layout=\"row\" layout-sm=\"column\" ng-show=\"loadingData || savingSample\" class=\"darkClass\" layout-align=\"center center\"><md-progress-circular md-mode=\"indeterminate\"></md-progress-circular></div><div layout=\"column\" layout-margin><div layout=\"row\"><h1 class=\"md-headline\">Patient&nbsp; &nbsp;</h1><h3 class=\"md-headline\">{{sampleInfo.patientCode}}</h3></div><h1 class=\"md-headline\">Sample Details</h1><md-input-container><label>Date of treatment (Surgical) (Year)</label><input name=\"dtSurgery\" type=\"number\" min=\"1900\" max=\"2100\" ng-model=\"dtSurgeryClientModel\" required><div ng-messages=\"sampleForm.dtSurgery.$error\"><div ng-message=\"required\"><span>This field is required.</span></div><div ng-message=\"min\"><span>Year should be 1900 at least.</span></div><div ng-message=\"max\"><span>Maximum year is 2100.</span></div></div></md-input-container><md-input-container><label>Age at diagnosis Year</label><input name=\"ageAtDiagnosisYear\" type=\"number\" min=\"0\" max=\"130\" step=\"1\" pattern=\"\\d+\" ng-model=\"sampleInfo.ageAtDiagnosisYear\"><div ng-messages=\"sampleForm.ageAtDiagnosisYear.$error\"><div ng-message=\"max\"><span>Maximum year is 130.</span></div></div></md-input-container><md-input-container><label>Age at diagnosis Month</label><input type=\"number\" min=\"0\" step=\"1\" pattern=\"\\d+\" ng-model=\"sampleInfo.ageAtDiagnosisMonth\"></md-input-container><md-input-container><label>Date of diagnosis</label><input name=\"dtDiagnosisText\" ng-model=\"dtDiagnosisText\" month-input required><div ng-messages=\"sampleForm.dtDiagnosisText.$error\"><div ng-message=\"required\"><span>This field is required</span></div><div ng-message=\"pattern\"><span>Invalid Date</span></div></div></md-input-container><md-input-container><label>Molecular</label><md-select multiple=\"multiple\" ng-model=\"selectedMoleculars\" ng-model-options=\"{ trackBy: \'$value._links.self.href\'}\"><md-option ng-value=\"molecular\" ng-repeat=\"molecular in moleculars\">{{molecular.name}}</md-option></md-select></md-input-container><md-input-container><label>Notes</label><textarea name=\"notes\" columns=\"1\" rows=\"3\" ng-model=\"sampleInfo.notes\"></textarea></md-input-container><h1 class=\"md-title\">Diagnosis</h1><dependent-dropdown title=\"Diagnosis\" top-model=\"topDiagnosis\" initial-data=\"sampleInfo.diagnosis\" number-of-levels=\"3\" querier=\"DiagnosisQuery(callback)\" show-selects-as-needed=\"true\" titles-array=\"diagnosisDropdownTitles\"></dependent-dropdown><md-input-container><label>Diagnosis comment</label><textarea columns=\"1\" rows=\"3\" ng-model=\"sampleInfo.diagnosisNotes\"></textarea></md-input-container><h1 class=\"md-title\">Location</h1><dependent-dropdown title=\"Location\" top-model=\"topLocation\" initial-data=\"sampleInfo.location\" number-of-levels=\"4\" show-selects-as-needed=\"true\" querier=\"LocationQuery(callback)\"></dependent-dropdown><md-input-container><label>Location comment</label><textarea columns=\"1\" rows=\"3\" ng-model=\"sampleInfo.locationNotes\"></textarea></md-input-container><h1 class=\"md-title\">Sample type</h1><sample-type-selector top-model=\"topSampleType\" sample=\"sampleInfo\"></sample-type-selector></div></div></md-dialog-content><md-dialog-actions layout=\"row\"><span flex></span><md-button ng-hide=\"savingSample\" type=\"submit\" class=\"md-raised md-primary\">Save Sample</md-button></md-dialog-actions></form></md-dialog>");
  $templateCache.put("sampleView/template/requestSampleDialog.html", "<md-dialog aria-label=\"Request sample\" ng-cloak><form ng-show=\"requestable === true\" name=\"requestForm\" ng-submit=\"sendRequest()\" novalidate><md-toolbar><div class=\"md-toolbar-tools\"><h2>Request sample</h2><span flex></span><md-button type=\"button\" class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon md-svg-icon=\"content:ic_clear_24px\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content class=\"request-sample-dialog-content\"><div class=\"md-dialog-content\"><h1 class=\"md-title\">Request Sample</h1><md-input-container style=\"width:100%\" ng-show=\"isCountable\"><label>Please specify the number of aliquots requested</label><input name=\"aliquotsRequested\" ng-model=\"request.aliquotsRequested\" required type=\"number\" min=\"0.01\" max=\"{{aliquotsAvailable}}\" ng-required=\"isCountable\"><div ng-messages=\"requestForm.aliquotsRequested.$error\"><div ng-message=\"required\">This field is required</div><!--TODO: more...--></div></md-input-container><label ng-show=\"isCountable\">out of {{aliquotsAvailable}}</label><label ng-show=\"!isCountable\">The sample is available.</label></div></md-dialog-content><md-dialog-actions><md-button type=\"submit\" class=\"md-primary\">Send Request</md-button></md-dialog-actions></form><div ng-if=\"requestable === false\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>Error — Request sample</h2><span flex></span><md-button type=\"button\" class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon md-svg-icon=\"content:ic_clear_24px\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content class=\"request-sample-dialog-content\"><div class=\"md-dialog-content\"><h1 class=\"md-title\">Error</h1><p>{{error}}</p></div></md-dialog-content><md-dialog-actions><md-button ng-click=\"cancel()\" class=\"md-primary\">OK</md-button></md-dialog-actions></div></md-dialog>");
  $templateCache.put("search/template/cardAvailability.html", "<div layout=\"column\"><md-input-container ng-show=\"search.inputs.avail.siteLocation.visible\" layout=\"row\"><label translate=\"braininstituteApp.sampleInfo.sampleSiteLocation\">Sample site location</label><md-select ng-model=\"search.inputs.avail.siteLocation.value\" md-on-close=\"search.blurOrChangeEvents()\" multiple=\"multiple\"><md-option ng-value=\"location\" ng-repeat=\"location in search.siteLocations\">{{location.name}}</md-option></md-select></md-input-container><md-input-container ng-show=\"search.inputs.avail.siteAvailability.visible\" layout=\"row\"><label translate=\"braininstituteApp.sampleInfo.siteAvailability\">Site availability</label><md-select ng-model=\"search.inputs.avail.siteAvailability.value\" ng-change=\"search.blurOrChangeEvents()\"><md-option ng-value=\"null\"></md-option><md-option ng-value=\"yn\" ng-repeat=\"yn in search.yesNo\">{{yn.name}}</md-option></md-select></md-input-container><div ng-show=\"!search.isInputEmpty(\'avail.siteAvailability\') && search.inputs.avail.siteAvailability.visible\" layout=\"row\"><md-input-container flex><label translate=\"braininstituteApp.sampleInfo.aliquotsFrom\">Aliquots from</label><input type=\"number\" min=\"0\" max=\"{{search.inputs.avail.siteAvailability.aliquots.to}}\" ng-model=\"search.inputs.avail.siteAvailability.aliquots.from\" ng-blur=\"search.blurOrChangeEvents()\"></md-input-container><md-input-container flex><label translate=\"braininstituteApp.forms.to\">To</label><input type=\"number\" min=\"{{search.inputs.avail.siteAvailability.aliquots.from}}\" ng-model=\"search.inputs.avail.siteAvailability.aliquots.to\" ng-blur=\"search.blurOrChangeEvents()\"></md-input-container></div></div>");
  $templateCache.put("search/template/cardPatient.html", "<div layout=\"column\" layout-align=\"start stretch\"><md-input-container ng-show=\"search.inputs.patient.patientCode.visible\"><label translate=\"braininstituteApp.patient.patientId\">Patient ID</label><input type=\"text\" ng-model=\"search.inputs.patient.patientCode.value\" input-space-remover ng-blur=\"search.blurOrChangeEvents()\"></md-input-container><h3 ng-show=\"search.inputs.patient.ageAtDiagnosisYear.visible\" class=\"md-subhead\" translate=\"braininstituteApp.patient.ageAtDiagnosisYear\">Age at diagnosis (Year)</h3><div ng-show=\"search.inputs.patient.ageAtDiagnosisYear.visible\" range-validator=\"integer\" layout=\"row\"><md-input-container flex><label translate=\"braininstituteApp.forms.from\">From</label><input type=\"number\" min=\"0\" max=\"130\" range-validator-child=\"from\" ng-model=\"search.inputs.patient.ageAtDiagnosisYear.value.from\" ng-change=\"search.blurOrChangeEvents()\"></md-input-container><md-input-container flex><label translate=\"braininstituteApp.forms.to\">To</label><input type=\"number\" min=\"0\" max=\"130\" range-validator-child=\"to\" ng-model=\"search.inputs.patient.ageAtDiagnosisYear.value.to\" ng-change=\"search.blurOrChangeEvents()\"></md-input-container></div><h3 ng-show=\"search.inputs.patient.ageAtDiagnosisMonth.visible\" class=\"md-subhead\" translate=\"braininstituteApp.patient.ageAtDiagnosisMonth\">Age at diagnosis (Month)</h3><div ng-show=\"search.inputs.patient.ageAtDiagnosisMonth.visible\" range-validator=\"integer\" layout=\"row\"><md-input-container flex><label translate=\"braininstituteApp.forms.from\">From</label><input type=\"number\" min=\"0\" max=\"12\" range-validator-child=\"from\" ng-model=\"search.inputs.patient.ageAtDiagnosisMonth.value.from\" ng-change=\"search.blurOrChangeEvents()\"></md-input-container><md-input-container flex><label translate=\"braininstituteApp.forms.to\">To</label><input type=\"number\" min=\"0\" max=\"12\" range-validator-child=\"to\" ng-model=\"search.inputs.patient.ageAtDiagnosisMonth.value.to\" ng-change=\"search.blurOrChangeEvents()\"></md-input-container></div><h3 ng-show=\"search.inputs.patient.lengthOfSurvivalYear.visible\" class=\"md-subhead\" translate=\"braininstituteApp.patient.lengthOfSurvivalYear\">Length of survival (Year)</h3><div ng-show=\"search.inputs.patient.lengthOfSurvivalYear.visible\" range-validator=\"integer\" layout=\"row\"><md-input-container flex><label translate=\"braininstituteApp.forms.from\">From</label><input type=\"number\" min=\"0\" max=\"130\" range-validator-child=\"from\" ng-model=\"search.inputs.patient.lengthOfSurvivalYear.value.from\" ng-change=\"search.blurOrChangeEvents()\"></md-input-container><md-input-container flex><label translate=\"braininstituteApp.forms.to\">To</label><input type=\"number\" min=\"0\" max=\"130\" range-validator-child=\"to\" ng-model=\"search.inputs.patient.lengthOfSurvivalYear.value.to\" ng-change=\"search.blurOrChangeEvents()\"></md-input-container></div><h3 ng-show=\"search.inputs.patient.lengthOfSurvivalMonth.visible\" class=\"md-subhead\" translate=\"braininstituteApp.patient.lengthOfSurvivalMonth\">Length of survival (Month)</h3><div ng-show=\"search.inputs.patient.lengthOfSurvivalMonth.visible\" range-validator=\"integer\" layout=\"row\"><md-input-container flex><label translate=\"braininstituteApp.forms.from\">From</label><input type=\"number\" min=\"0\" max=\"12\" range-validator-child=\"from\" ng-model=\"search.inputs.patient.lengthOfSurvivalMonth.value.from\" ng-change=\"search.blurOrChangeEvents()\"></md-input-container><md-input-container flex><label translate=\"braininstituteApp.forms.to\">To</label><input type=\"number\" min=\"0\" max=\"12\" range-validator-child=\"to\" ng-model=\"search.inputs.patient.lengthOfSurvivalMonth.value.to\" ng-change=\"search.blurOrChangeEvents()\"></md-input-container></div><md-input-container ng-show=\"search.inputs.patient.gender.visible\"><label translate=\"braininstituteApp.patient.gender\">Gender</label><md-select ng-model=\"search.inputs.patient.gender.value\" ng-change=\"search.blurOrChangeEvents()\"><md-option ng-value=\"null\"></md-option><md-option ng-value=\"gender\" ng-repeat=\"gender in search.genders\">{{gender.name}}</md-option></md-select></md-input-container><h3 ng-show=\"search.inputs.patient.dtSurgery.visible\" class=\"md-subhead\" translate=\"braininstituteApp.patient.dateOfTreatmentSurgicalYear\">Date of treatment (Surgical) (Year)</h3><div ng-show=\"search.inputs.patient.dtSurgery.visible\" range-validator=\"integer\" layout=\"row\"><md-input-container flex><label translate=\"braininstituteApp.forms.from\">From</label><input type=\"number\" min=\"1900\" max=\"2100\" range-validator-child=\"from\" ng-model=\"search.inputs.patient.dtSurgery.value.from\" ng-change=\"search.blurOrChangeEvents()\"></md-input-container><md-input-container flex><label translate=\"braininstituteApp.forms.to\">To</label><input type=\"number\" min=\"1900\" max=\"2100\" range-validator-child=\"to\" ng-model=\"search.inputs.patient.dtSurgery.value.to\" ng-change=\"search.blurOrChangeEvents()\"></md-input-container></div></div>");
  $templateCache.put("search/template/cardSample.html", "<div layout=\"column\"><md-input-container ng-show=\"search.inputs.sample.diagnosis.visible\"><label translate=\"braininstituteApp.diagnosis.diagnosis\">Diagnosis</label><input aria-label=\"{{ \'braininstituteApp.diagnosis.diagnosisSummary\' | translate }}\" ng-model=\"search.inputs.sample.diagnosis.viewValue\" ng-click=\"search.sidenavOpen(\'sidenavDiagnosis\')\"></md-input-container><md-input-container ng-show=\"search.inputs.sample.location.visible\"><label translate=\"braininstituteApp.location.location\">Location</label><input aria-label=\"{{ \'braininstituteApp.location.locationSummary\' | translate }}\" ng-model=\"search.inputs.sample.location.viewValue\" ng-click=\"search.sidenavOpen(\'sidenavLocations\')\"></md-input-container><md-input-container ng-show=\"search.inputs.sample.code.visible\"><label translate=\"braininstituteApp.sampleInfo.sampleId\">Sample ID</label><input type=\"text\" ng-model=\"search.inputs.sample.code.value\" input-space-remover ng-blur=\"search.blurOrChangeEvents()\"></md-input-container><md-input-container ng-show=\"search.inputs.sample.molecular.visible\"><label translate=\"braininstituteApp.molecular.molecular\">Molecular</label><md-select ng-model=\"search.inputs.sample.molecular.value\" md-on-close=\"search.blurOrChangeEvents()\" multiple=\"multiple\"><md-option ng-value=\"molecular\" ng-repeat=\"molecular in search.moleculars\">{{molecular.name}}</md-option></md-select></md-input-container><md-input-container ng-show=\"search.inputs.sample.sampleType.visible\"><label translate=\"braininstituteApp.sampleType.sampleType\">Sample type</label><input aria-label=\"{{ \'braininstituteApp.sampleType.sampleTypeSummary\' | translate }}\" ng-model=\"search.inputs.sample.sampleType.viewValue\" ng-click=\"search.sidenavOpen(\'sidenavSampleTypes\')\"></md-input-container><h3 class=\"md-subhead\" ng-show=\"search.inputs.sample.dtDiagnosis.visible\" translate=\"braininstituteApp.sampleInfo.dtDiagnosis\">Date of diagnosis</h3><div ng-show=\"search.inputs.sample.dtDiagnosis.visible\" range-validator=\"year-month\" layout=\"row\"><md-input-container><label translate=\"braininstituteApp.forms.from\">From</label><input name=\"dtDiagnosisFrom\" ng-model=\"search.inputs.sample.dtDiagnosis.value.from\" ng-blur=\"search.blurOrChangeEvents()\" range-validator-child=\"from\" month-input><div ng-messages=\"searchForm.dtDiagnosisFrom.$error\"><div ng-message=\"pattern\"><span translate=\"entity.validation.invalid\">Invalid input</span></div><div ng-message=\"range\"><span translate=\"entity.validation.fromBiggerThanTo\">Invalid range</span></div></div></md-input-container><md-input-container><label translate=\"braininstituteApp.forms.to\">To</label><input name=\"dtDiagnosisTo\" ng-model=\"search.inputs.sample.dtDiagnosis.value.to\" ng-blur=\"search.blurOrChangeEvents()\" range-validator-child=\"to\" month-input><div ng-messages=\"searchForm.dtDiagnosisTo.$error\"><div ng-message=\"pattern\"><span translate=\"entity.validation.invalid\">Invalid input</span></div><div ng-message=\"range\"><span translate=\"entity.validation.fromBiggerThanTo\">Invalid range</span></div></div></md-input-container></div></div>");
  $templateCache.put("search/template/changeInputVisibilityDialog.html", "<md-dialog aria-label=\"Search filter visibility settings\" ng-cloak><form name=\"changeFilterVisibilityForm\" ng-submit=\"hide()\" novalidate><md-toolbar><div class=\"md-toolbar-tools\"><h2>Change filter visibility</h2><span flex></span><md-button type=\"button\" class=\"md-icon-button\" ng-click=\"hide()\"><md-icon md-svg-icon=\"content:ic_clear_24px\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content class=\"record-dialog-content\"><div class=\"md-dialog-content\"><div layout=\"row\" layout-sm=\"column\" ng-show=\"isSubmitting\" class=\"darkClass\" layout-align=\"center center\"><md-progress-circular md-mode=\"indeterminate\"></md-progress-circular></div><div layout=\"column\" layout-margin><h3>Search filter visibility settings for this group</h3><md-checkbox ng-repeat=\"input in inputs\" ng-model=\"input.visible\" ng-change=\"saveOne(input)\" class=\"fix-for-md-checkbox-last\">{{ input.displayName }}</md-checkbox></div></div></md-dialog-content><md-dialog-actions><md-button ng-click=\"selectAll()\" ng-show=\"!isAllSelected()\">Select all</md-button><md-button ng-click=\"selectNone()\" ng-show=\"isAllSelected()\">Select none</md-button><md-button class=\"md-raised md-primary\" type=\"submit\">Close</md-button></md-dialog-actions></form></md-dialog>");
  $templateCache.put("search/template/exportColumnsDialog.html", "<md-dialog id=\"export-columns-dialog\" aria-label=\"Search column visibility settings\" ng-cloak><form name=\"changeVisibilityForm\" novalidate><md-toolbar><div class=\"md-toolbar-tools\"><!--TODO Dan - change to using i18n translation tag--><h2>Select column to include</h2><span flex></span><md-button type=\"button\" class=\"md-icon-button\" ng-click=\"hide()\"><md-icon md-svg-icon=\"content:ic_clear_24px\" aria-label=\"{{ \'global.dialogs.closeDialog\' | translate }}\"></md-icon></md-button></div></md-toolbar><md-dialog-content class=\"record-dialog-content\"><div class=\"md-dialog-content\"><div layout=\"row\" layout-sm=\"column\" ng-show=\"isSubmitting\" class=\"darkClass\" layout-align=\"center center\"><md-progress-circular md-mode=\"indeterminate\"></md-progress-circular></div><div layout=\"column\" layout-margin><!--TODO Dan - change to using i18n translation tag--><h3>Select the columns you would like to export</h3><md-checkbox ng-repeat=\"item in items\" ng-model=\"item.checked\" ng-change=\"changed(item)\" class=\"fix-for-md-checkbox-last\">{{ item.name }}</md-checkbox></div></div></md-dialog-content><md-dialog-actions><md-button ng-click=\"selectAll()\" ng-show=\"!isAllSelected()\">Select all</md-button><md-button ng-click=\"selectNone()\" ng-show=\"isAllSelected()\">Select none</md-button><md-button id=\"export-columns-done-btn\" class=\"md-raised md-primary\" type=\"button\" ng-click=\"done()\">Done</md-button></md-dialog-actions></form></md-dialog>");
  $templateCache.put("search/template/requestMultipleSampleDialog.html", "<md-dialog aria-label=\"Request sample\" ng-cloak><form name=\"requestForm\" ng-submit=\"sendRequest()\" novalidate><md-toolbar><div class=\"md-toolbar-tools\"><h2>Request samples</h2><span flex></span><md-button type=\"button\" class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon md-svg-icon=\"content:ic_clear_24px\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content class=\"request-sample-dialog-content\"><div layout=\"row\" layout-sm=\"column\" ng-show=\"loadingAll\" class=\"darkClass\" layout-align=\"center center\"><md-progress-circular md-mode=\"indeterminate\"></md-progress-circular></div><div class=\"md-dialog-content\"><h1 class=\"md-title\">Request Samples</h1><div style=\"margin-top: 20px\" ng-repeat=\"sample in requestingSamples\"><label>{{sample.description}}</label><div ng-if=\"sample.requestable\"><md-progress-linear ng-show=\"sample.request.submitting\"></md-progress-linear><md-input-container style=\"width: 50%\" ng-if=\"sample.isCountable\"><label>Please specify the number of aliquots requested</label><input name=\"aliquotsRequested\" ng-disabled=\"submitted\" ng-model=\"sample.request.aliquotsRequested\" type=\"number\" min=\"0.01\" max=\"{{sample.aliquotsAvailable}}\" ng-required=\"sample.isCountable\"></md-input-container><label ng-show=\"sample.isCountable\">out of {{sample.aliquotsAvailable}}</label><label ng-show=\"!sample.isCountable\">The sample is available.</label></div><div ng-show=\"!sample.requestable\"><label style=\"margin-top: 10px; color:red\">{{sample.error}}</label></div><label ng-show=\"sample.request.success\" style=\"color: green\">SUCCESS</label><label ng-show=\"sample.request.success == false\" style=\"color: RED\">ERROR: {{item.request.error}}</label><md-divider style=\"margin-top: 20px\"></md-divider></div></div></md-dialog-content><div class=\"md-actions\"><md-button ng-hide=\"submitted || !anyAvailable\" type=\"submit\" class=\"md-primary\">Send Request</md-button><md-button ng-show=\"submitted || !anyAvailable\" type=\"button\" ng-click=\"cancel()\" class=\"md-primary\">Go Back</md-button></div></form></md-dialog>");
  $templateCache.put("users/template/userForm.html", "<md-dialog aria-label=\"User\" ng-cloak><md-toolbar><div class=\"md-toolbar-tools\"><div ng-switch=\"isEditing\"><h2 ng-switch-when=\"false\" translate=\"braininstituteApp.user.createTitle\">Create User</h2><h2 ng-switch-when=\"true\" translate=\"braininstituteApp.user.editTitle\">Edit User</h2></div><span flex></span><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon md-svg-icon=\"content:ic_clear_24px\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><form name=\"userForm\" ng-submit=\"addUser()\" novalidate><md-dialog-content><div class=\"md-dialog-content\"><div layout=\"row\" layout-sm=\"column\" ng-show=\"isSubmitting\" class=\"darkClass\" layout-align=\"center center\"><md-progress-circular md-mode=\"indeterminate\"></md-progress-circular></div><div layout=\"row\" layout-sm=\"column\" layout-align=\"center start\"><div layout=\"column\" layout-margin style=\"min-width: 300px; width: 100%\"><md-input-container><label>E-mail</label><input ng-disabled=\"disableEdit || user.activated\" type=\"email\" name=\"email\" ng-model=\"user.email\" ng-minlength=\"5\" ng-maxlength=\"100\" ng-model-options=\"{ updateOn: \'default blur\', debounce: {default: 500, blur: 0} }\" required ng-disabled=\"user.id\" ng-trim=\"false\" to-lower-case email-unique-validator euv-disable-validation=\"user.activated\"><div ng-messages=\"userForm.email.$error\" md-auto-hide=\"false\" ng-if=\"userForm.email.$touched\"><div ng-message=\"required\"><span translate=\"global.messages.validate.email.required\">Your e-mail is required.</span></div><div ng-message=\"email\"><span translate=\"global.messages.validate.email.invalid\">Your e-mail is invalid.</span></div><div ng-message=\"emailUnique\"><span translate=\"global.messages.validate.email.alreadyInUse\">This e-mail address is already in use.</span></div><div ng-message=\"minlength\"><span translate=\"global.messages.validate.email.minlength\">Your e-mail is required to be at least 5 characters.</span></div><div ng-message=\"maxlength\"><span translate=\"global.messages.validate.email.maxlength\">Your e-mail cannot be longer than 50 characters.</span></div></div></md-input-container><md-input-container><label for=\"firstName\">First name</label><input ng-disabled=\"disableEdit\" id=\"firstName\" name=\"firstName\" ng-model=\"user.firstName\" required=\"true\"><div ng-messages=\"userForm.firstName.$error\"><div ng-message=\"required\"><span translate=\"braininstituteApp.user.messages.validate.firstName.required\">Your first name is required.</span></div></div></md-input-container><md-input-container><label for=\"lastName\">Last name</label><input ng-disabled=\"disableEdit\" id=\"lastName\" name=\"lastName\" ng-model=\"user.lastName\" required=\"true\"><div ng-messages=\"userForm.lastName.$error\"><div ng-message=\"required\"><span translate=\"braininstituteApp.user.messages.validate.lastName.required\">Your last name is required.</span></div></div></md-input-container><md-input-container><label>Phone number</label><input ng-disabled=\"disableEdit\" type=\"tel\" name=\"phone\" ng-model=\"user.phone\" pattern=\"^\\s*(?:\\+?(\\d{1,3}))?[-. (]*(\\d{3})[-. )]*(\\d{3})[-. ]*(\\d{4})(?: *x(\\d+))?\\s*$\"><div ng-messages=\"userForm.phone.$error\" ng-show=\"userForm.phone.$dirty\"><div ng-message=\"pattern\"><span translate=\"braininstituteApp.user.messages.validate.phone.invalid\">nnn-nnn-nnnn</span></div></div></md-input-container><md-input-container ng-if=\"isAdmin\"><label>Select a location</label><md-select ng-disabled=\"disableEdit\" name=\"location\" ng-model=\"user.siteLocation\" ng-model-options=\"{ trackBy: \'$value._links.self.href\' }\" required><md-option ng-value=\"location\" ng-repeat=\"location in locations\">{{location.name}}</md-option></md-select><div ng-messages=\"userForm.location.$error\"><div ng-message=\"required\"><span translate=\"braininstituteApp.user.messages.validate.site-location.required\">The site location is required.</span></div></div></md-input-container><md-input-container><label>Select a role</label><md-select ng-disabled=\"disableEdit\" id=\"roleSelect\" name=\"roleSelect\" ng-model-options=\"{ trackBy: \'$value._links.self.href\' }\" ng-model=\"user.role\" required><md-option ng-value=\"role\" ng-repeat=\"role in authorities\">{{role.description}}</md-option></md-select><div ng-messages=\"userForm.roleSelect.$error\"><div ng-message=\"required\"><span translate=\"braininstituteApp.user.messages.validate.role.required\">The role is required.</span></div></div></md-input-container><md-switch ng-show=\"isEditing\" md-no-ink aria-label=\"Enabled\" ng-model=\"user.enabled\">{{user.enabled ? (\"braininstituteApp.user.enabled\" | translate) : (\"braininstituteApp.user.disabled\" | translate)}}</md-switch></div></div></div></md-dialog-content><md-dialog-actions layout=\"row\"><span flex></span><md-button ng-hide=\"isSubmitting\" class=\"md-raised md-primary\" type=\"submit\">Save</md-button></md-dialog-actions></form></md-dialog>");
  $templateCache.put("users/template/userPersonalInfoForm.html", "<md-dialog aria-label=\"User\" ng-cloak class=\"edit-user-dialog\"><md-toolbar><div class=\"md-toolbar-tools\"><h2 translate=\"braininstituteApp.user.editTitle\">Update Personal Info</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon md-svg-icon=\"content:ic_clear_24px\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><form name=\"userForm\" ng-submit=\"addUser()\" novalidate><md-dialog-content><div class=\"md-dialog-content\"><div layout=\"row\" layout-sm=\"column\" ng-show=\"isSubmitting\" class=\"darkClass\" layout-align=\"center center\"><md-progress-circular md-mode=\"indeterminate\"></md-progress-circular></div><div layout=\"row\" layout-sm=\"column\" layout-align=\"center start\"><div layout=\"column\" layout-margin class=\"edit-user-dialog-form\"><h2>{{user.email}}</h2><br><md-input-container><label for=\"firstName\">First name</label><input id=\"firstName\" name=\"firstName\" ng-model=\"user.firstName\" required=\"true\"><div ng-messages=\"userForm.firstName.$error\"><div ng-message=\"required\"><span translate=\"braininstituteApp.user.messages.validate.firstName.required\">Your first name is required.</span></div></div></md-input-container><md-input-container><label for=\"lastName\">Last name</label><input id=\"lastName\" name=\"lastName\" ng-model=\"user.lastName\" required=\"true\"><div ng-messages=\"userForm.lastName.$error\"><div ng-message=\"required\"><span translate=\"braininstituteApp.user.messages.validate.lastName.required\">Your last name is required.</span></div></div></md-input-container><md-input-container><label>Phone number</label><input type=\"tel\" name=\"phone\" ng-model=\"user.phone\" pattern=\"^\\s*(?:\\+?(\\d{1,3}))?[-. (]*(\\d{3})[-. )]*(\\d{3})[-. ]*(\\d{4})(?: *x(\\d+))?\\s*$\"><div ng-messages=\"userForm.phone.$error\" ng-show=\"userForm.phone.$dirty\"><div ng-message=\"pattern\"><span translate=\"braininstituteApp.user.messages.validate.phone.invalid\">nnn-nnn-nnnn</span></div></div></md-input-container></div></div></div></md-dialog-content><md-dialog-actions><md-button ng-hide=\"isSubmitting\" class=\"md-raised md-primary\" type=\"submit\">Save</md-button></md-dialog-actions></form></md-dialog>");
  $templateCache.put("account/reset/finish/reset.finish.html", "<md-toolbar><div class=\"md-toolbar-tools\"><md-button aria-label=\"Menu\" ng-click=\"toggleAppSidenav()\"><md-icon md-svg-icon=\"navigation:ic_menu_24px\"></md-icon></md-button><h3>Login</h3><span flex></span><notification-menu></notification-menu></div></md-toolbar><md-content><div layout=\"row\" layout-align=\"center center\"><md-card><md-card-content><h1 translate=\"reset.finish.title\">Reset password</h1><div style=\"min-width: 300px\" ng-hide=\"keyMissing\"><form layout=\"column\" name=\"form\" role=\"form\" novalidate ng-submit=\"finishReset()\"><md-input-container><label translate=\"global.form.newpassword\">New password</label><input ng-pattern=\"/^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,50}$/\" type=\"password\" name=\"password\" ng-model=\"resetAccount.password\" ng-minlength=\"8\" ng-maxlength=\"50\" required><div ng-messages=\"form.password.$error\" ng-show=\"form.password.$dirty && form.password.$invalid\"><div ng-message=\"required\"><span translate=\"global.messages.validate.newpassword.required\">Your password is required.</span></div><div ng-message=\"minlength\"><span translate=\"global.messages.validate.newpassword.minlength\">Your password is required to be at least 5 characters.</span></div><div ng-message=\"pattern\"><span translate=\"global.messages.validate.newpassword.pattern\">The password does not follow the required pattern.</span></div><div ng-message=\"maxlength\"><span translate=\"global.messages.validate.newpassword.maxlength\">Your password cannot be longer than 50 characters.</span></div></div></md-input-container><password-strength-bar password-to-check=\"resetAccount.password\"></password-strength-bar><md-input-container><label translate=\"global.form.confirmpassword\">New password confirmation</label><input ng-pattern=\"/^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,50}$/\" type=\"password\" name=\"confirmPassword\" ng-model=\"confirmPassword\" ng-minlength=\"8\" ng-maxlength=\"50\" required><div ng-messages=\"form.confirmPassword.$error\" ng-show=\"form.confirmPassword.$dirty && form.confirmPassword.$invalid\"><div ng-message=\"required\"><span translate=\"global.messages.validate.confirmpassword.required\">Your password confirmation is required.</span></div><div ng-message=\"pattern\"><span translate=\"global.messages.validate.confirmpassword.pattern\">The password does not follow the required pattern.</span></div><div ng-message=\"minlength\"><span translate=\"global.messages.validate.confirmpassword.minlength\">Your password confirmation is required to be at least 5 characters.</span></div><div ng-message=\"maxlength\"><span translate=\"global.messages.validate.confirmpassword.maxlength\">Your password confirmation cannot be longer than 50 characters.</span></div></div></md-input-container><h3>Password must meet the following criteria:</h3><ul><li>Must be at least 8 characters.</li><li>Cannot exceed 50 characters.</li><li>Needs at least one upper case letter.</li><li>Needs at least one lower case letter.</li><li>Needs at least one number.</li><li>Needs at least one special character.</li></ul><div layout=\"row\" layout-align=\"end center\"><div ng-show=\"isSubmitting\" style=\"width: 0; margin:0 auto\"><md-progress-circular md-mode=\"indeterminate\"></md-progress-circular></div><md-button ng-hide=\"isSubmitting\" type=\"submit\" ng-disabled=\"form.$invalid\" class=\"md-raised md-primary\" translate=\"reset.finish.form.button\">Reset Password</md-button></div></form></div></md-card-content></md-card></div></md-content>");
  $templateCache.put("account/reset/request/reset.request.html", "<md-toolbar><div class=\"md-toolbar-tools\"><md-button aria-label=\"Menu\" ng-click=\"toggleAppSidenav()\"><md-icon md-svg-icon=\"navigation:ic_menu_24px\"></md-icon></md-button><h3>Login</h3><span flex></span><notification-menu></notification-menu></div></md-toolbar><md-content><div layout=\"row\" layout-align=\"center center\"><md-card><md-card-content><h1 translate=\"reset.request.title\">Reset your password</h1><form name=\"form\" role=\"form\" novalidate ng-submit=\"requestReset()\"><md-input-container><label translate=\"global.form.email\">E-mail</label><input type=\"email\" name=\"email\" ng-model=\"resetAccount.email\" ng-minlength=\"5\" ng-maxlength=\"100\" required><div ng-messages=\"form.email.$error\" ng-show=\"form.email.$dirty && form.email.$invalid\"><div ng-message=\"required\"><span translate=\"global.messages.validate.email.required\">Your e-mail is required.</span></div><div ng-message=\"email\"><span translate=\"global.messages.validate.email.invalid\">Your e-mail is invalid.</span></div><div ng-message=\"minlength\"><span translate=\"global.messages.validate.email.minlength\">Your e-mail is required to be at least 5 characters.</span></div><div ng-message=\"maxlength\"><span translate=\"global.messages.validate.email.maxlength\">Your e-mail cannot be longer than 100 characters.</span></div></div></md-input-container><div layout=\"row\" layout-align=\"end center\"><div ng-show=\"isSubmitting\" style=\"width: 0; margin:0 auto\"><md-progress-circular md-mode=\"indeterminate\"></md-progress-circular></div><md-button ng-hide=\"isSubmitting\" type=\"submit\" ng-disabled=\"form.$invalid\" class=\"md-raised md-primary\" translate=\"reset.request.form.button\">Register</md-button></div></form></md-card-content></md-card></div></md-content>");
  $templateCache.put("components/common/toasts/toast-error.html", "<md-toast class=\"custom-toast toast-error\"><div class=\"toast-container\" flex layout=\"row\"><div class=\"icon-area\" flex=\"20\" layout=\"row\" layout-align=\"center center\"><md-icon md-svg-icon=\"alert:ic_error_24px\"></md-icon></div><div class=\"toast-container-text\" flex=\"80\" layout=\"row\" layout-align=\"center center\"><span class=\"md-toast-text\" flex>{{ctrl.message}}</span></div></div></md-toast>");
  $templateCache.put("components/common/toasts/toast-info.html", "<md-toast class=\"custom-toast toast-info\"><div class=\"toast-container\" flex layout=\"row\"><div class=\"icon-area\" flex=\"20\" layout=\"row\" layout-align=\"center center\"><md-icon md-svg-icon=\"action:ic_info_24px\"></md-icon></div><div class=\"toast-container-text\" flex=\"80\" layout=\"row\" layout-align=\"center center\"><span class=\"md-toast-text\" flex>{{ctrl.message}}</span></div></div></md-toast>");
  $templateCache.put("components/common/toasts/toast-success.html", "<md-toast class=\"custom-toast toast-success\"><div class=\"toast-container\" flex layout=\"row\"><div class=\"icon-area\" flex=\"20\" layout=\"row\" layout-align=\"center center\"><md-icon md-svg-icon=\"action:ic_done_24px\"></md-icon></div><div class=\"toast-container-text\" flex=\"80\" layout=\"row\" layout-align=\"center center\"><span class=\"md-toast-text\" flex>{{ctrl.message}}</span></div></div></md-toast>");
  $templateCache.put("components/common/toasts/toast-warning.html", "<md-toast class=\"custom-toast toast-warning\"><div class=\"toast-container\" flex layout=\"row\"><div class=\"icon-area\" flex=\"20\" layout=\"row\" layout-align=\"center center\"><md-icon md-svg-icon=\"alert:ic_warning_24px\"></md-icon></div><div class=\"toast-container-text\" flex=\"80\" layout=\"row\" layout-align=\"center center\"><span class=\"md-toast-text\" flex>{{ctrl.message}}</span></div></div></md-toast>");
  $templateCache.put("components/navbar/template/userinfo.html", "<div class=\"nav-user-info\" layout-align=\"center center\"><md-icon md-svg-icon=\"action:ic_account_circle_24px\" style=\"color:white;height:64px;width:64px\"></md-icon><br><span>{{ user.firstName + \' \' + user.lastName }}</span><br><span>{{ user.email }}</span></div>");
  $templateCache.put("components/common/directive/manyTabs/manyTabs.html", "<!--This file is currently not being used. It is for the alternative idea that\'s in JIRA.--><div ng-show=\"expandedMode === false\" class=\"many-tabs-tab-list\" layout=\"row\" layout-wrap style=\"text-align: center\"><div ng-repeat=\"pane in panes\" flex=\"100\"><md-button href style=\"text-transform: none\" ng-click=\"select(pane)\">{{ pane.title }}<!--<md-icon ng-show=\"pane.dirty\" md-svg-icon=\"navigation:ic_check_24px\"></md-icon>--></md-button></div></div>");
  $templateCache.put("components/common/directive/manyTabs/manyTabsPane.html", "<!-- <div ng-show=\"visible\" ng-style=\'{\"margin-bottom\":(expanded?100:0)+\"px\"}\'> --><div ng-show=\"visible\"><div ng-click=\"expand()\" style=\"cursor: pointer\" layout=\"row\" ng-show=\"!expanded\"><h2 href class=\"md-title\">{{ title }}</h2><md-icon md-svg-icon=\"navigation:ic_check_24px\" ng-show=\"changedCount > 0\" aria-label=\"There are active filters\"></md-icon></div><h2 ng-show=\"expanded\" ng-click=\"goBack()\" href style=\"cursor: pointer; color: #D81B60\" class=\"md-title\"><md-icon md-svg-icon=\"navigation:ic_chevron_left_24px\" style=\"color: #D81B60\"></md-icon>{{ title }}</h2><div ng-show=\"expanded\" ng-transclude></div><div ng-show=\"expanded\" class=\"md-actions\" layout=\"row\" layout-align=\"end center\"><md-button ng-click=\"changeFilterVisibilityCallback()\" href>Change</md-button><md-button ng-click=\"clear()\" href class=\"md-primary md-accent\">Clear {{ changedCount }} filters</md-button></div><md-divider></md-divider></div>");
  $templateCache.put("components/common/directive/notificationMenu/notificationMenu.html", "<md-menu ng-show=\"isAuthenticated()\" md-position-mode=\"target-right target\"><div><md-button aria-label=\"Open notification menu\" id=\"notification-button\" class=\"md-icon-button\" ng-click=\"openMenu($mdOpenMenu, $event)\"><md-icon ng-class=\"{\'notification-icon-down\': stompDown}\" md-menu-origin md-svg-icon=\"social:ic_notifications_24px\"></md-icon></md-button><span ng-show=\"getNotificationCount() > 0\" class=\"badge\">{{getNotificationCount()}}</span></div><md-menu-content width=\"6\" id=\"notification-menu-content\"><md-list><div ng-show=\"stompDown\" class=\"notification-down\">Please refresh the page to get notifications. Due to a connectivity issue, you are not connected to the notification service.</div><div layout=\"row\" ng-hide=\"stompDown\"><md-subheader class=\"md-no-sticky\">{{getNotificationCount()}} new notifications Page:{{getPageData().number+1+\"/\"+(getPageData().totalPages > 0 ? getPageData().totalPages : \"1\")}}</md-subheader><md-button ng-click=\"clearAllNotifications()\" ng-show=\"getNotificationCount() > 0\" class=\"md-warn\" id=\"btn-clear-all-notif\">Clear all</md-button></div><div style=\"height: auto\" ng-repeat=\"n in getNotifications() | limitTo:5\"><md-divider></md-divider><md-menu-item class=\"notification-menu-item\"><md-list-item class=\"md-2-line notification-list-item\" ng-click=\"notificationClick(n)\"><!--<img src=\"https://material.angularjs.org/latest/img/list/60.jpeg?0\"--><!--class=\"md-avatar\"/>--><div class=\"md-list-item-text\" layout=\"column\"><h3>{{parseTitle(n.category)}}<p class=\"notification-list-item-date\">{{parseDate(n.dtNotification)}}</p></h3><p class=\"notification-list-item-message\">{{ n.message }}</p></div></md-list-item></md-menu-item></div><div ng-show=\"loadingMore\" layout=\"row\" style=\"width: 100%\" layout-align=\"center center\"><md-progress-circular md-mode=\"indeterminate\"></md-progress-circular></div><div ng-hide=\"loadingMore||stompDown\" style=\"width: 100%; margin-top: 10px\"><md-button md-prevent-menu-close ng-show=\"getPageData().number > 0\" ng-click=\"previous()\" type=\"button\" style=\"float: left\" class=\"md-raised\" id=\"btn-prev-page-notif\">Previous</md-button><md-button md-prevent-menu-close ng-show=\"getPageData().totalPages > (getPageData().number + 1)\" ng-click=\"next()\" type=\"button\" style=\"float: right\" class=\"md-raised\" id=\"btn-next-page-notif\">Next</md-button></div></md-list></md-menu-content></md-menu>");
  $templateCache.put("components/common/directive/sampleTypeSelector/sampleTypeSelector.html", "<md-select ng-model=\"sampleType.first\" placeholder=\"Category 1\" ng-model-options=\"{ trackBy: \'$value._links.self.href\' }\"><md-option ng-click=\"onChangeSampleType(sampleType)\" ng-value=\"sampleType\" ng-repeat=\"sampleType in sampleTypesFirst\">{{ sampleType.name }}</md-option></md-select><md-select ng-show=\"hasSampleTypeChildren\" ng-model=\"sampleType.second\" placeholder=\"Category 2\" ng-model-options=\"{ trackBy: \'$value._links.self.href\' }\"><md-option ng-click=\"onChangeSampleType(sampleType)\" ng-value=\"sampleType\" ng-repeat=\"sampleType in sampleTypesSecond\">{{ sampleType.name }}</md-option></md-select><!-- Just show this div after the sampleType is selected --><div ng-show=\"isSampleTypeSelected\"><div layout=\"row\"><md-input-container ng-show=\"isSampleTypeCountable\"><label>Aliquots</label><input ng-required=\"isSampleTypeCountable\" type=\"number\" min=\"0\" ng-model=\"sample.aliquots\"></md-input-container><md-checkbox ng-model=\"sample.containAliquots\" ng-hide=\"isSampleTypeCountable\">Aliquots</md-checkbox><md-input-container><label>Code</label><input type=\"text\" ng-model=\"sample.code\"></md-input-container></div><md-switch ng-model=\"sample.blocked\" ng-true-value=\"false\" ng-false-value=\"true\"><span ng-show=\"sample.blocked\">Not available for requesting</span> <span ng-show=\"!sample.blocked\">Available for requesting</span></md-switch></div>");
}]);
'use strict';

(function () {
    'use strict';

    angular.module('braininstituteApp').run(function (StateSetup, CacheSetup, $rootScope, Menu) {
        StateSetup.setup(); //setup UI router state

        CacheSetup.setup(); //setup http cache factory

        //app wide toggle for main app nave
        $rootScope.toggleAppSideNav = Menu.toggleSideNav;

        //attach nav bar to security module
        $rootScope.securityToggleAppSideNav = Menu.toggleSideNav;
    });
})();
'use strict';

(function () {
    'use strict';

    angular.module('braininstituteApp').config(routeConfig);

    function routeConfig($stateProvider, $urlRouterProvider) {
        $urlRouterProvider.otherwise('/');
        $stateProvider.state('site', {
            abstract: true,
            views: {
                'navbar@': {
                    templateUrl: 'app/components/navbar/navbar.html',
                    controller: 'NavbarController'
                }
            },
            resolve: {
                authorize: function authorize(Auth, Menu, $rootScope, $q) {

                    //do not check if the user is navigating to login page
                    if ($rootScope.toState.parent === 'account' && ($rootScope.toState.name === 'login' || $rootScope.toState.name === 'register')) {
                        return $q.resolve(Menu.createPages());
                    }

                    return Auth.authorize().then(function () {
                        Menu.createPages();
                    });
                },
                translatePartialLoader: function translatePartialLoader($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('menu');
                    $translatePartialLoader.addPart('security.menu');
                    return $translate.refresh();
                }
            }
        });
    }
})();
'use strict';

(function () {
    'use strict';

    angular.module('braininstituteApp').constant('_', window._); //add lodash
})();
'use strict';

(function () {
    'use strict';

    angular.module('braininstituteApp').config(configLogging).config(configCompilation);

    /**
     * Disable debug level messages in Prod.
     */
    function configLogging($logProvider, ENV) {
        if (ENV === 'prod') {
            $logProvider.debugEnabled(false);
        }
    }

    /**
     * Disable various debug runtime information in the compiler such as adding binding
     * information and a reference to the current scope on to DOM elements, in Prod.
     */
    function configCompilation($compileProvider, ENV) {
        if (ENV === 'prod') {
            $compileProvider.debugInfoEnabled(false);
        }
    }
})();
'use strict';

angular.module('braininstituteApp').controller('AppController', function ($scope, $state) {
    $scope.getCurrentStateName = function () {
        return $state.current.name;
    };
});
//# sourceMappingURL=app.js.map
